(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy', 'kotlinx-serialization-kotlinx-serialization-json-js-legacy', 'kotlinx-serialization-kotlinx-serialization-core-js-legacy', 'kvision-kvision-state-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-json-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-core-js-legacy'), require('kvision-kvision-state-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-tabulator-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-tabulator-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-tabulator-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-tabulator-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-tabulator-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' is loaded prior to 'kvision-kvision-tabulator-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-tabulator-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' is loaded prior to 'kvision-kvision-tabulator-js-legacy'.");
    }if (typeof this['kvision-kvision-state-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-tabulator-js-legacy'. Its dependency 'kvision-kvision-state-js-legacy' was not found. Please, check whether 'kvision-kvision-state-js-legacy' is loaded prior to 'kvision-kvision-tabulator-js-legacy'.");
    }root['kvision-kvision-tabulator-js-legacy'] = factory(typeof this['kvision-kvision-tabulator-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-tabulator-js-legacy'], kotlin, this['kvision-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'], this['kvision-kvision-state-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy, $module$kvision_kvision_state_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var Unit = Kotlin.kotlin.Unit;
  var throwCCE = Kotlin.throwCCE;
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  var equals = Kotlin.equals;
  var ContainerType = $module$kvision_js_legacy.io.kvision.panel.ContainerType;
  var Root_init = $module$kvision_js_legacy.io.kvision.panel.Root_init_39w7fw$;
  var FormControl = $module$kvision_js_legacy.io.kvision.form.FormControl;
  var FormInput = $module$kvision_js_legacy.io.kvision.form.FormInput;
  var Object_init = Object;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var Widget = $module$kvision_js_legacy.io.kvision.core.Widget;
  var getCallableRef = Kotlin.getCallableRef;
  var createInstance = $module$kvision_js_legacy.io.kvision.utils.createInstance_aevmdv$;
  var flatten = Kotlin.kotlin.collections.flatten_u0ad8z$;
  var plus = Kotlin.kotlin.collections.plus_mydzjv$;
  var Throwable = Error;
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  var toList = Kotlin.kotlin.collections.toList_us0mfu$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var MutableList = Kotlin.kotlin.collections.MutableList;
  var syncWithList = $module$kvision_js_legacy.io.kvision.utils.syncWithList_7f5kvw$;
  var i18n = $module$kvision_js_legacy.io.kvision.i18n;
  var List = Kotlin.kotlin.collections.List;
  var numberToInt = Kotlin.numberToInt;
  var asList = Kotlin.kotlin.collections.asList_us0mfu$;
  var toKotlinObj = $module$kvision_js_legacy.io.kvision.utils.toKotlinObj_t5tk2r$;
  var toPlainObj = $module$kvision_js_legacy.io.kvision.utils.toPlainObj_za3rmp$;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var wrapFunction = Kotlin.wrapFunction;
  var utils = $module$kvision_js_legacy.io.kvision.utils;
  var Json = $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy.kotlinx.serialization.json.Json_x26noe$;
  var getKClass = Kotlin.getKClass;
  var types = $module$kvision_js_legacy.io.kvision.types;
  var overwriteWith = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.overwriteWith_nz2fmb$;
  var ObservableList = $module$kvision_kvision_state_js_legacy.io.kvision.state.ObservableList;
  var deepMerge = $module$kvision_js_legacy.io.kvision.utils.deepMerge_wn2jw4$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var Widget$Widget$RefreshDelegateProvider_init = $module$kvision_js_legacy.io.kvision.core.Widget.RefreshDelegateProvider;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var SerializersModuleBuilder_init = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.SerializersModuleBuilder;
  Formatter.prototype = Object.create(Enum.prototype);
  Formatter.prototype.constructor = Formatter;
  Layout.prototype = Object.create(Enum.prototype);
  Layout.prototype.constructor = Layout;
  TableType.prototype = Object.create(Enum.prototype);
  TableType.prototype.constructor = TableType;
  RowRangeLookup.prototype = Object.create(Enum.prototype);
  RowRangeLookup.prototype.constructor = RowRangeLookup;
  Tabulator.prototype = Object.create(Widget.prototype);
  Tabulator.prototype.constructor = Tabulator;
  function TabulatorModule() {
    TabulatorModule_instance = this;
    this.tabulator_0 = require('tabulator-tables').TabulatorFull;
  }
  TabulatorModule.prototype.getConstructor = function () {
    return this.tabulator_0;
  };
  TabulatorModule.prototype.initialize = function () {
    require('tabulator-tables/dist/css/tabulator_bootstrap5.min.css');
  };
  TabulatorModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'TabulatorModule', interfaces: [ModuleInitializer]};
  var TabulatorModule_instance = null;
  function TabulatorModule_getInstance() {
    if (TabulatorModule_instance === null) {
      new TabulatorModule();
    }return TabulatorModule_instance;
  }
  var TooltipGenerationMode$LOAD_instance;
  var TooltipGenerationMode$HOVER_instance;
  var Align$LEFT_instance;
  var Align$CENTER_instance;
  var Align$RIGHT_instance;
  var VAlign$TOP_instance;
  var VAlign$MIDDLE_instance;
  var VAlign$BOTTOM_instance;
  var Sorter$STRING_instance;
  var Sorter$NUMBER_instance;
  var Sorter$ALPHANUM_instance;
  var Sorter$BOOLEAN_instance;
  var Sorter$EXISTS_instance;
  var Sorter$DATE_instance;
  var Sorter$TIME_instance;
  var Sorter$DATETIME_instance;
  var Sorter$ARRAY_instance;
  function Formatter(name, ordinal, formatter) {
    Enum.call(this);
    this.formatter_8be2vx$ = formatter;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Formatter_initFields() {
    Formatter_initFields = function () {
    };
    Formatter$PLAINTEXT_instance = new Formatter('PLAINTEXT', 0, 'plaintext');
    Formatter$TEXTAREA_instance = new Formatter('TEXTAREA', 1, 'textarea');
    Formatter$HTML_instance = new Formatter('HTML', 2, 'html');
    Formatter$MONEY_instance = new Formatter('MONEY', 3, 'money');
    Formatter$IMAGE_instance = new Formatter('IMAGE', 4, 'image');
    Formatter$LINK_instance = new Formatter('LINK', 5, 'link');
    Formatter$DATETIME_instance = new Formatter('DATETIME', 6, 'datetime');
    Formatter$DATETIMEDIFF_instance = new Formatter('DATETIMEDIFF', 7, 'datetimediff');
    Formatter$TICKCROSS_instance = new Formatter('TICKCROSS', 8, 'tickCross');
    Formatter$COLOR_instance = new Formatter('COLOR', 9, 'color');
    Formatter$STAR_instance = new Formatter('STAR', 10, 'star');
    Formatter$TRAFFIC_instance = new Formatter('TRAFFIC', 11, 'traffic');
    Formatter$PROGRESS_instance = new Formatter('PROGRESS', 12, 'progress');
    Formatter$LOOKUP_instance = new Formatter('LOOKUP', 13, 'lookup');
    Formatter$BUTTONTICK_instance = new Formatter('BUTTONTICK', 14, 'buttonTick');
    Formatter$BUTTONCROSS_instance = new Formatter('BUTTONCROSS', 15, 'buttonCross');
    Formatter$ROWNUM_instance = new Formatter('ROWNUM', 16, 'rownum');
    Formatter$HANDLE_instance = new Formatter('HANDLE', 17, 'handle');
    Formatter$ROWSELECTION_instance = new Formatter('ROWSELECTION', 18, 'rowSelection');
    Formatter$RESPONSIVECOLLAPSE_instance = new Formatter('RESPONSIVECOLLAPSE', 19, 'responsiveCollapse');
  }
  var Formatter$PLAINTEXT_instance;
  function Formatter$PLAINTEXT_getInstance() {
    Formatter_initFields();
    return Formatter$PLAINTEXT_instance;
  }
  var Formatter$TEXTAREA_instance;
  function Formatter$TEXTAREA_getInstance() {
    Formatter_initFields();
    return Formatter$TEXTAREA_instance;
  }
  var Formatter$HTML_instance;
  function Formatter$HTML_getInstance() {
    Formatter_initFields();
    return Formatter$HTML_instance;
  }
  var Formatter$MONEY_instance;
  function Formatter$MONEY_getInstance() {
    Formatter_initFields();
    return Formatter$MONEY_instance;
  }
  var Formatter$IMAGE_instance;
  function Formatter$IMAGE_getInstance() {
    Formatter_initFields();
    return Formatter$IMAGE_instance;
  }
  var Formatter$LINK_instance;
  function Formatter$LINK_getInstance() {
    Formatter_initFields();
    return Formatter$LINK_instance;
  }
  var Formatter$DATETIME_instance;
  function Formatter$DATETIME_getInstance() {
    Formatter_initFields();
    return Formatter$DATETIME_instance;
  }
  var Formatter$DATETIMEDIFF_instance;
  function Formatter$DATETIMEDIFF_getInstance() {
    Formatter_initFields();
    return Formatter$DATETIMEDIFF_instance;
  }
  var Formatter$TICKCROSS_instance;
  function Formatter$TICKCROSS_getInstance() {
    Formatter_initFields();
    return Formatter$TICKCROSS_instance;
  }
  var Formatter$COLOR_instance;
  function Formatter$COLOR_getInstance() {
    Formatter_initFields();
    return Formatter$COLOR_instance;
  }
  var Formatter$STAR_instance;
  function Formatter$STAR_getInstance() {
    Formatter_initFields();
    return Formatter$STAR_instance;
  }
  var Formatter$TRAFFIC_instance;
  function Formatter$TRAFFIC_getInstance() {
    Formatter_initFields();
    return Formatter$TRAFFIC_instance;
  }
  var Formatter$PROGRESS_instance;
  function Formatter$PROGRESS_getInstance() {
    Formatter_initFields();
    return Formatter$PROGRESS_instance;
  }
  var Formatter$LOOKUP_instance;
  function Formatter$LOOKUP_getInstance() {
    Formatter_initFields();
    return Formatter$LOOKUP_instance;
  }
  var Formatter$BUTTONTICK_instance;
  function Formatter$BUTTONTICK_getInstance() {
    Formatter_initFields();
    return Formatter$BUTTONTICK_instance;
  }
  var Formatter$BUTTONCROSS_instance;
  function Formatter$BUTTONCROSS_getInstance() {
    Formatter_initFields();
    return Formatter$BUTTONCROSS_instance;
  }
  var Formatter$ROWNUM_instance;
  function Formatter$ROWNUM_getInstance() {
    Formatter_initFields();
    return Formatter$ROWNUM_instance;
  }
  var Formatter$HANDLE_instance;
  function Formatter$HANDLE_getInstance() {
    Formatter_initFields();
    return Formatter$HANDLE_instance;
  }
  var Formatter$ROWSELECTION_instance;
  function Formatter$ROWSELECTION_getInstance() {
    Formatter_initFields();
    return Formatter$ROWSELECTION_instance;
  }
  var Formatter$RESPONSIVECOLLAPSE_instance;
  function Formatter$RESPONSIVECOLLAPSE_getInstance() {
    Formatter_initFields();
    return Formatter$RESPONSIVECOLLAPSE_instance;
  }
  Formatter.$metadata$ = {kind: Kind_CLASS, simpleName: 'Formatter', interfaces: [Enum]};
  function Formatter$values() {
    return [Formatter$PLAINTEXT_getInstance(), Formatter$TEXTAREA_getInstance(), Formatter$HTML_getInstance(), Formatter$MONEY_getInstance(), Formatter$IMAGE_getInstance(), Formatter$LINK_getInstance(), Formatter$DATETIME_getInstance(), Formatter$DATETIMEDIFF_getInstance(), Formatter$TICKCROSS_getInstance(), Formatter$COLOR_getInstance(), Formatter$STAR_getInstance(), Formatter$TRAFFIC_getInstance(), Formatter$PROGRESS_getInstance(), Formatter$LOOKUP_getInstance(), Formatter$BUTTONTICK_getInstance(), Formatter$BUTTONCROSS_getInstance(), Formatter$ROWNUM_getInstance(), Formatter$HANDLE_getInstance(), Formatter$ROWSELECTION_getInstance(), Formatter$RESPONSIVECOLLAPSE_getInstance()];
  }
  Formatter.values = Formatter$values;
  function Formatter$valueOf(name) {
    switch (name) {
      case 'PLAINTEXT':
        return Formatter$PLAINTEXT_getInstance();
      case 'TEXTAREA':
        return Formatter$TEXTAREA_getInstance();
      case 'HTML':
        return Formatter$HTML_getInstance();
      case 'MONEY':
        return Formatter$MONEY_getInstance();
      case 'IMAGE':
        return Formatter$IMAGE_getInstance();
      case 'LINK':
        return Formatter$LINK_getInstance();
      case 'DATETIME':
        return Formatter$DATETIME_getInstance();
      case 'DATETIMEDIFF':
        return Formatter$DATETIMEDIFF_getInstance();
      case 'TICKCROSS':
        return Formatter$TICKCROSS_getInstance();
      case 'COLOR':
        return Formatter$COLOR_getInstance();
      case 'STAR':
        return Formatter$STAR_getInstance();
      case 'TRAFFIC':
        return Formatter$TRAFFIC_getInstance();
      case 'PROGRESS':
        return Formatter$PROGRESS_getInstance();
      case 'LOOKUP':
        return Formatter$LOOKUP_getInstance();
      case 'BUTTONTICK':
        return Formatter$BUTTONTICK_getInstance();
      case 'BUTTONCROSS':
        return Formatter$BUTTONCROSS_getInstance();
      case 'ROWNUM':
        return Formatter$ROWNUM_getInstance();
      case 'HANDLE':
        return Formatter$HANDLE_getInstance();
      case 'ROWSELECTION':
        return Formatter$ROWSELECTION_getInstance();
      case 'RESPONSIVECOLLAPSE':
        return Formatter$RESPONSIVECOLLAPSE_getInstance();
      default:throwISE('No enum constant io.kvision.tabulator.Formatter.' + name);
    }
  }
  Formatter.valueOf_61zpoe$ = Formatter$valueOf;
  var Editor$INPUT_instance;
  var Editor$TEXTAREA_instance;
  var Editor$NUMBER_instance;
  var Editor$RANGE_instance;
  var Editor$TICK_instance;
  var Editor$STAR_instance;
  var Editor$SELECT_instance;
  var Editor$LIST_instance;
  var Editor$AUTOCOMPLETE_instance;
  var Editor$DATE_instance;
  var Editor$TIME_instance;
  var Editor$DATETIME_instance;
  var Validator$REQUIRED_instance;
  var Validator$UNIQUE_instance;
  var Validator$INTEGER_instance;
  var Validator$FLOAT_instance;
  var Validator$NUMERIC_instance;
  var Validator$STRING_instance;
  var Validator$MIN_instance;
  var Validator$MAX_instance;
  var Validator$MINLENGTH_instance;
  var Validator$MAXLENGTH_instance;
  var Validator$IN_instance;
  var Validator$REGEX_instance;
  var Calc$AVG_instance;
  var Calc$MAX_instance;
  var Calc$MIN_instance;
  var Calc$SUM_instance;
  var Calc$CONCAT_instance;
  var Calc$COUNT_instance;
  var SortingDir$ASC_instance;
  var SortingDir$DESC_instance;
  var Filter$EQUAL_instance;
  var Filter$NOTEQUAL_instance;
  var Filter$LIKE_instance;
  var Filter$LESS_instance;
  var Filter$LESSEQ_instance;
  var Filter$GREATER_instance;
  var Filter$GREATEREQ_instance;
  var Filter$IN_instance;
  var Filter$REGEX_instance;
  function Layout(name, ordinal, layout) {
    Enum.call(this);
    this.layout_8be2vx$ = layout;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Layout_initFields() {
    Layout_initFields = function () {
    };
    Layout$FITDATA_instance = new Layout('FITDATA', 0, 'fitData');
    Layout$FITDATAFILL_instance = new Layout('FITDATAFILL', 1, 'fitDataFill');
    Layout$FITCOLUMNS_instance = new Layout('FITCOLUMNS', 2, 'fitColumns');
    Layout$FITDATASTRETCH_instance = new Layout('FITDATASTRETCH', 3, 'fitDataStretch');
    Layout$FITDATATABLE_instance = new Layout('FITDATATABLE', 4, 'fitDataTable');
  }
  var Layout$FITDATA_instance;
  function Layout$FITDATA_getInstance() {
    Layout_initFields();
    return Layout$FITDATA_instance;
  }
  var Layout$FITDATAFILL_instance;
  function Layout$FITDATAFILL_getInstance() {
    Layout_initFields();
    return Layout$FITDATAFILL_instance;
  }
  var Layout$FITCOLUMNS_instance;
  function Layout$FITCOLUMNS_getInstance() {
    Layout_initFields();
    return Layout$FITCOLUMNS_instance;
  }
  var Layout$FITDATASTRETCH_instance;
  function Layout$FITDATASTRETCH_getInstance() {
    Layout_initFields();
    return Layout$FITDATASTRETCH_instance;
  }
  var Layout$FITDATATABLE_instance;
  function Layout$FITDATATABLE_getInstance() {
    Layout_initFields();
    return Layout$FITDATATABLE_instance;
  }
  Layout.$metadata$ = {kind: Kind_CLASS, simpleName: 'Layout', interfaces: [Enum]};
  function Layout$values() {
    return [Layout$FITDATA_getInstance(), Layout$FITDATAFILL_getInstance(), Layout$FITCOLUMNS_getInstance(), Layout$FITDATASTRETCH_getInstance(), Layout$FITDATATABLE_getInstance()];
  }
  Layout.values = Layout$values;
  function Layout$valueOf(name) {
    switch (name) {
      case 'FITDATA':
        return Layout$FITDATA_getInstance();
      case 'FITDATAFILL':
        return Layout$FITDATAFILL_getInstance();
      case 'FITCOLUMNS':
        return Layout$FITCOLUMNS_getInstance();
      case 'FITDATASTRETCH':
        return Layout$FITDATASTRETCH_getInstance();
      case 'FITDATATABLE':
        return Layout$FITDATATABLE_getInstance();
      default:throwISE('No enum constant io.kvision.tabulator.Layout.' + name);
    }
  }
  Layout.valueOf_61zpoe$ = Layout$valueOf;
  var ResponsiveLayout$HIDE_instance;
  var ResponsiveLayout$COLLAPSE_instance;
  var ColumnPosition$MIDDLE_instance;
  var ColumnPosition$LEFT_instance;
  var ColumnPosition$RIGHT_instance;
  var RowPosition$BOTTOM_instance;
  var RowPosition$TOP_instance;
  var RowPosition$CENTER_instance;
  var RowPosition$NEAREST_instance;
  var RowPos$BOTTOM_instance;
  var RowPos$TOP_instance;
  var RangeMode$CLICK_instance;
  var ProgressiveMode$LOAD_instance;
  var ProgressiveMode$SCROLL_instance;
  var PaginationMode$LOCAL_instance;
  var PaginationMode$REMOTE_instance;
  var SortMode$LOCAL_instance;
  var SortMode$REMOTE_instance;
  var FilterMode$LOCAL_instance;
  var FilterMode$REMOTE_instance;
  var AddRowMode$TABLE_instance;
  var AddRowMode$PAGE_instance;
  var TextDirection$AUTO_instance;
  var TextDirection$LTR_instance;
  var TextDirection$RTL_instance;
  var RenderType$BASIC_instance;
  var RenderType$VIRTUAL_instance;
  var ImportFormat$JSON_instance;
  var ImportFormat$CSV_instance;
  var ImportFormat$ARRAY_instance;
  var ImportReader$TEXT_instance;
  var ImportReader$BUFFER_instance;
  var ImportReader$BINARY_instance;
  var ImportReader$URL_instance;
  var HeaderSortClickElement$HEADER_instance;
  var HeaderSortClickElement$ICON_instance;
  function toJs($receiver) {
    var tmp$;
    var $receiver_0 = new Object_init();
    if ($receiver.columnGroups != null)
      $receiver_0.columnGroups = $receiver.columnGroups;
    if ($receiver.rowGroups != null)
      $receiver_0.rowGroups = $receiver.rowGroups;
    if ($receiver.columnCalcs != null)
      $receiver_0.columnCalcs = $receiver.columnCalcs;
    return Kotlin.isType(tmp$ = $receiver_0, Object) ? tmp$ : throwCCE();
  }
  function ColumnDefinition(title, field, columns, visible, align, width, minWidth, widthGrow, widthShrink, resizable, frozen, responsive, tooltip, cssClass, rowHandle, hideInHtml, sorter, sorterFunction, sorterParams, formatter, formatterFunction, formatterComponentFunction, formatterParams, variableHeight, editable, editor, editorFunction, editorComponentFunction, editorParams, validator, validatorFunction, validatorParams, download, downloadTitle, topCalc, topCalcParams, topCalcFormatter, topCalcFormatterParams, bottomCalc, bottomCalcParams, bottomCalcFormatter, bottomCalcFormatterParams, headerSort, headerSortStartingDir, headerSortTristate, headerClick, headerDblClick, headerContext, headerTap, headerDblTap, headerTapHold, headerTooltip, headerVertical, editableTitle, titleFormatter, titleFormatterParams, headerFilter, headerFilterParams, headerFilterCustom, headerFilterPlaceholder, headerFilterEmptyCheck, headerFilterFunc, headerFilterFuncCustom, headerFilterFuncParams, headerFilterLiveFilter, htmlOutput, print, formatterPrint, formatterPrintParams, cellClick, cellDblClick, cellContext, cellTap, cellDblTap, cellTapHold, cellMouseEnter, cellMouseLeave, cellMouseOver, cellMouseOut, cellMouseMove, cellEditing, cellEdited, cellEditCancelled, headerMenu, headerContextMenu, contextMenu, hozAlign, vertAlign, clickMenu, headerHozAlign, accessor, accessorParams, maxWidth, mutatorData, mutatorDataParams, mutatorEdit, mutatorEditParams, mutatorClipboard, mutatorClipboardParams, mutator, mutatorParams, maxInitialWidth, cellPopup, headerPopup, headerPopupIcon, headerContextPopup, clickPopup, contextPopup, headerMenuIcon, headerWordWrap, dblClickPopup, headerClickPopup, headerDblClickPopup, headerClickMenu, headerDblClickMenu, dblClickMenu) {
    if (field === void 0)
      field = null;
    if (columns === void 0)
      columns = null;
    if (visible === void 0)
      visible = null;
    if (align === void 0)
      align = null;
    if (width === void 0)
      width = null;
    if (minWidth === void 0)
      minWidth = null;
    if (widthGrow === void 0)
      widthGrow = null;
    if (widthShrink === void 0)
      widthShrink = null;
    if (resizable === void 0)
      resizable = null;
    if (frozen === void 0)
      frozen = null;
    if (responsive === void 0)
      responsive = null;
    if (tooltip === void 0)
      tooltip = null;
    if (cssClass === void 0)
      cssClass = null;
    if (rowHandle === void 0)
      rowHandle = null;
    if (hideInHtml === void 0)
      hideInHtml = null;
    if (sorter === void 0)
      sorter = null;
    if (sorterFunction === void 0)
      sorterFunction = null;
    if (sorterParams === void 0)
      sorterParams = null;
    if (formatter === void 0)
      formatter = null;
    if (formatterFunction === void 0)
      formatterFunction = null;
    if (formatterComponentFunction === void 0)
      formatterComponentFunction = null;
    if (formatterParams === void 0)
      formatterParams = null;
    if (variableHeight === void 0)
      variableHeight = null;
    if (editable === void 0)
      editable = null;
    if (editor === void 0)
      editor = null;
    if (editorFunction === void 0)
      editorFunction = null;
    if (editorComponentFunction === void 0)
      editorComponentFunction = null;
    if (editorParams === void 0)
      editorParams = null;
    if (validator === void 0)
      validator = null;
    if (validatorFunction === void 0)
      validatorFunction = null;
    if (validatorParams === void 0)
      validatorParams = null;
    if (download === void 0)
      download = null;
    if (downloadTitle === void 0)
      downloadTitle = null;
    if (topCalc === void 0)
      topCalc = null;
    if (topCalcParams === void 0)
      topCalcParams = null;
    if (topCalcFormatter === void 0)
      topCalcFormatter = null;
    if (topCalcFormatterParams === void 0)
      topCalcFormatterParams = null;
    if (bottomCalc === void 0)
      bottomCalc = null;
    if (bottomCalcParams === void 0)
      bottomCalcParams = null;
    if (bottomCalcFormatter === void 0)
      bottomCalcFormatter = null;
    if (bottomCalcFormatterParams === void 0)
      bottomCalcFormatterParams = null;
    if (headerSort === void 0)
      headerSort = null;
    if (headerSortStartingDir === void 0)
      headerSortStartingDir = null;
    if (headerSortTristate === void 0)
      headerSortTristate = null;
    if (headerClick === void 0)
      headerClick = null;
    if (headerDblClick === void 0)
      headerDblClick = null;
    if (headerContext === void 0)
      headerContext = null;
    if (headerTap === void 0)
      headerTap = null;
    if (headerDblTap === void 0)
      headerDblTap = null;
    if (headerTapHold === void 0)
      headerTapHold = null;
    if (headerTooltip === void 0)
      headerTooltip = null;
    if (headerVertical === void 0)
      headerVertical = null;
    if (editableTitle === void 0)
      editableTitle = null;
    if (titleFormatter === void 0)
      titleFormatter = null;
    if (titleFormatterParams === void 0)
      titleFormatterParams = null;
    if (headerFilter === void 0)
      headerFilter = null;
    if (headerFilterParams === void 0)
      headerFilterParams = null;
    if (headerFilterCustom === void 0)
      headerFilterCustom = null;
    if (headerFilterPlaceholder === void 0)
      headerFilterPlaceholder = null;
    if (headerFilterEmptyCheck === void 0)
      headerFilterEmptyCheck = null;
    if (headerFilterFunc === void 0)
      headerFilterFunc = null;
    if (headerFilterFuncCustom === void 0)
      headerFilterFuncCustom = null;
    if (headerFilterFuncParams === void 0)
      headerFilterFuncParams = null;
    if (headerFilterLiveFilter === void 0)
      headerFilterLiveFilter = null;
    if (htmlOutput === void 0)
      htmlOutput = null;
    if (print === void 0)
      print = null;
    if (formatterPrint === void 0)
      formatterPrint = null;
    if (formatterPrintParams === void 0)
      formatterPrintParams = null;
    if (cellClick === void 0)
      cellClick = null;
    if (cellDblClick === void 0)
      cellDblClick = null;
    if (cellContext === void 0)
      cellContext = null;
    if (cellTap === void 0)
      cellTap = null;
    if (cellDblTap === void 0)
      cellDblTap = null;
    if (cellTapHold === void 0)
      cellTapHold = null;
    if (cellMouseEnter === void 0)
      cellMouseEnter = null;
    if (cellMouseLeave === void 0)
      cellMouseLeave = null;
    if (cellMouseOver === void 0)
      cellMouseOver = null;
    if (cellMouseOut === void 0)
      cellMouseOut = null;
    if (cellMouseMove === void 0)
      cellMouseMove = null;
    if (cellEditing === void 0)
      cellEditing = null;
    if (cellEdited === void 0)
      cellEdited = null;
    if (cellEditCancelled === void 0)
      cellEditCancelled = null;
    if (headerMenu === void 0)
      headerMenu = null;
    if (headerContextMenu === void 0)
      headerContextMenu = null;
    if (contextMenu === void 0)
      contextMenu = null;
    if (hozAlign === void 0)
      hozAlign = null;
    if (vertAlign === void 0)
      vertAlign = null;
    if (clickMenu === void 0)
      clickMenu = null;
    if (headerHozAlign === void 0)
      headerHozAlign = null;
    if (accessor === void 0)
      accessor = null;
    if (accessorParams === void 0)
      accessorParams = null;
    if (maxWidth === void 0)
      maxWidth = null;
    if (mutatorData === void 0)
      mutatorData = null;
    if (mutatorDataParams === void 0)
      mutatorDataParams = null;
    if (mutatorEdit === void 0)
      mutatorEdit = null;
    if (mutatorEditParams === void 0)
      mutatorEditParams = null;
    if (mutatorClipboard === void 0)
      mutatorClipboard = null;
    if (mutatorClipboardParams === void 0)
      mutatorClipboardParams = null;
    if (mutator === void 0)
      mutator = null;
    if (mutatorParams === void 0)
      mutatorParams = null;
    if (maxInitialWidth === void 0)
      maxInitialWidth = null;
    if (cellPopup === void 0)
      cellPopup = null;
    if (headerPopup === void 0)
      headerPopup = null;
    if (headerPopupIcon === void 0)
      headerPopupIcon = null;
    if (headerContextPopup === void 0)
      headerContextPopup = null;
    if (clickPopup === void 0)
      clickPopup = null;
    if (contextPopup === void 0)
      contextPopup = null;
    if (headerMenuIcon === void 0)
      headerMenuIcon = null;
    if (headerWordWrap === void 0)
      headerWordWrap = null;
    if (dblClickPopup === void 0)
      dblClickPopup = null;
    if (headerClickPopup === void 0)
      headerClickPopup = null;
    if (headerDblClickPopup === void 0)
      headerDblClickPopup = null;
    if (headerClickMenu === void 0)
      headerClickMenu = null;
    if (headerDblClickMenu === void 0)
      headerDblClickMenu = null;
    if (dblClickMenu === void 0)
      dblClickMenu = null;
    this.title = title;
    this.field = field;
    this.columns = columns;
    this.visible = visible;
    this.align = align;
    this.width = width;
    this.minWidth = minWidth;
    this.widthGrow = widthGrow;
    this.widthShrink = widthShrink;
    this.resizable = resizable;
    this.frozen = frozen;
    this.responsive = responsive;
    this.tooltip = tooltip;
    this.cssClass = cssClass;
    this.rowHandle = rowHandle;
    this.hideInHtml = hideInHtml;
    this.sorter = sorter;
    this.sorterFunction = sorterFunction;
    this.sorterParams = sorterParams;
    this.formatter = formatter;
    this.formatterFunction = formatterFunction;
    this.formatterComponentFunction = formatterComponentFunction;
    this.formatterParams = formatterParams;
    this.variableHeight = variableHeight;
    this.editable = editable;
    this.editor = editor;
    this.editorFunction = editorFunction;
    this.editorComponentFunction = editorComponentFunction;
    this.editorParams = editorParams;
    this.validator = validator;
    this.validatorFunction = validatorFunction;
    this.validatorParams = validatorParams;
    this.download = download;
    this.downloadTitle = downloadTitle;
    this.topCalc = topCalc;
    this.topCalcParams = topCalcParams;
    this.topCalcFormatter = topCalcFormatter;
    this.topCalcFormatterParams = topCalcFormatterParams;
    this.bottomCalc = bottomCalc;
    this.bottomCalcParams = bottomCalcParams;
    this.bottomCalcFormatter = bottomCalcFormatter;
    this.bottomCalcFormatterParams = bottomCalcFormatterParams;
    this.headerSort = headerSort;
    this.headerSortStartingDir = headerSortStartingDir;
    this.headerSortTristate = headerSortTristate;
    this.headerClick = headerClick;
    this.headerDblClick = headerDblClick;
    this.headerContext = headerContext;
    this.headerTap = headerTap;
    this.headerDblTap = headerDblTap;
    this.headerTapHold = headerTapHold;
    this.headerTooltip = headerTooltip;
    this.headerVertical = headerVertical;
    this.editableTitle = editableTitle;
    this.titleFormatter = titleFormatter;
    this.titleFormatterParams = titleFormatterParams;
    this.headerFilter = headerFilter;
    this.headerFilterParams = headerFilterParams;
    this.headerFilterCustom = headerFilterCustom;
    this.headerFilterPlaceholder = headerFilterPlaceholder;
    this.headerFilterEmptyCheck = headerFilterEmptyCheck;
    this.headerFilterFunc = headerFilterFunc;
    this.headerFilterFuncCustom = headerFilterFuncCustom;
    this.headerFilterFuncParams = headerFilterFuncParams;
    this.headerFilterLiveFilter = headerFilterLiveFilter;
    this.htmlOutput = htmlOutput;
    this.print = print;
    this.formatterPrint = formatterPrint;
    this.formatterPrintParams = formatterPrintParams;
    this.cellClick = cellClick;
    this.cellDblClick = cellDblClick;
    this.cellContext = cellContext;
    this.cellTap = cellTap;
    this.cellDblTap = cellDblTap;
    this.cellTapHold = cellTapHold;
    this.cellMouseEnter = cellMouseEnter;
    this.cellMouseLeave = cellMouseLeave;
    this.cellMouseOver = cellMouseOver;
    this.cellMouseOut = cellMouseOut;
    this.cellMouseMove = cellMouseMove;
    this.cellEditing = cellEditing;
    this.cellEdited = cellEdited;
    this.cellEditCancelled = cellEditCancelled;
    this.headerMenu = headerMenu;
    this.headerContextMenu = headerContextMenu;
    this.contextMenu = contextMenu;
    this.hozAlign = hozAlign;
    this.vertAlign = vertAlign;
    this.clickMenu = clickMenu;
    this.headerHozAlign = headerHozAlign;
    this.accessor = accessor;
    this.accessorParams = accessorParams;
    this.maxWidth = maxWidth;
    this.mutatorData = mutatorData;
    this.mutatorDataParams = mutatorDataParams;
    this.mutatorEdit = mutatorEdit;
    this.mutatorEditParams = mutatorEditParams;
    this.mutatorClipboard = mutatorClipboard;
    this.mutatorClipboardParams = mutatorClipboardParams;
    this.mutator = mutator;
    this.mutatorParams = mutatorParams;
    this.maxInitialWidth = maxInitialWidth;
    this.cellPopup = cellPopup;
    this.headerPopup = headerPopup;
    this.headerPopupIcon = headerPopupIcon;
    this.headerContextPopup = headerContextPopup;
    this.clickPopup = clickPopup;
    this.contextPopup = contextPopup;
    this.headerMenuIcon = headerMenuIcon;
    this.headerWordWrap = headerWordWrap;
    this.dblClickPopup = dblClickPopup;
    this.headerClickPopup = headerClickPopup;
    this.headerDblClickPopup = headerDblClickPopup;
    this.headerClickMenu = headerClickMenu;
    this.headerDblClickMenu = headerDblClickMenu;
    this.dblClickMenu = dblClickMenu;
  }
  ColumnDefinition.$metadata$ = {kind: Kind_CLASS, simpleName: 'ColumnDefinition', interfaces: []};
  ColumnDefinition.prototype.component1 = function () {
    return this.title;
  };
  ColumnDefinition.prototype.component2 = function () {
    return this.field;
  };
  ColumnDefinition.prototype.component3 = function () {
    return this.columns;
  };
  ColumnDefinition.prototype.component4 = function () {
    return this.visible;
  };
  ColumnDefinition.prototype.component5 = function () {
    return this.align;
  };
  ColumnDefinition.prototype.component6 = function () {
    return this.width;
  };
  ColumnDefinition.prototype.component7 = function () {
    return this.minWidth;
  };
  ColumnDefinition.prototype.component8 = function () {
    return this.widthGrow;
  };
  ColumnDefinition.prototype.component9 = function () {
    return this.widthShrink;
  };
  ColumnDefinition.prototype.component10 = function () {
    return this.resizable;
  };
  ColumnDefinition.prototype.component11 = function () {
    return this.frozen;
  };
  ColumnDefinition.prototype.component12 = function () {
    return this.responsive;
  };
  ColumnDefinition.prototype.component13 = function () {
    return this.tooltip;
  };
  ColumnDefinition.prototype.component14 = function () {
    return this.cssClass;
  };
  ColumnDefinition.prototype.component15 = function () {
    return this.rowHandle;
  };
  ColumnDefinition.prototype.component16 = function () {
    return this.hideInHtml;
  };
  ColumnDefinition.prototype.component17 = function () {
    return this.sorter;
  };
  ColumnDefinition.prototype.component18 = function () {
    return this.sorterFunction;
  };
  ColumnDefinition.prototype.component19 = function () {
    return this.sorterParams;
  };
  ColumnDefinition.prototype.component20 = function () {
    return this.formatter;
  };
  ColumnDefinition.prototype.component21 = function () {
    return this.formatterFunction;
  };
  ColumnDefinition.prototype.component22 = function () {
    return this.formatterComponentFunction;
  };
  ColumnDefinition.prototype.component23 = function () {
    return this.formatterParams;
  };
  ColumnDefinition.prototype.component24 = function () {
    return this.variableHeight;
  };
  ColumnDefinition.prototype.component25 = function () {
    return this.editable;
  };
  ColumnDefinition.prototype.component26 = function () {
    return this.editor;
  };
  ColumnDefinition.prototype.component27 = function () {
    return this.editorFunction;
  };
  ColumnDefinition.prototype.component28 = function () {
    return this.editorComponentFunction;
  };
  ColumnDefinition.prototype.component29 = function () {
    return this.editorParams;
  };
  ColumnDefinition.prototype.component30 = function () {
    return this.validator;
  };
  ColumnDefinition.prototype.component31 = function () {
    return this.validatorFunction;
  };
  ColumnDefinition.prototype.component32 = function () {
    return this.validatorParams;
  };
  ColumnDefinition.prototype.component33 = function () {
    return this.download;
  };
  ColumnDefinition.prototype.component34 = function () {
    return this.downloadTitle;
  };
  ColumnDefinition.prototype.component35 = function () {
    return this.topCalc;
  };
  ColumnDefinition.prototype.component36 = function () {
    return this.topCalcParams;
  };
  ColumnDefinition.prototype.component37 = function () {
    return this.topCalcFormatter;
  };
  ColumnDefinition.prototype.component38 = function () {
    return this.topCalcFormatterParams;
  };
  ColumnDefinition.prototype.component39 = function () {
    return this.bottomCalc;
  };
  ColumnDefinition.prototype.component40 = function () {
    return this.bottomCalcParams;
  };
  ColumnDefinition.prototype.component41 = function () {
    return this.bottomCalcFormatter;
  };
  ColumnDefinition.prototype.component42 = function () {
    return this.bottomCalcFormatterParams;
  };
  ColumnDefinition.prototype.component43 = function () {
    return this.headerSort;
  };
  ColumnDefinition.prototype.component44 = function () {
    return this.headerSortStartingDir;
  };
  ColumnDefinition.prototype.component45 = function () {
    return this.headerSortTristate;
  };
  ColumnDefinition.prototype.component46 = function () {
    return this.headerClick;
  };
  ColumnDefinition.prototype.component47 = function () {
    return this.headerDblClick;
  };
  ColumnDefinition.prototype.component48 = function () {
    return this.headerContext;
  };
  ColumnDefinition.prototype.component49 = function () {
    return this.headerTap;
  };
  ColumnDefinition.prototype.component50 = function () {
    return this.headerDblTap;
  };
  ColumnDefinition.prototype.component51 = function () {
    return this.headerTapHold;
  };
  ColumnDefinition.prototype.component52 = function () {
    return this.headerTooltip;
  };
  ColumnDefinition.prototype.component53 = function () {
    return this.headerVertical;
  };
  ColumnDefinition.prototype.component54 = function () {
    return this.editableTitle;
  };
  ColumnDefinition.prototype.component55 = function () {
    return this.titleFormatter;
  };
  ColumnDefinition.prototype.component56 = function () {
    return this.titleFormatterParams;
  };
  ColumnDefinition.prototype.component57 = function () {
    return this.headerFilter;
  };
  ColumnDefinition.prototype.component58 = function () {
    return this.headerFilterParams;
  };
  ColumnDefinition.prototype.component59 = function () {
    return this.headerFilterCustom;
  };
  ColumnDefinition.prototype.component60 = function () {
    return this.headerFilterPlaceholder;
  };
  ColumnDefinition.prototype.component61 = function () {
    return this.headerFilterEmptyCheck;
  };
  ColumnDefinition.prototype.component62 = function () {
    return this.headerFilterFunc;
  };
  ColumnDefinition.prototype.component63 = function () {
    return this.headerFilterFuncCustom;
  };
  ColumnDefinition.prototype.component64 = function () {
    return this.headerFilterFuncParams;
  };
  ColumnDefinition.prototype.component65 = function () {
    return this.headerFilterLiveFilter;
  };
  ColumnDefinition.prototype.component66 = function () {
    return this.htmlOutput;
  };
  ColumnDefinition.prototype.component67 = function () {
    return this.print;
  };
  ColumnDefinition.prototype.component68 = function () {
    return this.formatterPrint;
  };
  ColumnDefinition.prototype.component69 = function () {
    return this.formatterPrintParams;
  };
  ColumnDefinition.prototype.component70 = function () {
    return this.cellClick;
  };
  ColumnDefinition.prototype.component71 = function () {
    return this.cellDblClick;
  };
  ColumnDefinition.prototype.component72 = function () {
    return this.cellContext;
  };
  ColumnDefinition.prototype.component73 = function () {
    return this.cellTap;
  };
  ColumnDefinition.prototype.component74 = function () {
    return this.cellDblTap;
  };
  ColumnDefinition.prototype.component75 = function () {
    return this.cellTapHold;
  };
  ColumnDefinition.prototype.component76 = function () {
    return this.cellMouseEnter;
  };
  ColumnDefinition.prototype.component77 = function () {
    return this.cellMouseLeave;
  };
  ColumnDefinition.prototype.component78 = function () {
    return this.cellMouseOver;
  };
  ColumnDefinition.prototype.component79 = function () {
    return this.cellMouseOut;
  };
  ColumnDefinition.prototype.component80 = function () {
    return this.cellMouseMove;
  };
  ColumnDefinition.prototype.component81 = function () {
    return this.cellEditing;
  };
  ColumnDefinition.prototype.component82 = function () {
    return this.cellEdited;
  };
  ColumnDefinition.prototype.component83 = function () {
    return this.cellEditCancelled;
  };
  ColumnDefinition.prototype.component84 = function () {
    return this.headerMenu;
  };
  ColumnDefinition.prototype.component85 = function () {
    return this.headerContextMenu;
  };
  ColumnDefinition.prototype.component86 = function () {
    return this.contextMenu;
  };
  ColumnDefinition.prototype.component87 = function () {
    return this.hozAlign;
  };
  ColumnDefinition.prototype.component88 = function () {
    return this.vertAlign;
  };
  ColumnDefinition.prototype.component89 = function () {
    return this.clickMenu;
  };
  ColumnDefinition.prototype.component90 = function () {
    return this.headerHozAlign;
  };
  ColumnDefinition.prototype.component91 = function () {
    return this.accessor;
  };
  ColumnDefinition.prototype.component92 = function () {
    return this.accessorParams;
  };
  ColumnDefinition.prototype.component93 = function () {
    return this.maxWidth;
  };
  ColumnDefinition.prototype.component94 = function () {
    return this.mutatorData;
  };
  ColumnDefinition.prototype.component95 = function () {
    return this.mutatorDataParams;
  };
  ColumnDefinition.prototype.component96 = function () {
    return this.mutatorEdit;
  };
  ColumnDefinition.prototype.component97 = function () {
    return this.mutatorEditParams;
  };
  ColumnDefinition.prototype.component98 = function () {
    return this.mutatorClipboard;
  };
  ColumnDefinition.prototype.component99 = function () {
    return this.mutatorClipboardParams;
  };
  ColumnDefinition.prototype.component100 = function () {
    return this.mutator;
  };
  ColumnDefinition.prototype.component101 = function () {
    return this.mutatorParams;
  };
  ColumnDefinition.prototype.component102 = function () {
    return this.maxInitialWidth;
  };
  ColumnDefinition.prototype.component103 = function () {
    return this.cellPopup;
  };
  ColumnDefinition.prototype.component104 = function () {
    return this.headerPopup;
  };
  ColumnDefinition.prototype.component105 = function () {
    return this.headerPopupIcon;
  };
  ColumnDefinition.prototype.component106 = function () {
    return this.headerContextPopup;
  };
  ColumnDefinition.prototype.component107 = function () {
    return this.clickPopup;
  };
  ColumnDefinition.prototype.component108 = function () {
    return this.contextPopup;
  };
  ColumnDefinition.prototype.component109 = function () {
    return this.headerMenuIcon;
  };
  ColumnDefinition.prototype.component110 = function () {
    return this.headerWordWrap;
  };
  ColumnDefinition.prototype.component111 = function () {
    return this.dblClickPopup;
  };
  ColumnDefinition.prototype.component112 = function () {
    return this.headerClickPopup;
  };
  ColumnDefinition.prototype.component113 = function () {
    return this.headerDblClickPopup;
  };
  ColumnDefinition.prototype.component114 = function () {
    return this.headerClickMenu;
  };
  ColumnDefinition.prototype.component115 = function () {
    return this.headerDblClickMenu;
  };
  ColumnDefinition.prototype.component116 = function () {
    return this.dblClickMenu;
  };
  ColumnDefinition.prototype.copy_vicz5a$ = function (title, field, columns, visible, align, width, minWidth, widthGrow, widthShrink, resizable, frozen, responsive, tooltip, cssClass, rowHandle, hideInHtml, sorter, sorterFunction, sorterParams, formatter, formatterFunction, formatterComponentFunction, formatterParams, variableHeight, editable, editor, editorFunction, editorComponentFunction, editorParams, validator, validatorFunction, validatorParams, download, downloadTitle, topCalc, topCalcParams, topCalcFormatter, topCalcFormatterParams, bottomCalc, bottomCalcParams, bottomCalcFormatter, bottomCalcFormatterParams, headerSort, headerSortStartingDir, headerSortTristate, headerClick, headerDblClick, headerContext, headerTap, headerDblTap, headerTapHold, headerTooltip, headerVertical, editableTitle, titleFormatter, titleFormatterParams, headerFilter, headerFilterParams, headerFilterCustom, headerFilterPlaceholder, headerFilterEmptyCheck, headerFilterFunc, headerFilterFuncCustom, headerFilterFuncParams, headerFilterLiveFilter, htmlOutput, print, formatterPrint, formatterPrintParams, cellClick, cellDblClick, cellContext, cellTap, cellDblTap, cellTapHold, cellMouseEnter, cellMouseLeave, cellMouseOver, cellMouseOut, cellMouseMove, cellEditing, cellEdited, cellEditCancelled, headerMenu, headerContextMenu, contextMenu, hozAlign, vertAlign, clickMenu, headerHozAlign, accessor, accessorParams, maxWidth, mutatorData, mutatorDataParams, mutatorEdit, mutatorEditParams, mutatorClipboard, mutatorClipboardParams, mutator, mutatorParams, maxInitialWidth, cellPopup, headerPopup, headerPopupIcon, headerContextPopup, clickPopup, contextPopup, headerMenuIcon, headerWordWrap, dblClickPopup, headerClickPopup, headerDblClickPopup, headerClickMenu, headerDblClickMenu, dblClickMenu) {
    return new ColumnDefinition(title === void 0 ? this.title : title, field === void 0 ? this.field : field, columns === void 0 ? this.columns : columns, visible === void 0 ? this.visible : visible, align === void 0 ? this.align : align, width === void 0 ? this.width : width, minWidth === void 0 ? this.minWidth : minWidth, widthGrow === void 0 ? this.widthGrow : widthGrow, widthShrink === void 0 ? this.widthShrink : widthShrink, resizable === void 0 ? this.resizable : resizable, frozen === void 0 ? this.frozen : frozen, responsive === void 0 ? this.responsive : responsive, tooltip === void 0 ? this.tooltip : tooltip, cssClass === void 0 ? this.cssClass : cssClass, rowHandle === void 0 ? this.rowHandle : rowHandle, hideInHtml === void 0 ? this.hideInHtml : hideInHtml, sorter === void 0 ? this.sorter : sorter, sorterFunction === void 0 ? this.sorterFunction : sorterFunction, sorterParams === void 0 ? this.sorterParams : sorterParams, formatter === void 0 ? this.formatter : formatter, formatterFunction === void 0 ? this.formatterFunction : formatterFunction, formatterComponentFunction === void 0 ? this.formatterComponentFunction : formatterComponentFunction, formatterParams === void 0 ? this.formatterParams : formatterParams, variableHeight === void 0 ? this.variableHeight : variableHeight, editable === void 0 ? this.editable : editable, editor === void 0 ? this.editor : editor, editorFunction === void 0 ? this.editorFunction : editorFunction, editorComponentFunction === void 0 ? this.editorComponentFunction : editorComponentFunction, editorParams === void 0 ? this.editorParams : editorParams, validator === void 0 ? this.validator : validator, validatorFunction === void 0 ? this.validatorFunction : validatorFunction, validatorParams === void 0 ? this.validatorParams : validatorParams, download === void 0 ? this.download : download, downloadTitle === void 0 ? this.downloadTitle : downloadTitle, topCalc === void 0 ? this.topCalc : topCalc, topCalcParams === void 0 ? this.topCalcParams : topCalcParams, topCalcFormatter === void 0 ? this.topCalcFormatter : topCalcFormatter, topCalcFormatterParams === void 0 ? this.topCalcFormatterParams : topCalcFormatterParams, bottomCalc === void 0 ? this.bottomCalc : bottomCalc, bottomCalcParams === void 0 ? this.bottomCalcParams : bottomCalcParams, bottomCalcFormatter === void 0 ? this.bottomCalcFormatter : bottomCalcFormatter, bottomCalcFormatterParams === void 0 ? this.bottomCalcFormatterParams : bottomCalcFormatterParams, headerSort === void 0 ? this.headerSort : headerSort, headerSortStartingDir === void 0 ? this.headerSortStartingDir : headerSortStartingDir, headerSortTristate === void 0 ? this.headerSortTristate : headerSortTristate, headerClick === void 0 ? this.headerClick : headerClick, headerDblClick === void 0 ? this.headerDblClick : headerDblClick, headerContext === void 0 ? this.headerContext : headerContext, headerTap === void 0 ? this.headerTap : headerTap, headerDblTap === void 0 ? this.headerDblTap : headerDblTap, headerTapHold === void 0 ? this.headerTapHold : headerTapHold, headerTooltip === void 0 ? this.headerTooltip : headerTooltip, headerVertical === void 0 ? this.headerVertical : headerVertical, editableTitle === void 0 ? this.editableTitle : editableTitle, titleFormatter === void 0 ? this.titleFormatter : titleFormatter, titleFormatterParams === void 0 ? this.titleFormatterParams : titleFormatterParams, headerFilter === void 0 ? this.headerFilter : headerFilter, headerFilterParams === void 0 ? this.headerFilterParams : headerFilterParams, headerFilterCustom === void 0 ? this.headerFilterCustom : headerFilterCustom, headerFilterPlaceholder === void 0 ? this.headerFilterPlaceholder : headerFilterPlaceholder, headerFilterEmptyCheck === void 0 ? this.headerFilterEmptyCheck : headerFilterEmptyCheck, headerFilterFunc === void 0 ? this.headerFilterFunc : headerFilterFunc, headerFilterFuncCustom === void 0 ? this.headerFilterFuncCustom : headerFilterFuncCustom, headerFilterFuncParams === void 0 ? this.headerFilterFuncParams : headerFilterFuncParams, headerFilterLiveFilter === void 0 ? this.headerFilterLiveFilter : headerFilterLiveFilter, htmlOutput === void 0 ? this.htmlOutput : htmlOutput, print === void 0 ? this.print : print, formatterPrint === void 0 ? this.formatterPrint : formatterPrint, formatterPrintParams === void 0 ? this.formatterPrintParams : formatterPrintParams, cellClick === void 0 ? this.cellClick : cellClick, cellDblClick === void 0 ? this.cellDblClick : cellDblClick, cellContext === void 0 ? this.cellContext : cellContext, cellTap === void 0 ? this.cellTap : cellTap, cellDblTap === void 0 ? this.cellDblTap : cellDblTap, cellTapHold === void 0 ? this.cellTapHold : cellTapHold, cellMouseEnter === void 0 ? this.cellMouseEnter : cellMouseEnter, cellMouseLeave === void 0 ? this.cellMouseLeave : cellMouseLeave, cellMouseOver === void 0 ? this.cellMouseOver : cellMouseOver, cellMouseOut === void 0 ? this.cellMouseOut : cellMouseOut, cellMouseMove === void 0 ? this.cellMouseMove : cellMouseMove, cellEditing === void 0 ? this.cellEditing : cellEditing, cellEdited === void 0 ? this.cellEdited : cellEdited, cellEditCancelled === void 0 ? this.cellEditCancelled : cellEditCancelled, headerMenu === void 0 ? this.headerMenu : headerMenu, headerContextMenu === void 0 ? this.headerContextMenu : headerContextMenu, contextMenu === void 0 ? this.contextMenu : contextMenu, hozAlign === void 0 ? this.hozAlign : hozAlign, vertAlign === void 0 ? this.vertAlign : vertAlign, clickMenu === void 0 ? this.clickMenu : clickMenu, headerHozAlign === void 0 ? this.headerHozAlign : headerHozAlign, accessor === void 0 ? this.accessor : accessor, accessorParams === void 0 ? this.accessorParams : accessorParams, maxWidth === void 0 ? this.maxWidth : maxWidth, mutatorData === void 0 ? this.mutatorData : mutatorData, mutatorDataParams === void 0 ? this.mutatorDataParams : mutatorDataParams, mutatorEdit === void 0 ? this.mutatorEdit : mutatorEdit, mutatorEditParams === void 0 ? this.mutatorEditParams : mutatorEditParams, mutatorClipboard === void 0 ? this.mutatorClipboard : mutatorClipboard, mutatorClipboardParams === void 0 ? this.mutatorClipboardParams : mutatorClipboardParams, mutator === void 0 ? this.mutator : mutator, mutatorParams === void 0 ? this.mutatorParams : mutatorParams, maxInitialWidth === void 0 ? this.maxInitialWidth : maxInitialWidth, cellPopup === void 0 ? this.cellPopup : cellPopup, headerPopup === void 0 ? this.headerPopup : headerPopup, headerPopupIcon === void 0 ? this.headerPopupIcon : headerPopupIcon, headerContextPopup === void 0 ? this.headerContextPopup : headerContextPopup, clickPopup === void 0 ? this.clickPopup : clickPopup, contextPopup === void 0 ? this.contextPopup : contextPopup, headerMenuIcon === void 0 ? this.headerMenuIcon : headerMenuIcon, headerWordWrap === void 0 ? this.headerWordWrap : headerWordWrap, dblClickPopup === void 0 ? this.dblClickPopup : dblClickPopup, headerClickPopup === void 0 ? this.headerClickPopup : headerClickPopup, headerDblClickPopup === void 0 ? this.headerDblClickPopup : headerDblClickPopup, headerClickMenu === void 0 ? this.headerClickMenu : headerClickMenu, headerDblClickMenu === void 0 ? this.headerDblClickMenu : headerDblClickMenu, dblClickMenu === void 0 ? this.dblClickMenu : dblClickMenu);
  };
  ColumnDefinition.prototype.toString = function () {
    return 'ColumnDefinition(title=' + Kotlin.toString(this.title) + (', field=' + Kotlin.toString(this.field)) + (', columns=' + Kotlin.toString(this.columns)) + (', visible=' + Kotlin.toString(this.visible)) + (', align=' + Kotlin.toString(this.align)) + (', width=' + Kotlin.toString(this.width)) + (', minWidth=' + Kotlin.toString(this.minWidth)) + (', widthGrow=' + Kotlin.toString(this.widthGrow)) + (', widthShrink=' + Kotlin.toString(this.widthShrink)) + (', resizable=' + Kotlin.toString(this.resizable)) + (', frozen=' + Kotlin.toString(this.frozen)) + (', responsive=' + Kotlin.toString(this.responsive)) + (', tooltip=' + Kotlin.toString(this.tooltip)) + (', cssClass=' + Kotlin.toString(this.cssClass)) + (', rowHandle=' + Kotlin.toString(this.rowHandle)) + (', hideInHtml=' + Kotlin.toString(this.hideInHtml)) + (', sorter=' + Kotlin.toString(this.sorter)) + (', sorterFunction=' + Kotlin.toString(this.sorterFunction)) + (', sorterParams=' + Kotlin.toString(this.sorterParams)) + (', formatter=' + Kotlin.toString(this.formatter)) + (', formatterFunction=' + Kotlin.toString(this.formatterFunction)) + (', formatterComponentFunction=' + Kotlin.toString(this.formatterComponentFunction)) + (', formatterParams=' + Kotlin.toString(this.formatterParams)) + (', variableHeight=' + Kotlin.toString(this.variableHeight)) + (', editable=' + Kotlin.toString(this.editable)) + (', editor=' + Kotlin.toString(this.editor)) + (', editorFunction=' + Kotlin.toString(this.editorFunction)) + (', editorComponentFunction=' + Kotlin.toString(this.editorComponentFunction)) + (', editorParams=' + Kotlin.toString(this.editorParams)) + (', validator=' + Kotlin.toString(this.validator)) + (', validatorFunction=' + Kotlin.toString(this.validatorFunction)) + (', validatorParams=' + Kotlin.toString(this.validatorParams)) + (', download=' + Kotlin.toString(this.download)) + (', downloadTitle=' + Kotlin.toString(this.downloadTitle)) + (', topCalc=' + Kotlin.toString(this.topCalc)) + (', topCalcParams=' + Kotlin.toString(this.topCalcParams)) + (', topCalcFormatter=' + Kotlin.toString(this.topCalcFormatter)) + (', topCalcFormatterParams=' + Kotlin.toString(this.topCalcFormatterParams)) + (', bottomCalc=' + Kotlin.toString(this.bottomCalc)) + (', bottomCalcParams=' + Kotlin.toString(this.bottomCalcParams)) + (', bottomCalcFormatter=' + Kotlin.toString(this.bottomCalcFormatter)) + (', bottomCalcFormatterParams=' + Kotlin.toString(this.bottomCalcFormatterParams)) + (', headerSort=' + Kotlin.toString(this.headerSort)) + (', headerSortStartingDir=' + Kotlin.toString(this.headerSortStartingDir)) + (', headerSortTristate=' + Kotlin.toString(this.headerSortTristate)) + (', headerClick=' + Kotlin.toString(this.headerClick)) + (', headerDblClick=' + Kotlin.toString(this.headerDblClick)) + (', headerContext=' + Kotlin.toString(this.headerContext)) + (', headerTap=' + Kotlin.toString(this.headerTap)) + (', headerDblTap=' + Kotlin.toString(this.headerDblTap)) + (', headerTapHold=' + Kotlin.toString(this.headerTapHold)) + (', headerTooltip=' + Kotlin.toString(this.headerTooltip)) + (', headerVertical=' + Kotlin.toString(this.headerVertical)) + (', editableTitle=' + Kotlin.toString(this.editableTitle)) + (', titleFormatter=' + Kotlin.toString(this.titleFormatter)) + (', titleFormatterParams=' + Kotlin.toString(this.titleFormatterParams)) + (', headerFilter=' + Kotlin.toString(this.headerFilter)) + (', headerFilterParams=' + Kotlin.toString(this.headerFilterParams)) + (', headerFilterCustom=' + Kotlin.toString(this.headerFilterCustom)) + (', headerFilterPlaceholder=' + Kotlin.toString(this.headerFilterPlaceholder)) + (', headerFilterEmptyCheck=' + Kotlin.toString(this.headerFilterEmptyCheck)) + (', headerFilterFunc=' + Kotlin.toString(this.headerFilterFunc)) + (', headerFilterFuncCustom=' + Kotlin.toString(this.headerFilterFuncCustom)) + (', headerFilterFuncParams=' + Kotlin.toString(this.headerFilterFuncParams)) + (', headerFilterLiveFilter=' + Kotlin.toString(this.headerFilterLiveFilter)) + (', htmlOutput=' + Kotlin.toString(this.htmlOutput)) + (', print=' + Kotlin.toString(this.print)) + (', formatterPrint=' + Kotlin.toString(this.formatterPrint)) + (', formatterPrintParams=' + Kotlin.toString(this.formatterPrintParams)) + (', cellClick=' + Kotlin.toString(this.cellClick)) + (', cellDblClick=' + Kotlin.toString(this.cellDblClick)) + (', cellContext=' + Kotlin.toString(this.cellContext)) + (', cellTap=' + Kotlin.toString(this.cellTap)) + (', cellDblTap=' + Kotlin.toString(this.cellDblTap)) + (', cellTapHold=' + Kotlin.toString(this.cellTapHold)) + (', cellMouseEnter=' + Kotlin.toString(this.cellMouseEnter)) + (', cellMouseLeave=' + Kotlin.toString(this.cellMouseLeave)) + (', cellMouseOver=' + Kotlin.toString(this.cellMouseOver)) + (', cellMouseOut=' + Kotlin.toString(this.cellMouseOut)) + (', cellMouseMove=' + Kotlin.toString(this.cellMouseMove)) + (', cellEditing=' + Kotlin.toString(this.cellEditing)) + (', cellEdited=' + Kotlin.toString(this.cellEdited)) + (', cellEditCancelled=' + Kotlin.toString(this.cellEditCancelled)) + (', headerMenu=' + Kotlin.toString(this.headerMenu)) + (', headerContextMenu=' + Kotlin.toString(this.headerContextMenu)) + (', contextMenu=' + Kotlin.toString(this.contextMenu)) + (', hozAlign=' + Kotlin.toString(this.hozAlign)) + (', vertAlign=' + Kotlin.toString(this.vertAlign)) + (', clickMenu=' + Kotlin.toString(this.clickMenu)) + (', headerHozAlign=' + Kotlin.toString(this.headerHozAlign)) + (', accessor=' + Kotlin.toString(this.accessor)) + (', accessorParams=' + Kotlin.toString(this.accessorParams)) + (', maxWidth=' + Kotlin.toString(this.maxWidth)) + (', mutatorData=' + Kotlin.toString(this.mutatorData)) + (', mutatorDataParams=' + Kotlin.toString(this.mutatorDataParams)) + (', mutatorEdit=' + Kotlin.toString(this.mutatorEdit)) + (', mutatorEditParams=' + Kotlin.toString(this.mutatorEditParams)) + (', mutatorClipboard=' + Kotlin.toString(this.mutatorClipboard)) + (', mutatorClipboardParams=' + Kotlin.toString(this.mutatorClipboardParams)) + (', mutator=' + Kotlin.toString(this.mutator)) + (', mutatorParams=' + Kotlin.toString(this.mutatorParams)) + (', maxInitialWidth=' + Kotlin.toString(this.maxInitialWidth)) + (', cellPopup=' + Kotlin.toString(this.cellPopup)) + (', headerPopup=' + Kotlin.toString(this.headerPopup)) + (', headerPopupIcon=' + Kotlin.toString(this.headerPopupIcon)) + (', headerContextPopup=' + Kotlin.toString(this.headerContextPopup)) + (', clickPopup=' + Kotlin.toString(this.clickPopup)) + (', contextPopup=' + Kotlin.toString(this.contextPopup)) + (', headerMenuIcon=' + Kotlin.toString(this.headerMenuIcon)) + (', headerWordWrap=' + Kotlin.toString(this.headerWordWrap)) + (', dblClickPopup=' + Kotlin.toString(this.dblClickPopup)) + (', headerClickPopup=' + Kotlin.toString(this.headerClickPopup)) + (', headerDblClickPopup=' + Kotlin.toString(this.headerDblClickPopup)) + (', headerClickMenu=' + Kotlin.toString(this.headerClickMenu)) + (', headerDblClickMenu=' + Kotlin.toString(this.headerDblClickMenu)) + (', dblClickMenu=' + Kotlin.toString(this.dblClickMenu)) + ')';
  };
  ColumnDefinition.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.title) | 0;
    result = result * 31 + Kotlin.hashCode(this.field) | 0;
    result = result * 31 + Kotlin.hashCode(this.columns) | 0;
    result = result * 31 + Kotlin.hashCode(this.visible) | 0;
    result = result * 31 + Kotlin.hashCode(this.align) | 0;
    result = result * 31 + Kotlin.hashCode(this.width) | 0;
    result = result * 31 + Kotlin.hashCode(this.minWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.widthGrow) | 0;
    result = result * 31 + Kotlin.hashCode(this.widthShrink) | 0;
    result = result * 31 + Kotlin.hashCode(this.resizable) | 0;
    result = result * 31 + Kotlin.hashCode(this.frozen) | 0;
    result = result * 31 + Kotlin.hashCode(this.responsive) | 0;
    result = result * 31 + Kotlin.hashCode(this.tooltip) | 0;
    result = result * 31 + Kotlin.hashCode(this.cssClass) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowHandle) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideInHtml) | 0;
    result = result * 31 + Kotlin.hashCode(this.sorter) | 0;
    result = result * 31 + Kotlin.hashCode(this.sorterFunction) | 0;
    result = result * 31 + Kotlin.hashCode(this.sorterParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.formatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.formatterFunction) | 0;
    result = result * 31 + Kotlin.hashCode(this.formatterComponentFunction) | 0;
    result = result * 31 + Kotlin.hashCode(this.formatterParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.variableHeight) | 0;
    result = result * 31 + Kotlin.hashCode(this.editable) | 0;
    result = result * 31 + Kotlin.hashCode(this.editor) | 0;
    result = result * 31 + Kotlin.hashCode(this.editorFunction) | 0;
    result = result * 31 + Kotlin.hashCode(this.editorComponentFunction) | 0;
    result = result * 31 + Kotlin.hashCode(this.editorParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.validator) | 0;
    result = result * 31 + Kotlin.hashCode(this.validatorFunction) | 0;
    result = result * 31 + Kotlin.hashCode(this.validatorParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.download) | 0;
    result = result * 31 + Kotlin.hashCode(this.downloadTitle) | 0;
    result = result * 31 + Kotlin.hashCode(this.topCalc) | 0;
    result = result * 31 + Kotlin.hashCode(this.topCalcParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.topCalcFormatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.topCalcFormatterParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.bottomCalc) | 0;
    result = result * 31 + Kotlin.hashCode(this.bottomCalcParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.bottomCalcFormatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.bottomCalcFormatterParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerSort) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerSortStartingDir) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerSortTristate) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerClick) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerDblClick) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerContext) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerTap) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerDblTap) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerTapHold) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerTooltip) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerVertical) | 0;
    result = result * 31 + Kotlin.hashCode(this.editableTitle) | 0;
    result = result * 31 + Kotlin.hashCode(this.titleFormatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.titleFormatterParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilter) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterCustom) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterPlaceholder) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterEmptyCheck) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterFunc) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterFuncCustom) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterFuncParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterLiveFilter) | 0;
    result = result * 31 + Kotlin.hashCode(this.htmlOutput) | 0;
    result = result * 31 + Kotlin.hashCode(this.print) | 0;
    result = result * 31 + Kotlin.hashCode(this.formatterPrint) | 0;
    result = result * 31 + Kotlin.hashCode(this.formatterPrintParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellClick) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellDblClick) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellContext) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellTap) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellDblTap) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellTapHold) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellMouseEnter) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellMouseLeave) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellMouseOver) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellMouseOut) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellMouseMove) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellEditing) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellEdited) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellEditCancelled) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerContextMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.contextMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.hozAlign) | 0;
    result = result * 31 + Kotlin.hashCode(this.vertAlign) | 0;
    result = result * 31 + Kotlin.hashCode(this.clickMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerHozAlign) | 0;
    result = result * 31 + Kotlin.hashCode(this.accessor) | 0;
    result = result * 31 + Kotlin.hashCode(this.accessorParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.maxWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorData) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorDataParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorEdit) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorEditParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorClipboard) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorClipboardParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutator) | 0;
    result = result * 31 + Kotlin.hashCode(this.mutatorParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.maxInitialWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.cellPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerPopupIcon) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerContextPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.clickPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.contextPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerMenuIcon) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerWordWrap) | 0;
    result = result * 31 + Kotlin.hashCode(this.dblClickPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerClickPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerDblClickPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerClickMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerDblClickMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.dblClickMenu) | 0;
    return result;
  };
  ColumnDefinition.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.title, other.title) && Kotlin.equals(this.field, other.field) && Kotlin.equals(this.columns, other.columns) && Kotlin.equals(this.visible, other.visible) && Kotlin.equals(this.align, other.align) && Kotlin.equals(this.width, other.width) && Kotlin.equals(this.minWidth, other.minWidth) && Kotlin.equals(this.widthGrow, other.widthGrow) && Kotlin.equals(this.widthShrink, other.widthShrink) && Kotlin.equals(this.resizable, other.resizable) && Kotlin.equals(this.frozen, other.frozen) && Kotlin.equals(this.responsive, other.responsive) && Kotlin.equals(this.tooltip, other.tooltip) && Kotlin.equals(this.cssClass, other.cssClass) && Kotlin.equals(this.rowHandle, other.rowHandle) && Kotlin.equals(this.hideInHtml, other.hideInHtml) && Kotlin.equals(this.sorter, other.sorter) && Kotlin.equals(this.sorterFunction, other.sorterFunction) && Kotlin.equals(this.sorterParams, other.sorterParams) && Kotlin.equals(this.formatter, other.formatter) && Kotlin.equals(this.formatterFunction, other.formatterFunction) && Kotlin.equals(this.formatterComponentFunction, other.formatterComponentFunction) && Kotlin.equals(this.formatterParams, other.formatterParams) && Kotlin.equals(this.variableHeight, other.variableHeight) && Kotlin.equals(this.editable, other.editable) && Kotlin.equals(this.editor, other.editor) && Kotlin.equals(this.editorFunction, other.editorFunction) && Kotlin.equals(this.editorComponentFunction, other.editorComponentFunction) && Kotlin.equals(this.editorParams, other.editorParams) && Kotlin.equals(this.validator, other.validator) && Kotlin.equals(this.validatorFunction, other.validatorFunction) && Kotlin.equals(this.validatorParams, other.validatorParams) && Kotlin.equals(this.download, other.download) && Kotlin.equals(this.downloadTitle, other.downloadTitle) && Kotlin.equals(this.topCalc, other.topCalc) && Kotlin.equals(this.topCalcParams, other.topCalcParams) && Kotlin.equals(this.topCalcFormatter, other.topCalcFormatter) && Kotlin.equals(this.topCalcFormatterParams, other.topCalcFormatterParams) && Kotlin.equals(this.bottomCalc, other.bottomCalc) && Kotlin.equals(this.bottomCalcParams, other.bottomCalcParams) && Kotlin.equals(this.bottomCalcFormatter, other.bottomCalcFormatter) && Kotlin.equals(this.bottomCalcFormatterParams, other.bottomCalcFormatterParams) && Kotlin.equals(this.headerSort, other.headerSort) && Kotlin.equals(this.headerSortStartingDir, other.headerSortStartingDir) && Kotlin.equals(this.headerSortTristate, other.headerSortTristate) && Kotlin.equals(this.headerClick, other.headerClick) && Kotlin.equals(this.headerDblClick, other.headerDblClick) && Kotlin.equals(this.headerContext, other.headerContext) && Kotlin.equals(this.headerTap, other.headerTap) && Kotlin.equals(this.headerDblTap, other.headerDblTap) && Kotlin.equals(this.headerTapHold, other.headerTapHold) && Kotlin.equals(this.headerTooltip, other.headerTooltip) && Kotlin.equals(this.headerVertical, other.headerVertical) && Kotlin.equals(this.editableTitle, other.editableTitle) && Kotlin.equals(this.titleFormatter, other.titleFormatter) && Kotlin.equals(this.titleFormatterParams, other.titleFormatterParams) && Kotlin.equals(this.headerFilter, other.headerFilter) && Kotlin.equals(this.headerFilterParams, other.headerFilterParams) && Kotlin.equals(this.headerFilterCustom, other.headerFilterCustom) && Kotlin.equals(this.headerFilterPlaceholder, other.headerFilterPlaceholder) && Kotlin.equals(this.headerFilterEmptyCheck, other.headerFilterEmptyCheck) && Kotlin.equals(this.headerFilterFunc, other.headerFilterFunc) && Kotlin.equals(this.headerFilterFuncCustom, other.headerFilterFuncCustom) && Kotlin.equals(this.headerFilterFuncParams, other.headerFilterFuncParams) && Kotlin.equals(this.headerFilterLiveFilter, other.headerFilterLiveFilter) && Kotlin.equals(this.htmlOutput, other.htmlOutput) && Kotlin.equals(this.print, other.print) && Kotlin.equals(this.formatterPrint, other.formatterPrint) && Kotlin.equals(this.formatterPrintParams, other.formatterPrintParams) && Kotlin.equals(this.cellClick, other.cellClick) && Kotlin.equals(this.cellDblClick, other.cellDblClick) && Kotlin.equals(this.cellContext, other.cellContext) && Kotlin.equals(this.cellTap, other.cellTap) && Kotlin.equals(this.cellDblTap, other.cellDblTap) && Kotlin.equals(this.cellTapHold, other.cellTapHold) && Kotlin.equals(this.cellMouseEnter, other.cellMouseEnter) && Kotlin.equals(this.cellMouseLeave, other.cellMouseLeave) && Kotlin.equals(this.cellMouseOver, other.cellMouseOver) && Kotlin.equals(this.cellMouseOut, other.cellMouseOut) && Kotlin.equals(this.cellMouseMove, other.cellMouseMove) && Kotlin.equals(this.cellEditing, other.cellEditing) && Kotlin.equals(this.cellEdited, other.cellEdited) && Kotlin.equals(this.cellEditCancelled, other.cellEditCancelled) && Kotlin.equals(this.headerMenu, other.headerMenu) && Kotlin.equals(this.headerContextMenu, other.headerContextMenu) && Kotlin.equals(this.contextMenu, other.contextMenu) && Kotlin.equals(this.hozAlign, other.hozAlign) && Kotlin.equals(this.vertAlign, other.vertAlign) && Kotlin.equals(this.clickMenu, other.clickMenu) && Kotlin.equals(this.headerHozAlign, other.headerHozAlign) && Kotlin.equals(this.accessor, other.accessor) && Kotlin.equals(this.accessorParams, other.accessorParams) && Kotlin.equals(this.maxWidth, other.maxWidth) && Kotlin.equals(this.mutatorData, other.mutatorData) && Kotlin.equals(this.mutatorDataParams, other.mutatorDataParams) && Kotlin.equals(this.mutatorEdit, other.mutatorEdit) && Kotlin.equals(this.mutatorEditParams, other.mutatorEditParams) && Kotlin.equals(this.mutatorClipboard, other.mutatorClipboard) && Kotlin.equals(this.mutatorClipboardParams, other.mutatorClipboardParams) && Kotlin.equals(this.mutator, other.mutator) && Kotlin.equals(this.mutatorParams, other.mutatorParams) && Kotlin.equals(this.maxInitialWidth, other.maxInitialWidth) && Kotlin.equals(this.cellPopup, other.cellPopup) && Kotlin.equals(this.headerPopup, other.headerPopup) && Kotlin.equals(this.headerPopupIcon, other.headerPopupIcon) && Kotlin.equals(this.headerContextPopup, other.headerContextPopup) && Kotlin.equals(this.clickPopup, other.clickPopup) && Kotlin.equals(this.contextPopup, other.contextPopup) && Kotlin.equals(this.headerMenuIcon, other.headerMenuIcon) && Kotlin.equals(this.headerWordWrap, other.headerWordWrap) && Kotlin.equals(this.dblClickPopup, other.dblClickPopup) && Kotlin.equals(this.headerClickPopup, other.headerClickPopup) && Kotlin.equals(this.headerDblClickPopup, other.headerDblClickPopup) && Kotlin.equals(this.headerClickMenu, other.headerClickMenu) && Kotlin.equals(this.headerDblClickMenu, other.headerDblClickMenu) && Kotlin.equals(this.dblClickMenu, other.dblClickMenu)))));
  };
  function EditorRoot() {
    EditorRoot_instance = this;
    this.root_8be2vx$ = null;
    this.cancel_8be2vx$ = null;
    this.disposeTimer_8be2vx$ = null;
  }
  EditorRoot.$metadata$ = {kind: Kind_OBJECT, simpleName: 'EditorRoot', interfaces: []};
  var EditorRoot_instance = null;
  function EditorRoot_getInstance() {
    if (EditorRoot_instance === null) {
      new EditorRoot();
    }return EditorRoot_instance;
  }
  function toJs$lambda$lambda$lambda(closure$onRenderedCallback) {
    return function (callback) {
      closure$onRenderedCallback.v = callback;
      return Unit;
    };
  }
  function toJs$lambda$lambda$lambda$lambda() {
    var tmp$;
    (tmp$ = EditorRoot_getInstance().root_8be2vx$) != null ? (tmp$.dispose(), Unit) : null;
    EditorRoot_getInstance().disposeTimer_8be2vx$ = null;
    EditorRoot_getInstance().root_8be2vx$ = null;
    EditorRoot_getInstance().cancel_8be2vx$ = null;
    return Unit;
  }
  function toJs$lambda$lambda$lambda_0(closure$success) {
    return function (value) {
      closure$success(value);
      EditorRoot_getInstance().disposeTimer_8be2vx$ = window.setTimeout(toJs$lambda$lambda$lambda$lambda, 500);
      return Unit;
    };
  }
  function toJs$lambda$lambda$lambda_1(closure$rootElement, closure$cancel, closure$component, closure$cell, closure$onRenderedCallback) {
    return function () {
      var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6;
      if (EditorRoot_getInstance().root_8be2vx$ != null) {
        if ((tmp$ = EditorRoot_getInstance().disposeTimer_8be2vx$) != null) {
          window.clearTimeout(tmp$);
        }(tmp$_0 = EditorRoot_getInstance().root_8be2vx$) != null ? (tmp$_0.dispose(), Unit) : null;
      }EditorRoot_getInstance().root_8be2vx$ = Root_init(closure$rootElement, ContainerType.NONE, false);
      EditorRoot_getInstance().cancel_8be2vx$ = closure$cancel;
      (tmp$_1 = EditorRoot_getInstance().root_8be2vx$) != null ? tmp$_1.add_87eobz$(closure$component) : null;
      (tmp$_3 = Kotlin.isType(tmp$_2 = closure$component, FormControl) ? tmp$_2 : null) != null ? (tmp$_3.focus(), Unit) : null;
      (tmp$_5 = Kotlin.isType(tmp$_4 = closure$component, FormInput) ? tmp$_4 : null) != null ? (tmp$_5.focus(), Unit) : null;
      closure$cell.checkHeight();
      (tmp$_6 = closure$onRenderedCallback.v) != null ? tmp$_6() : null;
      return Unit;
    };
  }
  function toJs$lambda$lambda(closure$kClass, closure$tabulator, closure$it) {
    return function (cell, onRendered, success, cancel, f) {
      var tmp$;
      if (cell.getElement() != false)
        cell.getElement().style.overflow = 'visible';
      var onRenderedCallback = {v: null};
      if (closure$kClass == null)
        throw IllegalStateException_init('The data class type is unknown');
      var data = closure$tabulator.toKotlinObjTabulator_azo0g3$(cell.getData(), closure$kClass);
      var component = closure$it(cell, toJs$lambda$lambda$lambda(onRenderedCallback), toJs$lambda$lambda$lambda_0(success), cancel, data);
      var rootElement = Kotlin.isType(tmp$ = document.createElement('div'), HTMLElement) ? tmp$ : throwCCE();
      if (!equals(onRendered, undefined)) {
        onRendered(toJs$lambda$lambda$lambda_1(rootElement, cancel, component, cell, onRenderedCallback));
      }return rootElement;
    };
  }
  function toJs$lambda$lambda$lambda_2(closure$onRenderedCallback) {
    return function (callback) {
      closure$onRenderedCallback.v = callback;
      return Unit;
    };
  }
  function toJs$lambda$lambda$lambda_3(closure$rootElement, closure$tabulator, closure$component, closure$cell, closure$onRenderedCallback) {
    return function () {
      var tmp$;
      var root = Root_init(closure$rootElement, ContainerType.NONE, false);
      closure$tabulator.addCustomRoot_bbcr7y$(root);
      root.add_87eobz$(closure$component);
      closure$cell.checkHeight();
      (tmp$ = closure$onRenderedCallback.v) != null ? tmp$() : null;
      return Unit;
    };
  }
  function toJs$lambda$lambda_0(closure$kClass, closure$tabulator, closure$it) {
    return function (cell, f, onRendered) {
      var tmp$;
      var onRenderedCallback = {v: null};
      if (closure$kClass == null)
        throw IllegalStateException_init('The data class type is unknown');
      var data = closure$tabulator.toKotlinObjTabulator_azo0g3$(cell.getData(), closure$kClass);
      var component = closure$it(cell, toJs$lambda$lambda$lambda_2(onRenderedCallback), data);
      var rootElement = Kotlin.isType(tmp$ = document.createElement('div'), HTMLElement) ? tmp$ : throwCCE();
      if (!equals(onRendered, undefined)) {
        onRendered(toJs$lambda$lambda$lambda_3(rootElement, closure$tabulator, component, cell, onRenderedCallback));
      }return rootElement;
    };
  }
  function toJs$lambda$lambda_1(cell, f, f_0) {
    return cell.getValue();
  }
  function toJs$lambda$lambda_2(cell) {
    cell.checkHeight();
    return Unit;
  }
  function toJs_0($receiver, tabulator, i18nTranslator, kClass) {
    var tmp$, tmp$_0, tmp$_1;
    var tmpEditorFunction = (tmp$ = $receiver.editorComponentFunction) != null ? toJs$lambda$lambda(kClass, tabulator, tmp$) : null;
    var tmpFormatterFunction = (tmp$_0 = $receiver.formatterComponentFunction) != null ? toJs$lambda$lambda_0(kClass, tabulator, tmp$_0) : null;
    var $receiver_0 = new Object_init();
    $receiver_0.title = i18nTranslator($receiver.title);
    if ($receiver.field != null)
      $receiver_0.field = $receiver.field;
    if ($receiver.columns != null) {
      var $receiver_1 = $receiver.columns;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$_2;
      tmp$_2 = $receiver_1.iterator();
      while (tmp$_2.hasNext()) {
        var item = tmp$_2.next();
        destination.add_11rb$(toJs_0(item, tabulator, i18nTranslator, kClass));
      }
      $receiver_0.columns = copyToArray(destination);
    }if ($receiver.visible != null)
      $receiver_0.visible = $receiver.visible;
    if ($receiver.align != null)
      $receiver_0.align = $receiver.align.align_8be2vx$;
    if ($receiver.width != null)
      $receiver_0.width = $receiver.width;
    if ($receiver.minWidth != null)
      $receiver_0.minWidth = $receiver.minWidth;
    if ($receiver.widthGrow != null)
      $receiver_0.widthGrow = $receiver.widthGrow;
    if ($receiver.widthShrink != null)
      $receiver_0.widthShrink = $receiver.widthShrink;
    if ($receiver.resizable != null)
      $receiver_0.resizable = $receiver.resizable;
    if ($receiver.frozen != null)
      $receiver_0.frozen = $receiver.frozen;
    if ($receiver.responsive != null)
      $receiver_0.responsive = $receiver.responsive;
    if ($receiver.tooltip != null)
      $receiver_0.tooltip = $receiver.tooltip;
    if ($receiver.cssClass != null)
      $receiver_0.cssClass = $receiver.cssClass;
    if ($receiver.rowHandle != null)
      $receiver_0.rowHandle = $receiver.rowHandle;
    if ($receiver.hideInHtml != null)
      $receiver_0.hideInHtml = $receiver.hideInHtml;
    if ($receiver.sorterFunction != null) {
      $receiver_0.sorter = $receiver.sorterFunction;
    } else if ($receiver.sorter != null) {
      $receiver_0.sorter = $receiver.sorter.sorter_8be2vx$;
    }if ($receiver.sorterParams != null)
      $receiver_0.sorterParams = $receiver.sorterParams;
    if (tmpFormatterFunction != null)
      $receiver_0.formatter = tmpFormatterFunction;
    else if ($receiver.formatterFunction != null)
      $receiver_0.formatter = $receiver.formatterFunction;
    else if ($receiver.formatter != null)
      $receiver_0.formatter = $receiver.formatter.formatter_8be2vx$;
    if ($receiver.formatterParams != null)
      $receiver_0.formatterParams = $receiver.formatterParams;
    if ($receiver.variableHeight != null)
      $receiver_0.variableHeight = $receiver.variableHeight;
    if ($receiver.editable != null)
      $receiver_0.editable = $receiver.editable;
    if (tmpEditorFunction != null)
      $receiver_0.editor = tmpEditorFunction;
    else if ($receiver.editorFunction != null)
      $receiver_0.editor = $receiver.editorFunction;
    else if ($receiver.editor != null)
      $receiver_0.editor = $receiver.editor.editor_8be2vx$;
    if ($receiver.editorParams != null)
      $receiver_0.editorParams = $receiver.editorParams;
    if ($receiver.validator != null)
      $receiver_0.validator = $receiver.validator.validator_8be2vx$;
    if ($receiver.validatorParams != null)
      $receiver_0.validatorParams = $receiver.validatorParams;
    if ($receiver.download != null)
      $receiver_0.download = $receiver.download;
    if ($receiver.downloadTitle != null)
      $receiver_0.downloadTitle = i18nTranslator($receiver.downloadTitle);
    if ($receiver.topCalc != null)
      $receiver_0.topCalc = $receiver.topCalc.calc_8be2vx$;
    if ($receiver.topCalcParams != null)
      $receiver_0.topCalcParams = $receiver.topCalcParams;
    if ($receiver.topCalcFormatter != null)
      $receiver_0.topCalcFormatter = $receiver.topCalcFormatter.formatter_8be2vx$;
    if ($receiver.topCalcFormatterParams != null)
      $receiver_0.topCalcFormatterParams = $receiver.topCalcFormatterParams;
    if ($receiver.bottomCalc != null)
      $receiver_0.bottomCalc = $receiver.bottomCalc.calc_8be2vx$;
    if ($receiver.bottomCalcParams != null)
      $receiver_0.bottomCalcParams = $receiver.bottomCalcParams;
    if ($receiver.bottomCalcFormatter != null)
      $receiver_0.bottomCalcFormatter = $receiver.bottomCalcFormatter.formatter_8be2vx$;
    if ($receiver.bottomCalcFormatterParams != null)
      $receiver_0.bottomCalcFormatterParams = $receiver.bottomCalcFormatterParams;
    if ($receiver.headerSort != null)
      $receiver_0.headerSort = $receiver.headerSort;
    if ($receiver.headerSortStartingDir != null)
      $receiver_0.headerSortStartingDir = $receiver.headerSortStartingDir.dir_8be2vx$;
    if ($receiver.headerSortTristate != null)
      $receiver_0.headerSortTristate = $receiver.headerSortTristate;
    if ($receiver.headerClick != null)
      $receiver_0.headerClick = $receiver.headerClick;
    if ($receiver.headerDblClick != null)
      $receiver_0.headerDblClick = $receiver.headerDblClick;
    if ($receiver.headerContext != null)
      $receiver_0.headerContext = $receiver.headerContext;
    if ($receiver.headerTap != null)
      $receiver_0.headerTap = $receiver.headerTap;
    if ($receiver.headerDblTap != null)
      $receiver_0.headerDblTap = $receiver.headerDblTap;
    if ($receiver.headerTapHold != null)
      $receiver_0.headerTapHold = $receiver.headerTapHold;
    if ($receiver.headerTooltip != null)
      $receiver_0.headerTooltip = $receiver.headerTooltip;
    if ($receiver.headerVertical != null)
      $receiver_0.headerVertical = $receiver.headerVertical;
    if ($receiver.editableTitle != null)
      $receiver_0.editableTitle = $receiver.editableTitle;
    if ($receiver.titleFormatter != null)
      $receiver_0.titleFormatter = $receiver.titleFormatter.formatter_8be2vx$;
    if ($receiver.titleFormatterParams != null)
      $receiver_0.titleFormatterParams = $receiver.titleFormatterParams;
    if ($receiver.headerFilterCustom != null) {
      $receiver_0.headerFilter = $receiver.headerFilterCustom;
    } else if ($receiver.headerFilter != null) {
      $receiver_0.headerFilter = $receiver.headerFilter.editor_8be2vx$;
    }if ($receiver.headerFilterParams != null)
      $receiver_0.headerFilterParams = $receiver.headerFilterParams;
    if ($receiver.headerFilterPlaceholder != null)
      $receiver_0.headerFilterPlaceholder = i18nTranslator($receiver.headerFilterPlaceholder);
    if ($receiver.headerFilterEmptyCheck != null)
      $receiver_0.headerFilterEmptyCheck = $receiver.headerFilterEmptyCheck;
    if ($receiver.headerFilterFuncCustom != null) {
      $receiver_0.headerFilterFunc = $receiver.headerFilterFuncCustom;
    } else if ($receiver.headerFilterFunc != null) {
      $receiver_0.headerFilterFunc = $receiver.headerFilterFunc.filter_8be2vx$;
    }if ($receiver.headerFilterFuncParams != null)
      $receiver_0.headerFilterFuncParams = $receiver.headerFilterFuncParams;
    if ($receiver.headerFilterLiveFilter != null)
      $receiver_0.headerFilterLiveFilter = $receiver.headerFilterLiveFilter;
    if ($receiver.htmlOutput != null)
      $receiver_0.htmlOutput = $receiver.htmlOutput;
    if ($receiver.print != null)
      $receiver_0.print = $receiver.print;
    if ($receiver.formatterPrint != null)
      $receiver_0.formatterPrint = $receiver.formatterPrint;
    else {
      if ($receiver.formatterComponentFunction != null) {
        $receiver_0.formatterPrint = toJs$lambda$lambda_1;
      }}
    if ($receiver.formatterPrintParams != null)
      $receiver_0.formatterPrintParams = $receiver.formatterPrintParams;
    if ($receiver.cellClick != null)
      $receiver_0.cellClick = $receiver.cellClick;
    if ($receiver.cellDblClick != null)
      $receiver_0.cellDblClick = $receiver.cellDblClick;
    if ($receiver.cellContext != null)
      $receiver_0.cellContext = $receiver.cellContext;
    if ($receiver.cellTap != null)
      $receiver_0.cellTap = $receiver.cellTap;
    if ($receiver.cellDblTap != null)
      $receiver_0.cellDblTap = $receiver.cellDblTap;
    if ($receiver.cellTapHold != null)
      $receiver_0.cellTapHold = $receiver.cellTapHold;
    if ($receiver.cellMouseEnter != null)
      $receiver_0.cellMouseEnter = $receiver.cellMouseEnter;
    if ($receiver.cellMouseLeave != null)
      $receiver_0.cellMouseLeave = $receiver.cellMouseLeave;
    if ($receiver.cellMouseOver != null)
      $receiver_0.cellMouseOver = $receiver.cellMouseOver;
    if ($receiver.cellMouseOut != null)
      $receiver_0.cellMouseOut = $receiver.cellMouseOut;
    if ($receiver.cellMouseMove != null)
      $receiver_0.cellMouseMove = $receiver.cellMouseMove;
    if ($receiver.cellEditing != null)
      $receiver_0.cellEditing = $receiver.cellEditing;
    if ($receiver.cellEdited != null)
      $receiver_0.cellEdited = $receiver.cellEdited;
    if ($receiver.cellEditCancelled != null) {
      $receiver_0.cellEditCancelled = $receiver.cellEditCancelled;
    } else if (tmpEditorFunction != null) {
      $receiver_0.cellEditCancelled = toJs$lambda$lambda_2;
    }if ($receiver.headerMenu != null)
      $receiver_0.headerMenu = $receiver.headerMenu;
    if ($receiver.headerContextMenu != null)
      $receiver_0.headerContextMenu = $receiver.headerContextMenu;
    if ($receiver.contextMenu != null)
      $receiver_0.contextMenu = $receiver.contextMenu;
    if ($receiver.hozAlign != null)
      $receiver_0.hozAlign = $receiver.hozAlign.align_8be2vx$;
    if ($receiver.vertAlign != null)
      $receiver_0.vertAlign = $receiver.vertAlign.valign_8be2vx$;
    if ($receiver.clickMenu != null)
      $receiver_0.clickMenu = $receiver.clickMenu;
    if ($receiver.headerHozAlign != null)
      $receiver_0.headerHozAlign = $receiver.headerHozAlign.align_8be2vx$;
    if ($receiver.accessor != null)
      $receiver_0.accessor = $receiver.accessor;
    if ($receiver.accessorParams != null)
      $receiver_0.accessorParams = $receiver.accessorParams;
    if ($receiver.maxWidth != null)
      $receiver_0.maxWidth = $receiver.maxWidth;
    if ($receiver.mutatorData != null)
      $receiver_0.mutatorData = $receiver.mutatorData;
    if ($receiver.mutatorDataParams != null)
      $receiver_0.mutatorDataParams = $receiver.mutatorDataParams;
    if ($receiver.mutatorEdit != null)
      $receiver_0.mutatorEdit = $receiver.mutatorEdit;
    if ($receiver.mutatorEditParams != null)
      $receiver_0.mutatorEditParams = $receiver.mutatorEditParams;
    if ($receiver.mutatorClipboard != null)
      $receiver_0.mutatorClipboard = $receiver.mutatorClipboard;
    if ($receiver.mutatorClipboardParams != null)
      $receiver_0.mutatorClipboardParams = $receiver.mutatorClipboardParams;
    if ($receiver.mutator != null)
      $receiver_0.mutator = $receiver.mutator;
    if ($receiver.mutatorParams != null)
      $receiver_0.mutatorParams = $receiver.mutatorParams;
    if ($receiver.maxInitialWidth != null)
      $receiver_0.maxInitialWidth = $receiver.maxInitialWidth;
    if ($receiver.cellPopup != null)
      $receiver_0.cellPopup = $receiver.cellPopup;
    if ($receiver.headerPopup != null)
      $receiver_0.headerPopup = $receiver.headerPopup;
    if ($receiver.headerPopupIcon != null)
      $receiver_0.headerPopupIcon = $receiver.headerPopupIcon;
    if ($receiver.headerContextPopup != null)
      $receiver_0.headerContextPopup = $receiver.headerContextPopup;
    if ($receiver.clickPopup != null)
      $receiver_0.clickPopup = $receiver.clickPopup;
    if ($receiver.contextPopup != null)
      $receiver_0.contextPopup = $receiver.contextPopup;
    if ($receiver.headerMenuIcon != null)
      $receiver_0.headerMenuIcon = $receiver.headerMenuIcon;
    if ($receiver.headerWordWrap != null)
      $receiver_0.headerWordWrap = $receiver.headerWordWrap;
    if ($receiver.headerClickPopup != null)
      $receiver_0.headerClickPopup = $receiver.headerClickPopup;
    if ($receiver.headerDblClickPopup != null)
      $receiver_0.headerDblClickPopup = $receiver.headerDblClickPopup;
    if ($receiver.headerClickMenu != null)
      $receiver_0.headerClickMenu = $receiver.headerClickMenu;
    if ($receiver.headerDblClickMenu != null)
      $receiver_0.headerDblClickMenu = $receiver.headerDblClickMenu;
    if ($receiver.dblClickMenu != null)
      $receiver_0.dblClickMenu = $receiver.dblClickMenu;
    return Kotlin.isType(tmp$_1 = $receiver_0, Object) ? tmp$_1 : throwCCE();
  }
  function TabulatorOptions(height, placeholder, footerElement, tooltipGenerationMode, history, keybindings, downloadDataFormatter, downloadConfig, reactiveData, autoResize, columns, autoColumns, layout, layoutColumnsOnNewData, responsiveLayout, responsiveLayoutCollapseStartOpen, responsiveLayoutCollapseUseFormatters, movableColumns, scrollToColumnPosition, scrollToColumnIfVisible, rowFormatter, addRowPos, selectable, selectableRangeMode, selectableRollingSelection, selectablePersistence, selectableCheck, movableRows, movableRowsConnectedTables, movableRowsSender, movableRowsReceiver, resizableRows, scrollToRowPosition, scrollToRowIfVisible, index, data, ajaxURL, ajaxParams, ajaxConfig, ajaxContentType, ajaxURLGenerator, ajaxRequestFunc, progressiveLoad, progressiveLoadDelay, progressiveLoadScrollMargin, dataLoader, dataLoaderLoading, dataLoaderError, initialSort, sortOrderReverse, initialFilter, initialHeaderFilter, pagination, paginationMode, paginationSize, paginationSizeSelector, paginationElement, dataReceiveParams, dataSendParams, paginationAddRow, paginationButtonCount, persistenceID, persistenceMode, persistentLayout, persistentSort, persistentFilter, locale, langs, localized, headerVisible, htmlOutputConfig, printAsHtml, printConfig, printCopyStyle, printVisibleRows, printHeader, printFooter, printFormatter, tabEndNewRow, invalidOptionWarnings, dataTree, dataTreeChildField, dataTreeCollapseElement, dataTreeExpandElement, dataTreeElementColumn, dataTreeBranchElement, dataTreeChildIndent, dataTreeStartExpanded, ajaxRequesting, ajaxResponse, persistence, persistenceReaderFunc, persistenceWriterFunc, paginationInitialPage, columnHeaderVertAlign, maxHeight, minHeight, rowContextMenu, dataTreeChildColumnCalcs, dataTreeSelectPropagate, headerFilterLiveFilterDelay, textDirection, autoColumnsDefinitions, rowClickMenu, headerSortElement, dataTreeFilter, dataTreeSort, renderVertical, renderVerticalBuffer, renderHorizontal, columnDefaults, sortMode, filterMode, importFormat, importReader, dataLoaderErrorTimeout, popupContainer, paginationCounter, paginationCounterElement, rowClickPopup, rowContextPopup, resizableColumnFit, rowHeight, frozenRows, frozenRowsField, headerSortClickElement, rowDblClickPopup, rowDblClickMenu) {
    if (height === void 0)
      height = null;
    if (placeholder === void 0)
      placeholder = null;
    if (footerElement === void 0)
      footerElement = null;
    if (tooltipGenerationMode === void 0)
      tooltipGenerationMode = null;
    if (history === void 0)
      history = null;
    if (keybindings === void 0)
      keybindings = null;
    if (downloadDataFormatter === void 0)
      downloadDataFormatter = null;
    if (downloadConfig === void 0)
      downloadConfig = null;
    if (reactiveData === void 0)
      reactiveData = null;
    if (autoResize === void 0)
      autoResize = null;
    if (columns === void 0)
      columns = null;
    if (autoColumns === void 0)
      autoColumns = null;
    if (layout === void 0)
      layout = null;
    if (layoutColumnsOnNewData === void 0)
      layoutColumnsOnNewData = null;
    if (responsiveLayout === void 0)
      responsiveLayout = null;
    if (responsiveLayoutCollapseStartOpen === void 0)
      responsiveLayoutCollapseStartOpen = null;
    if (responsiveLayoutCollapseUseFormatters === void 0)
      responsiveLayoutCollapseUseFormatters = null;
    if (movableColumns === void 0)
      movableColumns = null;
    if (scrollToColumnPosition === void 0)
      scrollToColumnPosition = null;
    if (scrollToColumnIfVisible === void 0)
      scrollToColumnIfVisible = null;
    if (rowFormatter === void 0)
      rowFormatter = null;
    if (addRowPos === void 0)
      addRowPos = null;
    if (selectable === void 0)
      selectable = null;
    if (selectableRangeMode === void 0)
      selectableRangeMode = null;
    if (selectableRollingSelection === void 0)
      selectableRollingSelection = null;
    if (selectablePersistence === void 0)
      selectablePersistence = null;
    if (selectableCheck === void 0)
      selectableCheck = null;
    if (movableRows === void 0)
      movableRows = null;
    if (movableRowsConnectedTables === void 0)
      movableRowsConnectedTables = null;
    if (movableRowsSender === void 0)
      movableRowsSender = null;
    if (movableRowsReceiver === void 0)
      movableRowsReceiver = null;
    if (resizableRows === void 0)
      resizableRows = null;
    if (scrollToRowPosition === void 0)
      scrollToRowPosition = null;
    if (scrollToRowIfVisible === void 0)
      scrollToRowIfVisible = null;
    if (index === void 0)
      index = null;
    if (data === void 0)
      data = null;
    if (ajaxURL === void 0)
      ajaxURL = null;
    if (ajaxParams === void 0)
      ajaxParams = null;
    if (ajaxConfig === void 0)
      ajaxConfig = null;
    if (ajaxContentType === void 0)
      ajaxContentType = null;
    if (ajaxURLGenerator === void 0)
      ajaxURLGenerator = null;
    if (ajaxRequestFunc === void 0)
      ajaxRequestFunc = null;
    if (progressiveLoad === void 0)
      progressiveLoad = null;
    if (progressiveLoadDelay === void 0)
      progressiveLoadDelay = null;
    if (progressiveLoadScrollMargin === void 0)
      progressiveLoadScrollMargin = null;
    if (dataLoader === void 0)
      dataLoader = null;
    if (dataLoaderLoading === void 0)
      dataLoaderLoading = null;
    if (dataLoaderError === void 0)
      dataLoaderError = null;
    if (initialSort === void 0)
      initialSort = null;
    if (sortOrderReverse === void 0)
      sortOrderReverse = null;
    if (initialFilter === void 0)
      initialFilter = null;
    if (initialHeaderFilter === void 0)
      initialHeaderFilter = null;
    if (pagination === void 0)
      pagination = null;
    if (paginationMode === void 0)
      paginationMode = null;
    if (paginationSize === void 0)
      paginationSize = null;
    if (paginationSizeSelector === void 0)
      paginationSizeSelector = null;
    if (paginationElement === void 0)
      paginationElement = null;
    if (dataReceiveParams === void 0)
      dataReceiveParams = null;
    if (dataSendParams === void 0)
      dataSendParams = null;
    if (paginationAddRow === void 0)
      paginationAddRow = null;
    if (paginationButtonCount === void 0)
      paginationButtonCount = null;
    if (persistenceID === void 0)
      persistenceID = null;
    if (persistenceMode === void 0)
      persistenceMode = null;
    if (persistentLayout === void 0)
      persistentLayout = null;
    if (persistentSort === void 0)
      persistentSort = null;
    if (persistentFilter === void 0)
      persistentFilter = null;
    if (locale === void 0)
      locale = null;
    if (langs === void 0)
      langs = null;
    if (localized === void 0)
      localized = null;
    if (headerVisible === void 0)
      headerVisible = null;
    if (htmlOutputConfig === void 0)
      htmlOutputConfig = null;
    if (printAsHtml === void 0)
      printAsHtml = null;
    if (printConfig === void 0)
      printConfig = null;
    if (printCopyStyle === void 0)
      printCopyStyle = null;
    if (printVisibleRows === void 0)
      printVisibleRows = null;
    if (printHeader === void 0)
      printHeader = null;
    if (printFooter === void 0)
      printFooter = null;
    if (printFormatter === void 0)
      printFormatter = null;
    if (tabEndNewRow === void 0)
      tabEndNewRow = null;
    if (invalidOptionWarnings === void 0)
      invalidOptionWarnings = null;
    if (dataTree === void 0)
      dataTree = null;
    if (dataTreeChildField === void 0)
      dataTreeChildField = null;
    if (dataTreeCollapseElement === void 0)
      dataTreeCollapseElement = null;
    if (dataTreeExpandElement === void 0)
      dataTreeExpandElement = null;
    if (dataTreeElementColumn === void 0)
      dataTreeElementColumn = null;
    if (dataTreeBranchElement === void 0)
      dataTreeBranchElement = null;
    if (dataTreeChildIndent === void 0)
      dataTreeChildIndent = null;
    if (dataTreeStartExpanded === void 0)
      dataTreeStartExpanded = null;
    if (ajaxRequesting === void 0)
      ajaxRequesting = null;
    if (ajaxResponse === void 0)
      ajaxResponse = null;
    if (persistence === void 0)
      persistence = null;
    if (persistenceReaderFunc === void 0)
      persistenceReaderFunc = null;
    if (persistenceWriterFunc === void 0)
      persistenceWriterFunc = null;
    if (paginationInitialPage === void 0)
      paginationInitialPage = null;
    if (columnHeaderVertAlign === void 0)
      columnHeaderVertAlign = null;
    if (maxHeight === void 0)
      maxHeight = null;
    if (minHeight === void 0)
      minHeight = null;
    if (rowContextMenu === void 0)
      rowContextMenu = null;
    if (dataTreeChildColumnCalcs === void 0)
      dataTreeChildColumnCalcs = null;
    if (dataTreeSelectPropagate === void 0)
      dataTreeSelectPropagate = null;
    if (headerFilterLiveFilterDelay === void 0)
      headerFilterLiveFilterDelay = null;
    if (textDirection === void 0)
      textDirection = null;
    if (autoColumnsDefinitions === void 0)
      autoColumnsDefinitions = null;
    if (rowClickMenu === void 0)
      rowClickMenu = null;
    if (headerSortElement === void 0)
      headerSortElement = null;
    if (dataTreeFilter === void 0)
      dataTreeFilter = null;
    if (dataTreeSort === void 0)
      dataTreeSort = null;
    if (renderVertical === void 0)
      renderVertical = null;
    if (renderVerticalBuffer === void 0)
      renderVerticalBuffer = null;
    if (renderHorizontal === void 0)
      renderHorizontal = null;
    if (columnDefaults === void 0)
      columnDefaults = null;
    if (sortMode === void 0)
      sortMode = null;
    if (filterMode === void 0)
      filterMode = null;
    if (importFormat === void 0)
      importFormat = null;
    if (importReader === void 0)
      importReader = null;
    if (dataLoaderErrorTimeout === void 0)
      dataLoaderErrorTimeout = null;
    if (popupContainer === void 0)
      popupContainer = null;
    if (paginationCounter === void 0)
      paginationCounter = null;
    if (paginationCounterElement === void 0)
      paginationCounterElement = null;
    if (rowClickPopup === void 0)
      rowClickPopup = null;
    if (rowContextPopup === void 0)
      rowContextPopup = null;
    if (resizableColumnFit === void 0)
      resizableColumnFit = null;
    if (rowHeight === void 0)
      rowHeight = null;
    if (frozenRows === void 0)
      frozenRows = null;
    if (frozenRowsField === void 0)
      frozenRowsField = null;
    if (headerSortClickElement === void 0)
      headerSortClickElement = null;
    if (rowDblClickPopup === void 0)
      rowDblClickPopup = null;
    if (rowDblClickMenu === void 0)
      rowDblClickMenu = null;
    this.height = height;
    this.placeholder = placeholder;
    this.footerElement = footerElement;
    this.tooltipGenerationMode = tooltipGenerationMode;
    this.history = history;
    this.keybindings = keybindings;
    this.downloadDataFormatter = downloadDataFormatter;
    this.downloadConfig = downloadConfig;
    this.reactiveData = reactiveData;
    this.autoResize = autoResize;
    this.columns = columns;
    this.autoColumns = autoColumns;
    this.layout = layout;
    this.layoutColumnsOnNewData = layoutColumnsOnNewData;
    this.responsiveLayout = responsiveLayout;
    this.responsiveLayoutCollapseStartOpen = responsiveLayoutCollapseStartOpen;
    this.responsiveLayoutCollapseUseFormatters = responsiveLayoutCollapseUseFormatters;
    this.movableColumns = movableColumns;
    this.scrollToColumnPosition = scrollToColumnPosition;
    this.scrollToColumnIfVisible = scrollToColumnIfVisible;
    this.rowFormatter = rowFormatter;
    this.addRowPos = addRowPos;
    this.selectable = selectable;
    this.selectableRangeMode = selectableRangeMode;
    this.selectableRollingSelection = selectableRollingSelection;
    this.selectablePersistence = selectablePersistence;
    this.selectableCheck = selectableCheck;
    this.movableRows = movableRows;
    this.movableRowsConnectedTables = movableRowsConnectedTables;
    this.movableRowsSender = movableRowsSender;
    this.movableRowsReceiver = movableRowsReceiver;
    this.resizableRows = resizableRows;
    this.scrollToRowPosition = scrollToRowPosition;
    this.scrollToRowIfVisible = scrollToRowIfVisible;
    this.index = index;
    this.data = data;
    this.ajaxURL = ajaxURL;
    this.ajaxParams = ajaxParams;
    this.ajaxConfig = ajaxConfig;
    this.ajaxContentType = ajaxContentType;
    this.ajaxURLGenerator = ajaxURLGenerator;
    this.ajaxRequestFunc = ajaxRequestFunc;
    this.progressiveLoad = progressiveLoad;
    this.progressiveLoadDelay = progressiveLoadDelay;
    this.progressiveLoadScrollMargin = progressiveLoadScrollMargin;
    this.dataLoader = dataLoader;
    this.dataLoaderLoading = dataLoaderLoading;
    this.dataLoaderError = dataLoaderError;
    this.initialSort = initialSort;
    this.sortOrderReverse = sortOrderReverse;
    this.initialFilter = initialFilter;
    this.initialHeaderFilter = initialHeaderFilter;
    this.pagination = pagination;
    this.paginationMode = paginationMode;
    this.paginationSize = paginationSize;
    this.paginationSizeSelector = paginationSizeSelector;
    this.paginationElement = paginationElement;
    this.dataReceiveParams = dataReceiveParams;
    this.dataSendParams = dataSendParams;
    this.paginationAddRow = paginationAddRow;
    this.paginationButtonCount = paginationButtonCount;
    this.persistenceID = persistenceID;
    this.persistenceMode = persistenceMode;
    this.persistentLayout = persistentLayout;
    this.persistentSort = persistentSort;
    this.persistentFilter = persistentFilter;
    this.locale = locale;
    this.langs = langs;
    this.localized = localized;
    this.headerVisible = headerVisible;
    this.htmlOutputConfig = htmlOutputConfig;
    this.printAsHtml = printAsHtml;
    this.printConfig = printConfig;
    this.printCopyStyle = printCopyStyle;
    this.printVisibleRows = printVisibleRows;
    this.printHeader = printHeader;
    this.printFooter = printFooter;
    this.printFormatter = printFormatter;
    this.tabEndNewRow = tabEndNewRow;
    this.invalidOptionWarnings = invalidOptionWarnings;
    this.dataTree = dataTree;
    this.dataTreeChildField = dataTreeChildField;
    this.dataTreeCollapseElement = dataTreeCollapseElement;
    this.dataTreeExpandElement = dataTreeExpandElement;
    this.dataTreeElementColumn = dataTreeElementColumn;
    this.dataTreeBranchElement = dataTreeBranchElement;
    this.dataTreeChildIndent = dataTreeChildIndent;
    this.dataTreeStartExpanded = dataTreeStartExpanded;
    this.ajaxRequesting = ajaxRequesting;
    this.ajaxResponse = ajaxResponse;
    this.persistence = persistence;
    this.persistenceReaderFunc = persistenceReaderFunc;
    this.persistenceWriterFunc = persistenceWriterFunc;
    this.paginationInitialPage = paginationInitialPage;
    this.columnHeaderVertAlign = columnHeaderVertAlign;
    this.maxHeight = maxHeight;
    this.minHeight = minHeight;
    this.rowContextMenu = rowContextMenu;
    this.dataTreeChildColumnCalcs = dataTreeChildColumnCalcs;
    this.dataTreeSelectPropagate = dataTreeSelectPropagate;
    this.headerFilterLiveFilterDelay = headerFilterLiveFilterDelay;
    this.textDirection = textDirection;
    this.autoColumnsDefinitions = autoColumnsDefinitions;
    this.rowClickMenu = rowClickMenu;
    this.headerSortElement = headerSortElement;
    this.dataTreeFilter = dataTreeFilter;
    this.dataTreeSort = dataTreeSort;
    this.renderVertical = renderVertical;
    this.renderVerticalBuffer = renderVerticalBuffer;
    this.renderHorizontal = renderHorizontal;
    this.columnDefaults = columnDefaults;
    this.sortMode = sortMode;
    this.filterMode = filterMode;
    this.importFormat = importFormat;
    this.importReader = importReader;
    this.dataLoaderErrorTimeout = dataLoaderErrorTimeout;
    this.popupContainer = popupContainer;
    this.paginationCounter = paginationCounter;
    this.paginationCounterElement = paginationCounterElement;
    this.rowClickPopup = rowClickPopup;
    this.rowContextPopup = rowContextPopup;
    this.resizableColumnFit = resizableColumnFit;
    this.rowHeight = rowHeight;
    this.frozenRows = frozenRows;
    this.frozenRowsField = frozenRowsField;
    this.headerSortClickElement = headerSortClickElement;
    this.rowDblClickPopup = rowDblClickPopup;
    this.rowDblClickMenu = rowDblClickMenu;
  }
  TabulatorOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'TabulatorOptions', interfaces: []};
  TabulatorOptions.prototype.component1 = function () {
    return this.height;
  };
  TabulatorOptions.prototype.component2 = function () {
    return this.placeholder;
  };
  TabulatorOptions.prototype.component3 = function () {
    return this.footerElement;
  };
  TabulatorOptions.prototype.component4 = function () {
    return this.tooltipGenerationMode;
  };
  TabulatorOptions.prototype.component5 = function () {
    return this.history;
  };
  TabulatorOptions.prototype.component6 = function () {
    return this.keybindings;
  };
  TabulatorOptions.prototype.component7 = function () {
    return this.downloadDataFormatter;
  };
  TabulatorOptions.prototype.component8 = function () {
    return this.downloadConfig;
  };
  TabulatorOptions.prototype.component9 = function () {
    return this.reactiveData;
  };
  TabulatorOptions.prototype.component10 = function () {
    return this.autoResize;
  };
  TabulatorOptions.prototype.component11 = function () {
    return this.columns;
  };
  TabulatorOptions.prototype.component12 = function () {
    return this.autoColumns;
  };
  TabulatorOptions.prototype.component13 = function () {
    return this.layout;
  };
  TabulatorOptions.prototype.component14 = function () {
    return this.layoutColumnsOnNewData;
  };
  TabulatorOptions.prototype.component15 = function () {
    return this.responsiveLayout;
  };
  TabulatorOptions.prototype.component16 = function () {
    return this.responsiveLayoutCollapseStartOpen;
  };
  TabulatorOptions.prototype.component17 = function () {
    return this.responsiveLayoutCollapseUseFormatters;
  };
  TabulatorOptions.prototype.component18 = function () {
    return this.movableColumns;
  };
  TabulatorOptions.prototype.component19 = function () {
    return this.scrollToColumnPosition;
  };
  TabulatorOptions.prototype.component20 = function () {
    return this.scrollToColumnIfVisible;
  };
  TabulatorOptions.prototype.component21 = function () {
    return this.rowFormatter;
  };
  TabulatorOptions.prototype.component22 = function () {
    return this.addRowPos;
  };
  TabulatorOptions.prototype.component23 = function () {
    return this.selectable;
  };
  TabulatorOptions.prototype.component24 = function () {
    return this.selectableRangeMode;
  };
  TabulatorOptions.prototype.component25 = function () {
    return this.selectableRollingSelection;
  };
  TabulatorOptions.prototype.component26 = function () {
    return this.selectablePersistence;
  };
  TabulatorOptions.prototype.component27 = function () {
    return this.selectableCheck;
  };
  TabulatorOptions.prototype.component28 = function () {
    return this.movableRows;
  };
  TabulatorOptions.prototype.component29 = function () {
    return this.movableRowsConnectedTables;
  };
  TabulatorOptions.prototype.component30 = function () {
    return this.movableRowsSender;
  };
  TabulatorOptions.prototype.component31 = function () {
    return this.movableRowsReceiver;
  };
  TabulatorOptions.prototype.component32 = function () {
    return this.resizableRows;
  };
  TabulatorOptions.prototype.component33 = function () {
    return this.scrollToRowPosition;
  };
  TabulatorOptions.prototype.component34 = function () {
    return this.scrollToRowIfVisible;
  };
  TabulatorOptions.prototype.component35 = function () {
    return this.index;
  };
  TabulatorOptions.prototype.component36 = function () {
    return this.data;
  };
  TabulatorOptions.prototype.component37 = function () {
    return this.ajaxURL;
  };
  TabulatorOptions.prototype.component38 = function () {
    return this.ajaxParams;
  };
  TabulatorOptions.prototype.component39 = function () {
    return this.ajaxConfig;
  };
  TabulatorOptions.prototype.component40 = function () {
    return this.ajaxContentType;
  };
  TabulatorOptions.prototype.component41 = function () {
    return this.ajaxURLGenerator;
  };
  TabulatorOptions.prototype.component42 = function () {
    return this.ajaxRequestFunc;
  };
  TabulatorOptions.prototype.component43 = function () {
    return this.progressiveLoad;
  };
  TabulatorOptions.prototype.component44 = function () {
    return this.progressiveLoadDelay;
  };
  TabulatorOptions.prototype.component45 = function () {
    return this.progressiveLoadScrollMargin;
  };
  TabulatorOptions.prototype.component46 = function () {
    return this.dataLoader;
  };
  TabulatorOptions.prototype.component47 = function () {
    return this.dataLoaderLoading;
  };
  TabulatorOptions.prototype.component48 = function () {
    return this.dataLoaderError;
  };
  TabulatorOptions.prototype.component49 = function () {
    return this.initialSort;
  };
  TabulatorOptions.prototype.component50 = function () {
    return this.sortOrderReverse;
  };
  TabulatorOptions.prototype.component51 = function () {
    return this.initialFilter;
  };
  TabulatorOptions.prototype.component52 = function () {
    return this.initialHeaderFilter;
  };
  TabulatorOptions.prototype.component53 = function () {
    return this.pagination;
  };
  TabulatorOptions.prototype.component54 = function () {
    return this.paginationMode;
  };
  TabulatorOptions.prototype.component55 = function () {
    return this.paginationSize;
  };
  TabulatorOptions.prototype.component56 = function () {
    return this.paginationSizeSelector;
  };
  TabulatorOptions.prototype.component57 = function () {
    return this.paginationElement;
  };
  TabulatorOptions.prototype.component58 = function () {
    return this.dataReceiveParams;
  };
  TabulatorOptions.prototype.component59 = function () {
    return this.dataSendParams;
  };
  TabulatorOptions.prototype.component60 = function () {
    return this.paginationAddRow;
  };
  TabulatorOptions.prototype.component61 = function () {
    return this.paginationButtonCount;
  };
  TabulatorOptions.prototype.component62 = function () {
    return this.persistenceID;
  };
  TabulatorOptions.prototype.component63 = function () {
    return this.persistenceMode;
  };
  TabulatorOptions.prototype.component64 = function () {
    return this.persistentLayout;
  };
  TabulatorOptions.prototype.component65 = function () {
    return this.persistentSort;
  };
  TabulatorOptions.prototype.component66 = function () {
    return this.persistentFilter;
  };
  TabulatorOptions.prototype.component67 = function () {
    return this.locale;
  };
  TabulatorOptions.prototype.component68 = function () {
    return this.langs;
  };
  TabulatorOptions.prototype.component69 = function () {
    return this.localized;
  };
  TabulatorOptions.prototype.component70 = function () {
    return this.headerVisible;
  };
  TabulatorOptions.prototype.component71 = function () {
    return this.htmlOutputConfig;
  };
  TabulatorOptions.prototype.component72 = function () {
    return this.printAsHtml;
  };
  TabulatorOptions.prototype.component73 = function () {
    return this.printConfig;
  };
  TabulatorOptions.prototype.component74 = function () {
    return this.printCopyStyle;
  };
  TabulatorOptions.prototype.component75 = function () {
    return this.printVisibleRows;
  };
  TabulatorOptions.prototype.component76 = function () {
    return this.printHeader;
  };
  TabulatorOptions.prototype.component77 = function () {
    return this.printFooter;
  };
  TabulatorOptions.prototype.component78 = function () {
    return this.printFormatter;
  };
  TabulatorOptions.prototype.component79 = function () {
    return this.tabEndNewRow;
  };
  TabulatorOptions.prototype.component80 = function () {
    return this.invalidOptionWarnings;
  };
  TabulatorOptions.prototype.component81 = function () {
    return this.dataTree;
  };
  TabulatorOptions.prototype.component82 = function () {
    return this.dataTreeChildField;
  };
  TabulatorOptions.prototype.component83 = function () {
    return this.dataTreeCollapseElement;
  };
  TabulatorOptions.prototype.component84 = function () {
    return this.dataTreeExpandElement;
  };
  TabulatorOptions.prototype.component85 = function () {
    return this.dataTreeElementColumn;
  };
  TabulatorOptions.prototype.component86 = function () {
    return this.dataTreeBranchElement;
  };
  TabulatorOptions.prototype.component87 = function () {
    return this.dataTreeChildIndent;
  };
  TabulatorOptions.prototype.component88 = function () {
    return this.dataTreeStartExpanded;
  };
  TabulatorOptions.prototype.component89 = function () {
    return this.ajaxRequesting;
  };
  TabulatorOptions.prototype.component90 = function () {
    return this.ajaxResponse;
  };
  TabulatorOptions.prototype.component91 = function () {
    return this.persistence;
  };
  TabulatorOptions.prototype.component92 = function () {
    return this.persistenceReaderFunc;
  };
  TabulatorOptions.prototype.component93 = function () {
    return this.persistenceWriterFunc;
  };
  TabulatorOptions.prototype.component94 = function () {
    return this.paginationInitialPage;
  };
  TabulatorOptions.prototype.component95 = function () {
    return this.columnHeaderVertAlign;
  };
  TabulatorOptions.prototype.component96 = function () {
    return this.maxHeight;
  };
  TabulatorOptions.prototype.component97 = function () {
    return this.minHeight;
  };
  TabulatorOptions.prototype.component98 = function () {
    return this.rowContextMenu;
  };
  TabulatorOptions.prototype.component99 = function () {
    return this.dataTreeChildColumnCalcs;
  };
  TabulatorOptions.prototype.component100 = function () {
    return this.dataTreeSelectPropagate;
  };
  TabulatorOptions.prototype.component101 = function () {
    return this.headerFilterLiveFilterDelay;
  };
  TabulatorOptions.prototype.component102 = function () {
    return this.textDirection;
  };
  TabulatorOptions.prototype.component103 = function () {
    return this.autoColumnsDefinitions;
  };
  TabulatorOptions.prototype.component104 = function () {
    return this.rowClickMenu;
  };
  TabulatorOptions.prototype.component105 = function () {
    return this.headerSortElement;
  };
  TabulatorOptions.prototype.component106 = function () {
    return this.dataTreeFilter;
  };
  TabulatorOptions.prototype.component107 = function () {
    return this.dataTreeSort;
  };
  TabulatorOptions.prototype.component108 = function () {
    return this.renderVertical;
  };
  TabulatorOptions.prototype.component109 = function () {
    return this.renderVerticalBuffer;
  };
  TabulatorOptions.prototype.component110 = function () {
    return this.renderHorizontal;
  };
  TabulatorOptions.prototype.component111 = function () {
    return this.columnDefaults;
  };
  TabulatorOptions.prototype.component112 = function () {
    return this.sortMode;
  };
  TabulatorOptions.prototype.component113 = function () {
    return this.filterMode;
  };
  TabulatorOptions.prototype.component114 = function () {
    return this.importFormat;
  };
  TabulatorOptions.prototype.component115 = function () {
    return this.importReader;
  };
  TabulatorOptions.prototype.component116 = function () {
    return this.dataLoaderErrorTimeout;
  };
  TabulatorOptions.prototype.component117 = function () {
    return this.popupContainer;
  };
  TabulatorOptions.prototype.component118 = function () {
    return this.paginationCounter;
  };
  TabulatorOptions.prototype.component119 = function () {
    return this.paginationCounterElement;
  };
  TabulatorOptions.prototype.component120 = function () {
    return this.rowClickPopup;
  };
  TabulatorOptions.prototype.component121 = function () {
    return this.rowContextPopup;
  };
  TabulatorOptions.prototype.component122 = function () {
    return this.resizableColumnFit;
  };
  TabulatorOptions.prototype.component123 = function () {
    return this.rowHeight;
  };
  TabulatorOptions.prototype.component124 = function () {
    return this.frozenRows;
  };
  TabulatorOptions.prototype.component125 = function () {
    return this.frozenRowsField;
  };
  TabulatorOptions.prototype.component126 = function () {
    return this.headerSortClickElement;
  };
  TabulatorOptions.prototype.component127 = function () {
    return this.rowDblClickPopup;
  };
  TabulatorOptions.prototype.component128 = function () {
    return this.rowDblClickMenu;
  };
  TabulatorOptions.prototype.copy_2gzzyy$ = function (height, placeholder, footerElement, tooltipGenerationMode, history, keybindings, downloadDataFormatter, downloadConfig, reactiveData, autoResize, columns, autoColumns, layout, layoutColumnsOnNewData, responsiveLayout, responsiveLayoutCollapseStartOpen, responsiveLayoutCollapseUseFormatters, movableColumns, scrollToColumnPosition, scrollToColumnIfVisible, rowFormatter, addRowPos, selectable, selectableRangeMode, selectableRollingSelection, selectablePersistence, selectableCheck, movableRows, movableRowsConnectedTables, movableRowsSender, movableRowsReceiver, resizableRows, scrollToRowPosition, scrollToRowIfVisible, index, data, ajaxURL, ajaxParams, ajaxConfig, ajaxContentType, ajaxURLGenerator, ajaxRequestFunc, progressiveLoad, progressiveLoadDelay, progressiveLoadScrollMargin, dataLoader, dataLoaderLoading, dataLoaderError, initialSort, sortOrderReverse, initialFilter, initialHeaderFilter, pagination, paginationMode, paginationSize, paginationSizeSelector, paginationElement, dataReceiveParams, dataSendParams, paginationAddRow, paginationButtonCount, persistenceID, persistenceMode, persistentLayout, persistentSort, persistentFilter, locale, langs, localized, headerVisible, htmlOutputConfig, printAsHtml, printConfig, printCopyStyle, printVisibleRows, printHeader, printFooter, printFormatter, tabEndNewRow, invalidOptionWarnings, dataTree, dataTreeChildField, dataTreeCollapseElement, dataTreeExpandElement, dataTreeElementColumn, dataTreeBranchElement, dataTreeChildIndent, dataTreeStartExpanded, ajaxRequesting, ajaxResponse, persistence, persistenceReaderFunc, persistenceWriterFunc, paginationInitialPage, columnHeaderVertAlign, maxHeight, minHeight, rowContextMenu, dataTreeChildColumnCalcs, dataTreeSelectPropagate, headerFilterLiveFilterDelay, textDirection, autoColumnsDefinitions, rowClickMenu, headerSortElement, dataTreeFilter, dataTreeSort, renderVertical, renderVerticalBuffer, renderHorizontal, columnDefaults, sortMode, filterMode, importFormat, importReader, dataLoaderErrorTimeout, popupContainer, paginationCounter, paginationCounterElement, rowClickPopup, rowContextPopup, resizableColumnFit, rowHeight, frozenRows, frozenRowsField, headerSortClickElement, rowDblClickPopup, rowDblClickMenu) {
    return new TabulatorOptions(height === void 0 ? this.height : height, placeholder === void 0 ? this.placeholder : placeholder, footerElement === void 0 ? this.footerElement : footerElement, tooltipGenerationMode === void 0 ? this.tooltipGenerationMode : tooltipGenerationMode, history === void 0 ? this.history : history, keybindings === void 0 ? this.keybindings : keybindings, downloadDataFormatter === void 0 ? this.downloadDataFormatter : downloadDataFormatter, downloadConfig === void 0 ? this.downloadConfig : downloadConfig, reactiveData === void 0 ? this.reactiveData : reactiveData, autoResize === void 0 ? this.autoResize : autoResize, columns === void 0 ? this.columns : columns, autoColumns === void 0 ? this.autoColumns : autoColumns, layout === void 0 ? this.layout : layout, layoutColumnsOnNewData === void 0 ? this.layoutColumnsOnNewData : layoutColumnsOnNewData, responsiveLayout === void 0 ? this.responsiveLayout : responsiveLayout, responsiveLayoutCollapseStartOpen === void 0 ? this.responsiveLayoutCollapseStartOpen : responsiveLayoutCollapseStartOpen, responsiveLayoutCollapseUseFormatters === void 0 ? this.responsiveLayoutCollapseUseFormatters : responsiveLayoutCollapseUseFormatters, movableColumns === void 0 ? this.movableColumns : movableColumns, scrollToColumnPosition === void 0 ? this.scrollToColumnPosition : scrollToColumnPosition, scrollToColumnIfVisible === void 0 ? this.scrollToColumnIfVisible : scrollToColumnIfVisible, rowFormatter === void 0 ? this.rowFormatter : rowFormatter, addRowPos === void 0 ? this.addRowPos : addRowPos, selectable === void 0 ? this.selectable : selectable, selectableRangeMode === void 0 ? this.selectableRangeMode : selectableRangeMode, selectableRollingSelection === void 0 ? this.selectableRollingSelection : selectableRollingSelection, selectablePersistence === void 0 ? this.selectablePersistence : selectablePersistence, selectableCheck === void 0 ? this.selectableCheck : selectableCheck, movableRows === void 0 ? this.movableRows : movableRows, movableRowsConnectedTables === void 0 ? this.movableRowsConnectedTables : movableRowsConnectedTables, movableRowsSender === void 0 ? this.movableRowsSender : movableRowsSender, movableRowsReceiver === void 0 ? this.movableRowsReceiver : movableRowsReceiver, resizableRows === void 0 ? this.resizableRows : resizableRows, scrollToRowPosition === void 0 ? this.scrollToRowPosition : scrollToRowPosition, scrollToRowIfVisible === void 0 ? this.scrollToRowIfVisible : scrollToRowIfVisible, index === void 0 ? this.index : index, data === void 0 ? this.data : data, ajaxURL === void 0 ? this.ajaxURL : ajaxURL, ajaxParams === void 0 ? this.ajaxParams : ajaxParams, ajaxConfig === void 0 ? this.ajaxConfig : ajaxConfig, ajaxContentType === void 0 ? this.ajaxContentType : ajaxContentType, ajaxURLGenerator === void 0 ? this.ajaxURLGenerator : ajaxURLGenerator, ajaxRequestFunc === void 0 ? this.ajaxRequestFunc : ajaxRequestFunc, progressiveLoad === void 0 ? this.progressiveLoad : progressiveLoad, progressiveLoadDelay === void 0 ? this.progressiveLoadDelay : progressiveLoadDelay, progressiveLoadScrollMargin === void 0 ? this.progressiveLoadScrollMargin : progressiveLoadScrollMargin, dataLoader === void 0 ? this.dataLoader : dataLoader, dataLoaderLoading === void 0 ? this.dataLoaderLoading : dataLoaderLoading, dataLoaderError === void 0 ? this.dataLoaderError : dataLoaderError, initialSort === void 0 ? this.initialSort : initialSort, sortOrderReverse === void 0 ? this.sortOrderReverse : sortOrderReverse, initialFilter === void 0 ? this.initialFilter : initialFilter, initialHeaderFilter === void 0 ? this.initialHeaderFilter : initialHeaderFilter, pagination === void 0 ? this.pagination : pagination, paginationMode === void 0 ? this.paginationMode : paginationMode, paginationSize === void 0 ? this.paginationSize : paginationSize, paginationSizeSelector === void 0 ? this.paginationSizeSelector : paginationSizeSelector, paginationElement === void 0 ? this.paginationElement : paginationElement, dataReceiveParams === void 0 ? this.dataReceiveParams : dataReceiveParams, dataSendParams === void 0 ? this.dataSendParams : dataSendParams, paginationAddRow === void 0 ? this.paginationAddRow : paginationAddRow, paginationButtonCount === void 0 ? this.paginationButtonCount : paginationButtonCount, persistenceID === void 0 ? this.persistenceID : persistenceID, persistenceMode === void 0 ? this.persistenceMode : persistenceMode, persistentLayout === void 0 ? this.persistentLayout : persistentLayout, persistentSort === void 0 ? this.persistentSort : persistentSort, persistentFilter === void 0 ? this.persistentFilter : persistentFilter, locale === void 0 ? this.locale : locale, langs === void 0 ? this.langs : langs, localized === void 0 ? this.localized : localized, headerVisible === void 0 ? this.headerVisible : headerVisible, htmlOutputConfig === void 0 ? this.htmlOutputConfig : htmlOutputConfig, printAsHtml === void 0 ? this.printAsHtml : printAsHtml, printConfig === void 0 ? this.printConfig : printConfig, printCopyStyle === void 0 ? this.printCopyStyle : printCopyStyle, printVisibleRows === void 0 ? this.printVisibleRows : printVisibleRows, printHeader === void 0 ? this.printHeader : printHeader, printFooter === void 0 ? this.printFooter : printFooter, printFormatter === void 0 ? this.printFormatter : printFormatter, tabEndNewRow === void 0 ? this.tabEndNewRow : tabEndNewRow, invalidOptionWarnings === void 0 ? this.invalidOptionWarnings : invalidOptionWarnings, dataTree === void 0 ? this.dataTree : dataTree, dataTreeChildField === void 0 ? this.dataTreeChildField : dataTreeChildField, dataTreeCollapseElement === void 0 ? this.dataTreeCollapseElement : dataTreeCollapseElement, dataTreeExpandElement === void 0 ? this.dataTreeExpandElement : dataTreeExpandElement, dataTreeElementColumn === void 0 ? this.dataTreeElementColumn : dataTreeElementColumn, dataTreeBranchElement === void 0 ? this.dataTreeBranchElement : dataTreeBranchElement, dataTreeChildIndent === void 0 ? this.dataTreeChildIndent : dataTreeChildIndent, dataTreeStartExpanded === void 0 ? this.dataTreeStartExpanded : dataTreeStartExpanded, ajaxRequesting === void 0 ? this.ajaxRequesting : ajaxRequesting, ajaxResponse === void 0 ? this.ajaxResponse : ajaxResponse, persistence === void 0 ? this.persistence : persistence, persistenceReaderFunc === void 0 ? this.persistenceReaderFunc : persistenceReaderFunc, persistenceWriterFunc === void 0 ? this.persistenceWriterFunc : persistenceWriterFunc, paginationInitialPage === void 0 ? this.paginationInitialPage : paginationInitialPage, columnHeaderVertAlign === void 0 ? this.columnHeaderVertAlign : columnHeaderVertAlign, maxHeight === void 0 ? this.maxHeight : maxHeight, minHeight === void 0 ? this.minHeight : minHeight, rowContextMenu === void 0 ? this.rowContextMenu : rowContextMenu, dataTreeChildColumnCalcs === void 0 ? this.dataTreeChildColumnCalcs : dataTreeChildColumnCalcs, dataTreeSelectPropagate === void 0 ? this.dataTreeSelectPropagate : dataTreeSelectPropagate, headerFilterLiveFilterDelay === void 0 ? this.headerFilterLiveFilterDelay : headerFilterLiveFilterDelay, textDirection === void 0 ? this.textDirection : textDirection, autoColumnsDefinitions === void 0 ? this.autoColumnsDefinitions : autoColumnsDefinitions, rowClickMenu === void 0 ? this.rowClickMenu : rowClickMenu, headerSortElement === void 0 ? this.headerSortElement : headerSortElement, dataTreeFilter === void 0 ? this.dataTreeFilter : dataTreeFilter, dataTreeSort === void 0 ? this.dataTreeSort : dataTreeSort, renderVertical === void 0 ? this.renderVertical : renderVertical, renderVerticalBuffer === void 0 ? this.renderVerticalBuffer : renderVerticalBuffer, renderHorizontal === void 0 ? this.renderHorizontal : renderHorizontal, columnDefaults === void 0 ? this.columnDefaults : columnDefaults, sortMode === void 0 ? this.sortMode : sortMode, filterMode === void 0 ? this.filterMode : filterMode, importFormat === void 0 ? this.importFormat : importFormat, importReader === void 0 ? this.importReader : importReader, dataLoaderErrorTimeout === void 0 ? this.dataLoaderErrorTimeout : dataLoaderErrorTimeout, popupContainer === void 0 ? this.popupContainer : popupContainer, paginationCounter === void 0 ? this.paginationCounter : paginationCounter, paginationCounterElement === void 0 ? this.paginationCounterElement : paginationCounterElement, rowClickPopup === void 0 ? this.rowClickPopup : rowClickPopup, rowContextPopup === void 0 ? this.rowContextPopup : rowContextPopup, resizableColumnFit === void 0 ? this.resizableColumnFit : resizableColumnFit, rowHeight === void 0 ? this.rowHeight : rowHeight, frozenRows === void 0 ? this.frozenRows : frozenRows, frozenRowsField === void 0 ? this.frozenRowsField : frozenRowsField, headerSortClickElement === void 0 ? this.headerSortClickElement : headerSortClickElement, rowDblClickPopup === void 0 ? this.rowDblClickPopup : rowDblClickPopup, rowDblClickMenu === void 0 ? this.rowDblClickMenu : rowDblClickMenu);
  };
  TabulatorOptions.prototype.toString = function () {
    return 'TabulatorOptions(height=' + Kotlin.toString(this.height) + (', placeholder=' + Kotlin.toString(this.placeholder)) + (', footerElement=' + Kotlin.toString(this.footerElement)) + (', tooltipGenerationMode=' + Kotlin.toString(this.tooltipGenerationMode)) + (', history=' + Kotlin.toString(this.history)) + (', keybindings=' + Kotlin.toString(this.keybindings)) + (', downloadDataFormatter=' + Kotlin.toString(this.downloadDataFormatter)) + (', downloadConfig=' + Kotlin.toString(this.downloadConfig)) + (', reactiveData=' + Kotlin.toString(this.reactiveData)) + (', autoResize=' + Kotlin.toString(this.autoResize)) + (', columns=' + Kotlin.toString(this.columns)) + (', autoColumns=' + Kotlin.toString(this.autoColumns)) + (', layout=' + Kotlin.toString(this.layout)) + (', layoutColumnsOnNewData=' + Kotlin.toString(this.layoutColumnsOnNewData)) + (', responsiveLayout=' + Kotlin.toString(this.responsiveLayout)) + (', responsiveLayoutCollapseStartOpen=' + Kotlin.toString(this.responsiveLayoutCollapseStartOpen)) + (', responsiveLayoutCollapseUseFormatters=' + Kotlin.toString(this.responsiveLayoutCollapseUseFormatters)) + (', movableColumns=' + Kotlin.toString(this.movableColumns)) + (', scrollToColumnPosition=' + Kotlin.toString(this.scrollToColumnPosition)) + (', scrollToColumnIfVisible=' + Kotlin.toString(this.scrollToColumnIfVisible)) + (', rowFormatter=' + Kotlin.toString(this.rowFormatter)) + (', addRowPos=' + Kotlin.toString(this.addRowPos)) + (', selectable=' + Kotlin.toString(this.selectable)) + (', selectableRangeMode=' + Kotlin.toString(this.selectableRangeMode)) + (', selectableRollingSelection=' + Kotlin.toString(this.selectableRollingSelection)) + (', selectablePersistence=' + Kotlin.toString(this.selectablePersistence)) + (', selectableCheck=' + Kotlin.toString(this.selectableCheck)) + (', movableRows=' + Kotlin.toString(this.movableRows)) + (', movableRowsConnectedTables=' + Kotlin.toString(this.movableRowsConnectedTables)) + (', movableRowsSender=' + Kotlin.toString(this.movableRowsSender)) + (', movableRowsReceiver=' + Kotlin.toString(this.movableRowsReceiver)) + (', resizableRows=' + Kotlin.toString(this.resizableRows)) + (', scrollToRowPosition=' + Kotlin.toString(this.scrollToRowPosition)) + (', scrollToRowIfVisible=' + Kotlin.toString(this.scrollToRowIfVisible)) + (', index=' + Kotlin.toString(this.index)) + (', data=' + Kotlin.toString(this.data)) + (', ajaxURL=' + Kotlin.toString(this.ajaxURL)) + (', ajaxParams=' + Kotlin.toString(this.ajaxParams)) + (', ajaxConfig=' + Kotlin.toString(this.ajaxConfig)) + (', ajaxContentType=' + Kotlin.toString(this.ajaxContentType)) + (', ajaxURLGenerator=' + Kotlin.toString(this.ajaxURLGenerator)) + (', ajaxRequestFunc=' + Kotlin.toString(this.ajaxRequestFunc)) + (', progressiveLoad=' + Kotlin.toString(this.progressiveLoad)) + (', progressiveLoadDelay=' + Kotlin.toString(this.progressiveLoadDelay)) + (', progressiveLoadScrollMargin=' + Kotlin.toString(this.progressiveLoadScrollMargin)) + (', dataLoader=' + Kotlin.toString(this.dataLoader)) + (', dataLoaderLoading=' + Kotlin.toString(this.dataLoaderLoading)) + (', dataLoaderError=' + Kotlin.toString(this.dataLoaderError)) + (', initialSort=' + Kotlin.toString(this.initialSort)) + (', sortOrderReverse=' + Kotlin.toString(this.sortOrderReverse)) + (', initialFilter=' + Kotlin.toString(this.initialFilter)) + (', initialHeaderFilter=' + Kotlin.toString(this.initialHeaderFilter)) + (', pagination=' + Kotlin.toString(this.pagination)) + (', paginationMode=' + Kotlin.toString(this.paginationMode)) + (', paginationSize=' + Kotlin.toString(this.paginationSize)) + (', paginationSizeSelector=' + Kotlin.toString(this.paginationSizeSelector)) + (', paginationElement=' + Kotlin.toString(this.paginationElement)) + (', dataReceiveParams=' + Kotlin.toString(this.dataReceiveParams)) + (', dataSendParams=' + Kotlin.toString(this.dataSendParams)) + (', paginationAddRow=' + Kotlin.toString(this.paginationAddRow)) + (', paginationButtonCount=' + Kotlin.toString(this.paginationButtonCount)) + (', persistenceID=' + Kotlin.toString(this.persistenceID)) + (', persistenceMode=' + Kotlin.toString(this.persistenceMode)) + (', persistentLayout=' + Kotlin.toString(this.persistentLayout)) + (', persistentSort=' + Kotlin.toString(this.persistentSort)) + (', persistentFilter=' + Kotlin.toString(this.persistentFilter)) + (', locale=' + Kotlin.toString(this.locale)) + (', langs=' + Kotlin.toString(this.langs)) + (', localized=' + Kotlin.toString(this.localized)) + (', headerVisible=' + Kotlin.toString(this.headerVisible)) + (', htmlOutputConfig=' + Kotlin.toString(this.htmlOutputConfig)) + (', printAsHtml=' + Kotlin.toString(this.printAsHtml)) + (', printConfig=' + Kotlin.toString(this.printConfig)) + (', printCopyStyle=' + Kotlin.toString(this.printCopyStyle)) + (', printVisibleRows=' + Kotlin.toString(this.printVisibleRows)) + (', printHeader=' + Kotlin.toString(this.printHeader)) + (', printFooter=' + Kotlin.toString(this.printFooter)) + (', printFormatter=' + Kotlin.toString(this.printFormatter)) + (', tabEndNewRow=' + Kotlin.toString(this.tabEndNewRow)) + (', invalidOptionWarnings=' + Kotlin.toString(this.invalidOptionWarnings)) + (', dataTree=' + Kotlin.toString(this.dataTree)) + (', dataTreeChildField=' + Kotlin.toString(this.dataTreeChildField)) + (', dataTreeCollapseElement=' + Kotlin.toString(this.dataTreeCollapseElement)) + (', dataTreeExpandElement=' + Kotlin.toString(this.dataTreeExpandElement)) + (', dataTreeElementColumn=' + Kotlin.toString(this.dataTreeElementColumn)) + (', dataTreeBranchElement=' + Kotlin.toString(this.dataTreeBranchElement)) + (', dataTreeChildIndent=' + Kotlin.toString(this.dataTreeChildIndent)) + (', dataTreeStartExpanded=' + Kotlin.toString(this.dataTreeStartExpanded)) + (', ajaxRequesting=' + Kotlin.toString(this.ajaxRequesting)) + (', ajaxResponse=' + Kotlin.toString(this.ajaxResponse)) + (', persistence=' + Kotlin.toString(this.persistence)) + (', persistenceReaderFunc=' + Kotlin.toString(this.persistenceReaderFunc)) + (', persistenceWriterFunc=' + Kotlin.toString(this.persistenceWriterFunc)) + (', paginationInitialPage=' + Kotlin.toString(this.paginationInitialPage)) + (', columnHeaderVertAlign=' + Kotlin.toString(this.columnHeaderVertAlign)) + (', maxHeight=' + Kotlin.toString(this.maxHeight)) + (', minHeight=' + Kotlin.toString(this.minHeight)) + (', rowContextMenu=' + Kotlin.toString(this.rowContextMenu)) + (', dataTreeChildColumnCalcs=' + Kotlin.toString(this.dataTreeChildColumnCalcs)) + (', dataTreeSelectPropagate=' + Kotlin.toString(this.dataTreeSelectPropagate)) + (', headerFilterLiveFilterDelay=' + Kotlin.toString(this.headerFilterLiveFilterDelay)) + (', textDirection=' + Kotlin.toString(this.textDirection)) + (', autoColumnsDefinitions=' + Kotlin.toString(this.autoColumnsDefinitions)) + (', rowClickMenu=' + Kotlin.toString(this.rowClickMenu)) + (', headerSortElement=' + Kotlin.toString(this.headerSortElement)) + (', dataTreeFilter=' + Kotlin.toString(this.dataTreeFilter)) + (', dataTreeSort=' + Kotlin.toString(this.dataTreeSort)) + (', renderVertical=' + Kotlin.toString(this.renderVertical)) + (', renderVerticalBuffer=' + Kotlin.toString(this.renderVerticalBuffer)) + (', renderHorizontal=' + Kotlin.toString(this.renderHorizontal)) + (', columnDefaults=' + Kotlin.toString(this.columnDefaults)) + (', sortMode=' + Kotlin.toString(this.sortMode)) + (', filterMode=' + Kotlin.toString(this.filterMode)) + (', importFormat=' + Kotlin.toString(this.importFormat)) + (', importReader=' + Kotlin.toString(this.importReader)) + (', dataLoaderErrorTimeout=' + Kotlin.toString(this.dataLoaderErrorTimeout)) + (', popupContainer=' + Kotlin.toString(this.popupContainer)) + (', paginationCounter=' + Kotlin.toString(this.paginationCounter)) + (', paginationCounterElement=' + Kotlin.toString(this.paginationCounterElement)) + (', rowClickPopup=' + Kotlin.toString(this.rowClickPopup)) + (', rowContextPopup=' + Kotlin.toString(this.rowContextPopup)) + (', resizableColumnFit=' + Kotlin.toString(this.resizableColumnFit)) + (', rowHeight=' + Kotlin.toString(this.rowHeight)) + (', frozenRows=' + Kotlin.toString(this.frozenRows)) + (', frozenRowsField=' + Kotlin.toString(this.frozenRowsField)) + (', headerSortClickElement=' + Kotlin.toString(this.headerSortClickElement)) + (', rowDblClickPopup=' + Kotlin.toString(this.rowDblClickPopup)) + (', rowDblClickMenu=' + Kotlin.toString(this.rowDblClickMenu)) + ')';
  };
  TabulatorOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.height) | 0;
    result = result * 31 + Kotlin.hashCode(this.placeholder) | 0;
    result = result * 31 + Kotlin.hashCode(this.footerElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.tooltipGenerationMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.history) | 0;
    result = result * 31 + Kotlin.hashCode(this.keybindings) | 0;
    result = result * 31 + Kotlin.hashCode(this.downloadDataFormatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.downloadConfig) | 0;
    result = result * 31 + Kotlin.hashCode(this.reactiveData) | 0;
    result = result * 31 + Kotlin.hashCode(this.autoResize) | 0;
    result = result * 31 + Kotlin.hashCode(this.columns) | 0;
    result = result * 31 + Kotlin.hashCode(this.autoColumns) | 0;
    result = result * 31 + Kotlin.hashCode(this.layout) | 0;
    result = result * 31 + Kotlin.hashCode(this.layoutColumnsOnNewData) | 0;
    result = result * 31 + Kotlin.hashCode(this.responsiveLayout) | 0;
    result = result * 31 + Kotlin.hashCode(this.responsiveLayoutCollapseStartOpen) | 0;
    result = result * 31 + Kotlin.hashCode(this.responsiveLayoutCollapseUseFormatters) | 0;
    result = result * 31 + Kotlin.hashCode(this.movableColumns) | 0;
    result = result * 31 + Kotlin.hashCode(this.scrollToColumnPosition) | 0;
    result = result * 31 + Kotlin.hashCode(this.scrollToColumnIfVisible) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowFormatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.addRowPos) | 0;
    result = result * 31 + Kotlin.hashCode(this.selectable) | 0;
    result = result * 31 + Kotlin.hashCode(this.selectableRangeMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.selectableRollingSelection) | 0;
    result = result * 31 + Kotlin.hashCode(this.selectablePersistence) | 0;
    result = result * 31 + Kotlin.hashCode(this.selectableCheck) | 0;
    result = result * 31 + Kotlin.hashCode(this.movableRows) | 0;
    result = result * 31 + Kotlin.hashCode(this.movableRowsConnectedTables) | 0;
    result = result * 31 + Kotlin.hashCode(this.movableRowsSender) | 0;
    result = result * 31 + Kotlin.hashCode(this.movableRowsReceiver) | 0;
    result = result * 31 + Kotlin.hashCode(this.resizableRows) | 0;
    result = result * 31 + Kotlin.hashCode(this.scrollToRowPosition) | 0;
    result = result * 31 + Kotlin.hashCode(this.scrollToRowIfVisible) | 0;
    result = result * 31 + Kotlin.hashCode(this.index) | 0;
    result = result * 31 + Kotlin.hashCode(this.data) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxURL) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxConfig) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxContentType) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxURLGenerator) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxRequestFunc) | 0;
    result = result * 31 + Kotlin.hashCode(this.progressiveLoad) | 0;
    result = result * 31 + Kotlin.hashCode(this.progressiveLoadDelay) | 0;
    result = result * 31 + Kotlin.hashCode(this.progressiveLoadScrollMargin) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataLoader) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataLoaderLoading) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataLoaderError) | 0;
    result = result * 31 + Kotlin.hashCode(this.initialSort) | 0;
    result = result * 31 + Kotlin.hashCode(this.sortOrderReverse) | 0;
    result = result * 31 + Kotlin.hashCode(this.initialFilter) | 0;
    result = result * 31 + Kotlin.hashCode(this.initialHeaderFilter) | 0;
    result = result * 31 + Kotlin.hashCode(this.pagination) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationSize) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationSizeSelector) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataReceiveParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataSendParams) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationAddRow) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationButtonCount) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistenceID) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistenceMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistentLayout) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistentSort) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistentFilter) | 0;
    result = result * 31 + Kotlin.hashCode(this.locale) | 0;
    result = result * 31 + Kotlin.hashCode(this.langs) | 0;
    result = result * 31 + Kotlin.hashCode(this.localized) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerVisible) | 0;
    result = result * 31 + Kotlin.hashCode(this.htmlOutputConfig) | 0;
    result = result * 31 + Kotlin.hashCode(this.printAsHtml) | 0;
    result = result * 31 + Kotlin.hashCode(this.printConfig) | 0;
    result = result * 31 + Kotlin.hashCode(this.printCopyStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.printVisibleRows) | 0;
    result = result * 31 + Kotlin.hashCode(this.printHeader) | 0;
    result = result * 31 + Kotlin.hashCode(this.printFooter) | 0;
    result = result * 31 + Kotlin.hashCode(this.printFormatter) | 0;
    result = result * 31 + Kotlin.hashCode(this.tabEndNewRow) | 0;
    result = result * 31 + Kotlin.hashCode(this.invalidOptionWarnings) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTree) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeChildField) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeCollapseElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeExpandElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeElementColumn) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeBranchElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeChildIndent) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeStartExpanded) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxRequesting) | 0;
    result = result * 31 + Kotlin.hashCode(this.ajaxResponse) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistence) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistenceReaderFunc) | 0;
    result = result * 31 + Kotlin.hashCode(this.persistenceWriterFunc) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationInitialPage) | 0;
    result = result * 31 + Kotlin.hashCode(this.columnHeaderVertAlign) | 0;
    result = result * 31 + Kotlin.hashCode(this.maxHeight) | 0;
    result = result * 31 + Kotlin.hashCode(this.minHeight) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowContextMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeChildColumnCalcs) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeSelectPropagate) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerFilterLiveFilterDelay) | 0;
    result = result * 31 + Kotlin.hashCode(this.textDirection) | 0;
    result = result * 31 + Kotlin.hashCode(this.autoColumnsDefinitions) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowClickMenu) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerSortElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeFilter) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataTreeSort) | 0;
    result = result * 31 + Kotlin.hashCode(this.renderVertical) | 0;
    result = result * 31 + Kotlin.hashCode(this.renderVerticalBuffer) | 0;
    result = result * 31 + Kotlin.hashCode(this.renderHorizontal) | 0;
    result = result * 31 + Kotlin.hashCode(this.columnDefaults) | 0;
    result = result * 31 + Kotlin.hashCode(this.sortMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.filterMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.importFormat) | 0;
    result = result * 31 + Kotlin.hashCode(this.importReader) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataLoaderErrorTimeout) | 0;
    result = result * 31 + Kotlin.hashCode(this.popupContainer) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationCounter) | 0;
    result = result * 31 + Kotlin.hashCode(this.paginationCounterElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowClickPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowContextPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.resizableColumnFit) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowHeight) | 0;
    result = result * 31 + Kotlin.hashCode(this.frozenRows) | 0;
    result = result * 31 + Kotlin.hashCode(this.frozenRowsField) | 0;
    result = result * 31 + Kotlin.hashCode(this.headerSortClickElement) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowDblClickPopup) | 0;
    result = result * 31 + Kotlin.hashCode(this.rowDblClickMenu) | 0;
    return result;
  };
  TabulatorOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.height, other.height) && Kotlin.equals(this.placeholder, other.placeholder) && Kotlin.equals(this.footerElement, other.footerElement) && Kotlin.equals(this.tooltipGenerationMode, other.tooltipGenerationMode) && Kotlin.equals(this.history, other.history) && Kotlin.equals(this.keybindings, other.keybindings) && Kotlin.equals(this.downloadDataFormatter, other.downloadDataFormatter) && Kotlin.equals(this.downloadConfig, other.downloadConfig) && Kotlin.equals(this.reactiveData, other.reactiveData) && Kotlin.equals(this.autoResize, other.autoResize) && Kotlin.equals(this.columns, other.columns) && Kotlin.equals(this.autoColumns, other.autoColumns) && Kotlin.equals(this.layout, other.layout) && Kotlin.equals(this.layoutColumnsOnNewData, other.layoutColumnsOnNewData) && Kotlin.equals(this.responsiveLayout, other.responsiveLayout) && Kotlin.equals(this.responsiveLayoutCollapseStartOpen, other.responsiveLayoutCollapseStartOpen) && Kotlin.equals(this.responsiveLayoutCollapseUseFormatters, other.responsiveLayoutCollapseUseFormatters) && Kotlin.equals(this.movableColumns, other.movableColumns) && Kotlin.equals(this.scrollToColumnPosition, other.scrollToColumnPosition) && Kotlin.equals(this.scrollToColumnIfVisible, other.scrollToColumnIfVisible) && Kotlin.equals(this.rowFormatter, other.rowFormatter) && Kotlin.equals(this.addRowPos, other.addRowPos) && Kotlin.equals(this.selectable, other.selectable) && Kotlin.equals(this.selectableRangeMode, other.selectableRangeMode) && Kotlin.equals(this.selectableRollingSelection, other.selectableRollingSelection) && Kotlin.equals(this.selectablePersistence, other.selectablePersistence) && Kotlin.equals(this.selectableCheck, other.selectableCheck) && Kotlin.equals(this.movableRows, other.movableRows) && Kotlin.equals(this.movableRowsConnectedTables, other.movableRowsConnectedTables) && Kotlin.equals(this.movableRowsSender, other.movableRowsSender) && Kotlin.equals(this.movableRowsReceiver, other.movableRowsReceiver) && Kotlin.equals(this.resizableRows, other.resizableRows) && Kotlin.equals(this.scrollToRowPosition, other.scrollToRowPosition) && Kotlin.equals(this.scrollToRowIfVisible, other.scrollToRowIfVisible) && Kotlin.equals(this.index, other.index) && Kotlin.equals(this.data, other.data) && Kotlin.equals(this.ajaxURL, other.ajaxURL) && Kotlin.equals(this.ajaxParams, other.ajaxParams) && Kotlin.equals(this.ajaxConfig, other.ajaxConfig) && Kotlin.equals(this.ajaxContentType, other.ajaxContentType) && Kotlin.equals(this.ajaxURLGenerator, other.ajaxURLGenerator) && Kotlin.equals(this.ajaxRequestFunc, other.ajaxRequestFunc) && Kotlin.equals(this.progressiveLoad, other.progressiveLoad) && Kotlin.equals(this.progressiveLoadDelay, other.progressiveLoadDelay) && Kotlin.equals(this.progressiveLoadScrollMargin, other.progressiveLoadScrollMargin) && Kotlin.equals(this.dataLoader, other.dataLoader) && Kotlin.equals(this.dataLoaderLoading, other.dataLoaderLoading) && Kotlin.equals(this.dataLoaderError, other.dataLoaderError) && Kotlin.equals(this.initialSort, other.initialSort) && Kotlin.equals(this.sortOrderReverse, other.sortOrderReverse) && Kotlin.equals(this.initialFilter, other.initialFilter) && Kotlin.equals(this.initialHeaderFilter, other.initialHeaderFilter) && Kotlin.equals(this.pagination, other.pagination) && Kotlin.equals(this.paginationMode, other.paginationMode) && Kotlin.equals(this.paginationSize, other.paginationSize) && Kotlin.equals(this.paginationSizeSelector, other.paginationSizeSelector) && Kotlin.equals(this.paginationElement, other.paginationElement) && Kotlin.equals(this.dataReceiveParams, other.dataReceiveParams) && Kotlin.equals(this.dataSendParams, other.dataSendParams) && Kotlin.equals(this.paginationAddRow, other.paginationAddRow) && Kotlin.equals(this.paginationButtonCount, other.paginationButtonCount) && Kotlin.equals(this.persistenceID, other.persistenceID) && Kotlin.equals(this.persistenceMode, other.persistenceMode) && Kotlin.equals(this.persistentLayout, other.persistentLayout) && Kotlin.equals(this.persistentSort, other.persistentSort) && Kotlin.equals(this.persistentFilter, other.persistentFilter) && Kotlin.equals(this.locale, other.locale) && Kotlin.equals(this.langs, other.langs) && Kotlin.equals(this.localized, other.localized) && Kotlin.equals(this.headerVisible, other.headerVisible) && Kotlin.equals(this.htmlOutputConfig, other.htmlOutputConfig) && Kotlin.equals(this.printAsHtml, other.printAsHtml) && Kotlin.equals(this.printConfig, other.printConfig) && Kotlin.equals(this.printCopyStyle, other.printCopyStyle) && Kotlin.equals(this.printVisibleRows, other.printVisibleRows) && Kotlin.equals(this.printHeader, other.printHeader) && Kotlin.equals(this.printFooter, other.printFooter) && Kotlin.equals(this.printFormatter, other.printFormatter) && Kotlin.equals(this.tabEndNewRow, other.tabEndNewRow) && Kotlin.equals(this.invalidOptionWarnings, other.invalidOptionWarnings) && Kotlin.equals(this.dataTree, other.dataTree) && Kotlin.equals(this.dataTreeChildField, other.dataTreeChildField) && Kotlin.equals(this.dataTreeCollapseElement, other.dataTreeCollapseElement) && Kotlin.equals(this.dataTreeExpandElement, other.dataTreeExpandElement) && Kotlin.equals(this.dataTreeElementColumn, other.dataTreeElementColumn) && Kotlin.equals(this.dataTreeBranchElement, other.dataTreeBranchElement) && Kotlin.equals(this.dataTreeChildIndent, other.dataTreeChildIndent) && Kotlin.equals(this.dataTreeStartExpanded, other.dataTreeStartExpanded) && Kotlin.equals(this.ajaxRequesting, other.ajaxRequesting) && Kotlin.equals(this.ajaxResponse, other.ajaxResponse) && Kotlin.equals(this.persistence, other.persistence) && Kotlin.equals(this.persistenceReaderFunc, other.persistenceReaderFunc) && Kotlin.equals(this.persistenceWriterFunc, other.persistenceWriterFunc) && Kotlin.equals(this.paginationInitialPage, other.paginationInitialPage) && Kotlin.equals(this.columnHeaderVertAlign, other.columnHeaderVertAlign) && Kotlin.equals(this.maxHeight, other.maxHeight) && Kotlin.equals(this.minHeight, other.minHeight) && Kotlin.equals(this.rowContextMenu, other.rowContextMenu) && Kotlin.equals(this.dataTreeChildColumnCalcs, other.dataTreeChildColumnCalcs) && Kotlin.equals(this.dataTreeSelectPropagate, other.dataTreeSelectPropagate) && Kotlin.equals(this.headerFilterLiveFilterDelay, other.headerFilterLiveFilterDelay) && Kotlin.equals(this.textDirection, other.textDirection) && Kotlin.equals(this.autoColumnsDefinitions, other.autoColumnsDefinitions) && Kotlin.equals(this.rowClickMenu, other.rowClickMenu) && Kotlin.equals(this.headerSortElement, other.headerSortElement) && Kotlin.equals(this.dataTreeFilter, other.dataTreeFilter) && Kotlin.equals(this.dataTreeSort, other.dataTreeSort) && Kotlin.equals(this.renderVertical, other.renderVertical) && Kotlin.equals(this.renderVerticalBuffer, other.renderVerticalBuffer) && Kotlin.equals(this.renderHorizontal, other.renderHorizontal) && Kotlin.equals(this.columnDefaults, other.columnDefaults) && Kotlin.equals(this.sortMode, other.sortMode) && Kotlin.equals(this.filterMode, other.filterMode) && Kotlin.equals(this.importFormat, other.importFormat) && Kotlin.equals(this.importReader, other.importReader) && Kotlin.equals(this.dataLoaderErrorTimeout, other.dataLoaderErrorTimeout) && Kotlin.equals(this.popupContainer, other.popupContainer) && Kotlin.equals(this.paginationCounter, other.paginationCounter) && Kotlin.equals(this.paginationCounterElement, other.paginationCounterElement) && Kotlin.equals(this.rowClickPopup, other.rowClickPopup) && Kotlin.equals(this.rowContextPopup, other.rowContextPopup) && Kotlin.equals(this.resizableColumnFit, other.resizableColumnFit) && Kotlin.equals(this.rowHeight, other.rowHeight) && Kotlin.equals(this.frozenRows, other.frozenRows) && Kotlin.equals(this.frozenRowsField, other.frozenRowsField) && Kotlin.equals(this.headerSortClickElement, other.headerSortClickElement) && Kotlin.equals(this.rowDblClickPopup, other.rowDblClickPopup) && Kotlin.equals(this.rowDblClickMenu, other.rowDblClickMenu)))));
  };
  function toJs_1($receiver, tabulator, i18nTranslator, kClass) {
    var tmp$;
    var $receiver_0 = new Object_init();
    if ($receiver.height != null)
      $receiver_0.height = $receiver.height;
    if ($receiver.placeholder != null)
      $receiver_0.placeholder = i18nTranslator($receiver.placeholder);
    if ($receiver.footerElement != null)
      $receiver_0.footerElement = i18nTranslator($receiver.footerElement);
    if ($receiver.history != null)
      $receiver_0.history = $receiver.history;
    if ($receiver.keybindings != null)
      $receiver_0.keybindings = $receiver.keybindings;
    if ($receiver.downloadDataFormatter != null)
      $receiver_0.downloadDataFormatter = $receiver.downloadDataFormatter;
    if ($receiver.downloadConfig != null)
      $receiver_0.downloadConfig = toJs($receiver.downloadConfig);
    if ($receiver.reactiveData != null)
      $receiver_0.reactiveData = $receiver.reactiveData;
    if ($receiver.autoResize != null)
      $receiver_0.autoResize = $receiver.autoResize;
    if ($receiver.columns != null) {
      var $receiver_1 = $receiver.columns;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$_0;
      tmp$_0 = $receiver_1.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        destination.add_11rb$(toJs_0(item, tabulator, i18nTranslator, kClass));
      }
      $receiver_0.columns = copyToArray(destination);
    }if ($receiver.autoColumns != null) {
      $receiver_0.autoColumns = $receiver.autoColumns;
    } else if ($receiver.columns == null) {
      $receiver_0.autoColumns = true;
    }if ($receiver.layout != null)
      $receiver_0.layout = $receiver.layout.layout_8be2vx$;
    if ($receiver.layoutColumnsOnNewData != null)
      $receiver_0.layoutColumnsOnNewData = $receiver.layoutColumnsOnNewData;
    if ($receiver.responsiveLayout != null)
      $receiver_0.responsiveLayout = $receiver.responsiveLayout.layout_8be2vx$;
    if ($receiver.responsiveLayoutCollapseStartOpen != null)
      $receiver_0.responsiveLayoutCollapseStartOpen = $receiver.responsiveLayoutCollapseStartOpen;
    if ($receiver.responsiveLayoutCollapseUseFormatters != null)
      $receiver_0.responsiveLayoutCollapseUseFormatters = $receiver.responsiveLayoutCollapseUseFormatters;
    if ($receiver.movableColumns != null)
      $receiver_0.movableColumns = $receiver.movableColumns;
    if ($receiver.scrollToColumnPosition != null)
      $receiver_0.scrollToColumnPosition = $receiver.scrollToColumnPosition.position_8be2vx$;
    if ($receiver.scrollToColumnIfVisible != null)
      $receiver_0.scrollToColumnIfVisible = $receiver.scrollToColumnIfVisible;
    if ($receiver.rowFormatter != null)
      $receiver_0.rowFormatter = $receiver.rowFormatter;
    if ($receiver.addRowPos != null)
      $receiver_0.addRowPos = $receiver.addRowPos.position_8be2vx$;
    if ($receiver.selectable != null)
      $receiver_0.selectable = $receiver.selectable;
    if ($receiver.selectableRangeMode != null)
      $receiver_0.selectableRangeMode = $receiver.selectableRangeMode.mode_8be2vx$;
    if ($receiver.selectableRollingSelection != null)
      $receiver_0.selectableRollingSelection = $receiver.selectableRollingSelection;
    if ($receiver.selectablePersistence != null)
      $receiver_0.selectablePersistence = $receiver.selectablePersistence;
    if ($receiver.selectableCheck != null)
      $receiver_0.selectableCheck = $receiver.selectableCheck;
    if ($receiver.movableRows != null)
      $receiver_0.movableRows = $receiver.movableRows;
    if ($receiver.movableRowsConnectedTables != null)
      $receiver_0.movableRowsConnectedTables = $receiver.movableRowsConnectedTables;
    if ($receiver.movableRowsSender != null)
      $receiver_0.movableRowsSender = $receiver.movableRowsSender;
    if ($receiver.movableRowsReceiver != null)
      $receiver_0.movableRowsReceiver = $receiver.movableRowsReceiver;
    if ($receiver.resizableRows != null)
      $receiver_0.resizableRows = $receiver.resizableRows;
    if ($receiver.scrollToRowPosition != null)
      $receiver_0.scrollToRowPosition = $receiver.scrollToRowPosition.position_8be2vx$;
    if ($receiver.scrollToRowIfVisible != null)
      $receiver_0.scrollToRowIfVisible = $receiver.scrollToRowIfVisible;
    if ($receiver.index != null)
      $receiver_0.index = $receiver.index;
    if ($receiver.data != null)
      $receiver_0.data = $receiver.data;
    if ($receiver.ajaxURL != null)
      $receiver_0.ajaxURL = $receiver.ajaxURL;
    if ($receiver.ajaxParams != null)
      $receiver_0.ajaxParams = $receiver.ajaxParams;
    if ($receiver.ajaxConfig != null)
      $receiver_0.ajaxConfig = $receiver.ajaxConfig;
    if ($receiver.ajaxContentType != null)
      $receiver_0.ajaxContentType = $receiver.ajaxContentType;
    if ($receiver.ajaxURLGenerator != null)
      $receiver_0.ajaxURLGenerator = $receiver.ajaxURLGenerator;
    if ($receiver.ajaxRequestFunc != null)
      $receiver_0.ajaxRequestFunc = $receiver.ajaxRequestFunc;
    if ($receiver.filterMode != null)
      $receiver_0.filterMode = $receiver.filterMode.mode_8be2vx$;
    if ($receiver.sortMode != null)
      $receiver_0.sortMode = $receiver.sortMode.mode_8be2vx$;
    if ($receiver.progressiveLoad != null)
      $receiver_0.progressiveLoad = $receiver.progressiveLoad.mode_8be2vx$;
    if ($receiver.progressiveLoadDelay != null)
      $receiver_0.progressiveLoadDelay = $receiver.progressiveLoadDelay;
    if ($receiver.progressiveLoadScrollMargin != null)
      $receiver_0.progressiveLoadScrollMargin = $receiver.progressiveLoadScrollMargin;
    if ($receiver.dataLoader != null)
      $receiver_0.dataLoader = $receiver.dataLoader;
    if ($receiver.dataLoaderLoading != null)
      $receiver_0.dataLoaderLoading = i18nTranslator($receiver.dataLoaderLoading);
    if ($receiver.dataLoaderError != null)
      $receiver_0.dataLoaderError = i18nTranslator($receiver.dataLoaderError);
    if ($receiver.initialSort != null) {
      $receiver_0.initialSort = copyToArray($receiver.initialSort);
    }if ($receiver.sortOrderReverse != null)
      $receiver_0.sortOrderReverse = $receiver.sortOrderReverse;
    if ($receiver.initialFilter != null) {
      $receiver_0.initialFilter = copyToArray($receiver.initialFilter);
    }if ($receiver.initialHeaderFilter != null) {
      $receiver_0.initialHeaderFilter = copyToArray($receiver.initialHeaderFilter);
    }if ($receiver.pagination != null)
      $receiver_0.pagination = $receiver.pagination;
    if ($receiver.paginationMode != null)
      $receiver_0.paginationMode = $receiver.paginationMode.mode_8be2vx$;
    if ($receiver.paginationSize != null)
      $receiver_0.paginationSize = $receiver.paginationSize;
    if ($receiver.paginationSizeSelector != null)
      $receiver_0.paginationSizeSelector = $receiver.paginationSizeSelector;
    if ($receiver.paginationElement != null)
      $receiver_0.paginationElement = $receiver.paginationElement;
    if ($receiver.dataReceiveParams != null)
      $receiver_0.dataReceiveParams = $receiver.dataReceiveParams;
    if ($receiver.dataSendParams != null)
      $receiver_0.dataSendParams = $receiver.dataSendParams;
    if ($receiver.paginationAddRow != null)
      $receiver_0.paginationAddRow = $receiver.paginationAddRow.mode_8be2vx$;
    if ($receiver.paginationButtonCount != null)
      $receiver_0.paginationButtonCount = $receiver.paginationButtonCount;
    if ($receiver.persistenceID != null)
      $receiver_0.persistenceID = $receiver.persistenceID;
    if ($receiver.persistenceMode != null)
      $receiver_0.persistenceMode = $receiver.persistenceMode;
    if ($receiver.persistentLayout != null)
      $receiver_0.persistentLayout = $receiver.persistentLayout;
    if ($receiver.persistentSort != null)
      $receiver_0.persistentSort = $receiver.persistentSort;
    if ($receiver.persistentFilter != null)
      $receiver_0.persistentFilter = $receiver.persistentFilter;
    if ($receiver.locale != null)
      $receiver_0.locale = $receiver.locale;
    if ($receiver.langs != null)
      $receiver_0.langs = $receiver.langs;
    if ($receiver.localized != null)
      $receiver_0.localized = $receiver.localized;
    if ($receiver.headerVisible != null)
      $receiver_0.headerVisible = $receiver.headerVisible;
    if ($receiver.htmlOutputConfig != null)
      $receiver_0.htmlOutputConfig = $receiver.htmlOutputConfig;
    if ($receiver.printAsHtml != null)
      $receiver_0.printAsHtml = $receiver.printAsHtml;
    if ($receiver.printConfig != null)
      $receiver_0.printConfig = $receiver.printConfig;
    if ($receiver.printCopyStyle != null)
      $receiver_0.printCopyStyle = $receiver.printCopyStyle;
    if ($receiver.printVisibleRows != null)
      $receiver_0.printVisibleRows = $receiver.printVisibleRows;
    if ($receiver.printHeader != null)
      $receiver_0.printHeader = $receiver.printHeader;
    if ($receiver.printFooter != null)
      $receiver_0.printFooter = $receiver.printFooter;
    if ($receiver.printFormatter != null)
      $receiver_0.printFormatter = $receiver.printFormatter;
    if ($receiver.tabEndNewRow != null)
      $receiver_0.tabEndNewRow = $receiver.tabEndNewRow;
    if ($receiver.invalidOptionWarnings != null)
      $receiver_0.invalidOptionWarnings = $receiver.invalidOptionWarnings;
    if ($receiver.dataTree != null)
      $receiver_0.dataTree = $receiver.dataTree;
    if ($receiver.dataTreeChildField != null)
      $receiver_0.dataTreeChildField = $receiver.dataTreeChildField;
    if ($receiver.dataTreeCollapseElement != null)
      $receiver_0.dataTreeCollapseElement = $receiver.dataTreeCollapseElement;
    if ($receiver.dataTreeExpandElement != null)
      $receiver_0.dataTreeExpandElement = $receiver.dataTreeExpandElement;
    if ($receiver.dataTreeElementColumn != null)
      $receiver_0.dataTreeElementColumn = $receiver.dataTreeElementColumn;
    if ($receiver.dataTreeBranchElement != null)
      $receiver_0.dataTreeBranchElement = $receiver.dataTreeBranchElement;
    if ($receiver.dataTreeChildIndent != null)
      $receiver_0.dataTreeChildIndent = $receiver.dataTreeChildIndent;
    if ($receiver.dataTreeStartExpanded != null)
      $receiver_0.dataTreeStartExpanded = $receiver.dataTreeStartExpanded;
    if ($receiver.ajaxRequesting != null)
      $receiver_0.ajaxRequesting = $receiver.ajaxRequesting;
    if ($receiver.ajaxResponse != null)
      $receiver_0.ajaxResponse = $receiver.ajaxResponse;
    if ($receiver.persistence != null)
      $receiver_0.persistence = $receiver.persistence;
    if ($receiver.persistenceReaderFunc != null)
      $receiver_0.persistenceReaderFunc = $receiver.persistenceReaderFunc;
    if ($receiver.persistenceWriterFunc != null)
      $receiver_0.persistenceWriterFunc = $receiver.persistenceWriterFunc;
    if ($receiver.paginationInitialPage != null)
      $receiver_0.paginationInitialPage = $receiver.paginationInitialPage;
    if ($receiver.columnHeaderVertAlign != null)
      $receiver_0.columnHeaderVertAlign = $receiver.columnHeaderVertAlign.valign_8be2vx$;
    if ($receiver.maxHeight != null)
      $receiver_0.maxHeight = $receiver.maxHeight;
    if ($receiver.minHeight != null)
      $receiver_0.minHeight = $receiver.minHeight;
    if ($receiver.rowContextMenu != null)
      $receiver_0.rowContextMenu = $receiver.rowContextMenu;
    if ($receiver.dataTreeChildColumnCalcs != null)
      $receiver_0.dataTreeChildColumnCalcs = $receiver.dataTreeChildColumnCalcs;
    if ($receiver.dataTreeSelectPropagate != null)
      $receiver_0.dataTreeSelectPropagate = $receiver.dataTreeSelectPropagate;
    if ($receiver.headerFilterLiveFilterDelay != null)
      $receiver_0.headerFilterLiveFilterDelay = $receiver.headerFilterLiveFilterDelay;
    if ($receiver.textDirection != null)
      $receiver_0.textDirection = $receiver.textDirection.dir_8be2vx$;
    if ($receiver.autoColumnsDefinitions != null)
      $receiver_0.autoColumnsDefinitions = $receiver.autoColumnsDefinitions;
    if ($receiver.rowClickMenu != null)
      $receiver_0.rowClickMenu = $receiver.rowClickMenu;
    if ($receiver.headerSortElement != null)
      $receiver_0.headerSortElement = $receiver.headerSortElement;
    if ($receiver.dataTreeFilter != null)
      $receiver_0.dataTreeFilter = $receiver.dataTreeFilter;
    if ($receiver.dataTreeSort != null)
      $receiver_0.dataTreeSort = $receiver.dataTreeSort;
    if ($receiver.renderVertical != null)
      $receiver_0.renderVertical = $receiver.renderVertical.type_8be2vx$;
    if ($receiver.renderVerticalBuffer != null)
      $receiver_0.renderVerticalBuffer = $receiver.renderVerticalBuffer;
    if ($receiver.renderHorizontal != null)
      $receiver_0.renderHorizontal = $receiver.renderHorizontal.type_8be2vx$;
    if ($receiver.columnDefaults != null)
      $receiver_0.columnDefaults = toJs_0($receiver.columnDefaults, tabulator, i18nTranslator, kClass);
    if ($receiver.importFormat != null)
      $receiver_0.importFormat = $receiver.importFormat.type_8be2vx$;
    if ($receiver.importReader != null)
      $receiver_0.importReader = $receiver.importReader.type_8be2vx$;
    if ($receiver.dataLoaderErrorTimeout != null)
      $receiver_0.dataLoaderErrorTimeout = $receiver.dataLoaderErrorTimeout;
    if ($receiver.popupContainer != null)
      $receiver_0.popupContainer = $receiver.popupContainer;
    if ($receiver.paginationCounter != null)
      $receiver_0.paginationCounter = $receiver.paginationCounter;
    if ($receiver.paginationCounterElement != null)
      $receiver_0.paginationCounterElement = $receiver.paginationCounterElement;
    if ($receiver.rowClickPopup != null)
      $receiver_0.rowClickPopup = $receiver.rowClickPopup;
    if ($receiver.rowContextPopup != null)
      $receiver_0.rowContextPopup = $receiver.rowContextPopup;
    if ($receiver.resizableColumnFit != null)
      $receiver_0.resizableColumnFit = $receiver.resizableColumnFit;
    if ($receiver.rowHeight != null)
      $receiver_0.rowHeight = $receiver.rowHeight;
    if ($receiver.frozenRows != null)
      $receiver_0.frozenRows = $receiver.frozenRows;
    if ($receiver.frozenRowsField != null)
      $receiver_0.frozenRowsField = $receiver.frozenRowsField;
    if ($receiver.headerSortClickElement != null)
      $receiver_0.headerSortClickElement = $receiver.headerSortClickElement.element_8be2vx$;
    if ($receiver.rowDblClickPopup != null)
      $receiver_0.rowDblClickPopup = $receiver.rowDblClickPopup;
    if ($receiver.rowDblClickMenu != null)
      $receiver_0.rowDblClickMenu = $receiver.rowDblClickMenu;
    return Kotlin.isType(tmp$ = $receiver_0, Object) ? tmp$ : throwCCE();
  }
  function Widget$refreshOnUpdate$lambda(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function TableType(name, ordinal, type) {
    Enum.call(this);
    this.type = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function TableType_initFields() {
    TableType_initFields = function () {
    };
    TableType$STRIPED_instance = new TableType('STRIPED', 0, 'table-striped');
    TableType$BORDERED_instance = new TableType('BORDERED', 1, 'table-bordered');
    TableType$BORDERLESS_instance = new TableType('BORDERLESS', 2, 'table-borderless');
    TableType$HOVER_instance = new TableType('HOVER', 3, 'table-hover');
    TableType$SMALL_instance = new TableType('SMALL', 4, 'table-sm');
  }
  var TableType$STRIPED_instance;
  function TableType$STRIPED_getInstance() {
    TableType_initFields();
    return TableType$STRIPED_instance;
  }
  var TableType$BORDERED_instance;
  function TableType$BORDERED_getInstance() {
    TableType_initFields();
    return TableType$BORDERED_instance;
  }
  var TableType$BORDERLESS_instance;
  function TableType$BORDERLESS_getInstance() {
    TableType_initFields();
    return TableType$BORDERLESS_instance;
  }
  var TableType$HOVER_instance;
  function TableType$HOVER_getInstance() {
    TableType_initFields();
    return TableType$HOVER_instance;
  }
  var TableType$SMALL_instance;
  function TableType$SMALL_getInstance() {
    TableType_initFields();
    return TableType$SMALL_instance;
  }
  TableType.$metadata$ = {kind: Kind_CLASS, simpleName: 'TableType', interfaces: [Enum]};
  function TableType$values() {
    return [TableType$STRIPED_getInstance(), TableType$BORDERED_getInstance(), TableType$BORDERLESS_getInstance(), TableType$HOVER_getInstance(), TableType$SMALL_getInstance()];
  }
  TableType.values = TableType$values;
  function TableType$valueOf(name) {
    switch (name) {
      case 'STRIPED':
        return TableType$STRIPED_getInstance();
      case 'BORDERED':
        return TableType$BORDERED_getInstance();
      case 'BORDERLESS':
        return TableType$BORDERLESS_getInstance();
      case 'HOVER':
        return TableType$HOVER_getInstance();
      case 'SMALL':
        return TableType$SMALL_getInstance();
      default:throwISE('No enum constant io.kvision.tabulator.TableType.' + name);
    }
  }
  TableType.valueOf_61zpoe$ = TableType$valueOf;
  function RowRangeLookup(name, ordinal, set) {
    Enum.call(this);
    this.set_8be2vx$ = set;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function RowRangeLookup_initFields() {
    RowRangeLookup_initFields = function () {
    };
    RowRangeLookup$ALL_instance = new RowRangeLookup('ALL', 0, 'all');
    RowRangeLookup$VISIBLE_instance = new RowRangeLookup('VISIBLE', 1, 'visible');
    RowRangeLookup$SELECTED_instance = new RowRangeLookup('SELECTED', 2, 'selected');
    RowRangeLookup$ACTIVE_instance = new RowRangeLookup('ACTIVE', 3, 'active');
  }
  var RowRangeLookup$ALL_instance;
  function RowRangeLookup$ALL_getInstance() {
    RowRangeLookup_initFields();
    return RowRangeLookup$ALL_instance;
  }
  var RowRangeLookup$VISIBLE_instance;
  function RowRangeLookup$VISIBLE_getInstance() {
    RowRangeLookup_initFields();
    return RowRangeLookup$VISIBLE_instance;
  }
  var RowRangeLookup$SELECTED_instance;
  function RowRangeLookup$SELECTED_getInstance() {
    RowRangeLookup_initFields();
    return RowRangeLookup$SELECTED_instance;
  }
  var RowRangeLookup$ACTIVE_instance;
  function RowRangeLookup$ACTIVE_getInstance() {
    RowRangeLookup_initFields();
    return RowRangeLookup$ACTIVE_instance;
  }
  RowRangeLookup.$metadata$ = {kind: Kind_CLASS, simpleName: 'RowRangeLookup', interfaces: [Enum]};
  function RowRangeLookup$values() {
    return [RowRangeLookup$ALL_getInstance(), RowRangeLookup$VISIBLE_getInstance(), RowRangeLookup$SELECTED_getInstance(), RowRangeLookup$ACTIVE_getInstance()];
  }
  RowRangeLookup.values = RowRangeLookup$values;
  function RowRangeLookup$valueOf(name) {
    switch (name) {
      case 'ALL':
        return RowRangeLookup$ALL_getInstance();
      case 'VISIBLE':
        return RowRangeLookup$VISIBLE_getInstance();
      case 'SELECTED':
        return RowRangeLookup$SELECTED_getInstance();
      case 'ACTIVE':
        return RowRangeLookup$ACTIVE_getInstance();
      default:throwISE('No enum constant io.kvision.tabulator.RowRangeLookup.' + name);
    }
  }
  RowRangeLookup.valueOf_61zpoe$ = RowRangeLookup$valueOf;
  var AlertStyle$MSG_instance;
  var AlertStyle$ERROR_instance;
  function Tabulator(data, dataUpdateOnEdit, options, types, className, kClass, serializer, module_0) {
    Tabulator$Companion_getInstance();
    if (data === void 0)
      data = null;
    if (dataUpdateOnEdit === void 0)
      dataUpdateOnEdit = true;
    if (options === void 0)
      options = new TabulatorOptions();
    if (types === void 0) {
      types = emptySet();
    }if (className === void 0)
      className = null;
    if (kClass === void 0)
      kClass = null;
    if (serializer === void 0)
      serializer = null;
    if (module_0 === void 0)
      module_0 = null;
    Widget.call(this, className);
    this.data = data;
    this.dataUpdateOnEdit = dataUpdateOnEdit;
    this.options = options;
    this.kClass = kClass;
    this.serializer = serializer;
    this.module = module_0;
    var tmp$, tmp$_0;
    if (this.serializer != null) {
      tmp$_0 = Json((tmp$ = utils.Serialization.customConfiguration) != null ? tmp$ : Json(void 0, Tabulator$jsonHelper$lambda), Tabulator$jsonHelper$lambda_0(this));
    } else
      tmp$_0 = null;
    this.jsonHelper_1310rt$_0 = tmp$_0;
    this.types_vwwa1o$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, types, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Tabulator$types_metadata);
    this.jsTabulator = null;
    this.unsubscribe_aoulac$_0 = null;
    this.jsTabulatorInitialized_xtyfok$_0 = false;
    this.pageSize_rj1gv$_0 = null;
    this.currentPage_jtvjgt$_0 = null;
    this.customRoots_1mxic5$_0 = ArrayList_init_0();
    this.filter = null;
    this.useSnabbdomDistinctKey();
    if (this.data != null) {
      var tmp$_1 = this.options;
      var $receiver = this.data;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
      var tmp$_2;
      tmp$_2 = $receiver.iterator();
      while (tmp$_2.hasNext()) {
        var item = tmp$_2.next();
        destination.add_11rb$(this.toPlainObjTabulator_myks26$(item));
      }
      tmp$_1.data = copyToArray(destination);
      if (Kotlin.isType(this.data, ObservableList)) {
        this.unsubscribe_aoulac$_0 = this.data.subscribe_qlkmfe$(Tabulator_init$lambda(this));
      }}var $receiver_0 = new Object_init();
    var $receiver_1 = new Object_init();
    var $receiver_2 = new Object_init();
    $receiver_2.item = '';
    $receiver_2.items = '';
    $receiver_1.groups = $receiver_2;
    var $receiver_3 = new Object_init();
    $receiver_3.loading = '...';
    $receiver_3.error = '!!!';
    $receiver_1.data = $receiver_3;
    var $receiver_4 = new Object_init();
    $receiver_4.page_size = '\u2195';
    $receiver_4.page_title = '#';
    $receiver_4.first = '<<';
    $receiver_4.first_title = '<<';
    $receiver_4.last = '>>';
    $receiver_4.last_title = '>>';
    $receiver_4.prev = '<';
    $receiver_4.prev_title = '<';
    $receiver_4.next = '>';
    $receiver_4.next_title = '>';
    $receiver_4.all = '*';
    var $receiver_5 = new Object_init();
    $receiver_5.showing = '';
    $receiver_5.of = '/';
    $receiver_5.rows = '';
    $receiver_5.pages = '';
    $receiver_4.counter = $receiver_5;
    $receiver_1.pagination = $receiver_4;
    var $receiver_6 = new Object_init();
    $receiver_6.default = '...';
    $receiver_1.headerFilters = $receiver_6;
    $receiver_0.default = $receiver_1;
    var defaultLangs = $receiver_0;
    if (this.options.langs == null) {
      this.options.langs = defaultLangs;
    } else {
      this.options.langs = deepMerge(defaultLangs, this.options.langs);
    }
  }
  Object.defineProperty(Tabulator.prototype, 'jsonHelper', {configurable: true, get: function () {
    return this.jsonHelper_1310rt$_0;
  }});
  var Tabulator$types_metadata = new PropertyMetadata('types');
  Object.defineProperty(Tabulator.prototype, 'types', {configurable: true, get: function () {
    return this.types_vwwa1o$_0.getValue_fmbzy8$(this, Tabulator$types_metadata);
  }, set: function (types) {
    this.types_vwwa1o$_0.setValue_19qrsr$(this, Tabulator$types_metadata, types);
  }});
  Tabulator.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    var tmp$;
    tmp$ = this.types.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      classSetBuilder.add_61zpoe$(element.type);
    }
  };
  function Tabulator$createJsTabulator$lambda$lambda$lambda$lambda(closure$cell) {
    return function () {
      try {
        var $receiver = closure$cell.getTable().getRows('visible');
        var tmp$;
        for (tmp$ = 0; tmp$ !== $receiver.length; ++tmp$) {
          var element = $receiver[tmp$];
          element.reformat();
        }
      } catch (e) {
        if (Kotlin.isType(e, Throwable)) {
          console.log("Table reformat failed. Probably it's not visible anymore.");
        } else
          throw e;
      }
      return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda$lambda(cell) {
    return window.setTimeout(Tabulator$createJsTabulator$lambda$lambda$lambda$lambda(cell), 0);
  }
  function Tabulator$createJsTabulator$lambda$lambda(this$Tabulator) {
    return function (e, row) {
      if (!e.defaultPrevented) {
        var tmp$ = this$Tabulator;
        var $receiver = new Object_init();
        $receiver.detail = row;
        if (tmp$.dispatchEvent_nxedta$('rowClickTabulator', $receiver) !== true)
          e.preventDefault();
      }return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_0(this$Tabulator) {
    return function (e, row) {
      if (!e.defaultPrevented) {
        var tmp$ = this$Tabulator;
        var $receiver = new Object_init();
        $receiver.detail = row;
        if (tmp$.dispatchEvent_nxedta$('rowDblClickTabulator', $receiver) !== true)
          e.preventDefault();
      }return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_1(this$Tabulator) {
    return function (f, rows) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = rows;
      return tmp$.dispatchEvent_nxedta$('rowSelectionChangedTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_2(this$Tabulator) {
    return function (row) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = row;
      return tmp$.dispatchEvent_nxedta$('rowSelectedTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_3(this$Tabulator) {
    return function (row) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = row;
      return tmp$.dispatchEvent_nxedta$('rowDeselectedTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_4(this$Tabulator) {
    return function (e, cell) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = cell;
      $receiver.cancelable = true;
      if (tmp$.dispatchEvent_nxedta$('cellClickTabulator', $receiver) !== true)
        e.preventDefault();
      return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_5(this$Tabulator) {
    return function (e, cell) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = cell;
      $receiver.cancelable = true;
      if (tmp$.dispatchEvent_nxedta$('cellDblClickTabulator', $receiver) !== true)
        e.preventDefault();
      return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_6(this$Tabulator) {
    return function (cell) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = cell;
      return tmp$.dispatchEvent_nxedta$('cellEditingTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_7(this$Tabulator) {
    return function (cell) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = cell;
      return tmp$.dispatchEvent_nxedta$('cellEditedTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_8(this$Tabulator) {
    return function (cell) {
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = cell;
      return tmp$.dispatchEvent_nxedta$('cellEditCancelledTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_9(this$Tabulator) {
    return function (data) {
      var tmp$;
      if (!data) {
        tmp$ = emptyList();
      } else {
        tmp$ = ensureNotNull(this$Tabulator.fixData_giv383$(toList(data)));
      }
      var fixedData = tmp$;
      var tmp$_0 = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = fixedData;
      return tmp$_0.dispatchEvent_nxedta$('dataLoadingTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_10(this$Tabulator) {
    return function (data) {
      var fixedData = !equals(data, undefined) ? ensureNotNull(this$Tabulator.fixData_giv383$(toList(data))) : emptyList();
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = fixedData;
      return tmp$.dispatchEvent_nxedta$('dataLoadedTabulator', $receiver);
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda$lambda_0(this$Tabulator, closure$fixedData) {
    return function () {
      syncWithList(this$Tabulator.data, closure$fixedData);
      return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_11(this$Tabulator) {
    return function (data) {
      var fixedData = !equals(data, undefined) ? ensureNotNull(this$Tabulator.fixData_giv383$(toList(data))) : emptyList();
      var tmp$ = this$Tabulator;
      var $receiver = new Object_init();
      $receiver.detail = fixedData;
      tmp$.dispatchEvent_nxedta$('dataEditedTabulator', $receiver);
      if (this$Tabulator.dataUpdateOnEdit && Kotlin.isType(this$Tabulator.data, MutableList)) {
        window.setTimeout(Tabulator$createJsTabulator$lambda$lambda$lambda_0(this$Tabulator, fixedData), 0);
      }return Unit;
    };
  }
  function Tabulator$createJsTabulator$lambda$lambda_12(this$Tabulator) {
    return function () {
      var tmp$, tmp$_0, tmp$_1, tmp$_2;
      if (this$Tabulator.currentPage_jtvjgt$_0 != null) {
        tmp$_1 = this$Tabulator.jsTabulator;
        tmp$_0 = (tmp$ = this$Tabulator.pageSize_rj1gv$_0) != null ? tmp$ : 0;
        tmp$_1 != null ? (tmp$_1.setPageSize(tmp$_0), Unit) : null;
        (tmp$_2 = this$Tabulator.jsTabulator) != null ? tmp$_2.setPage(this$Tabulator.currentPage_jtvjgt$_0) : null;
      }this$Tabulator.applyFilter();
      this$Tabulator.jsTabulatorInitialized_xtyfok$_0 = true;
      return Unit;
    };
  }
  Tabulator.prototype.createJsTabulator = function () {
    var tmp$, tmp$_0;
    if ((tmp$_0 = Kotlin.isType(tmp$ = this.getElement(), HTMLElement) ? tmp$ : null) != null) {
      var tmp$_1;
      var tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11, tmp$_12, tmp$_13, tmp$_14, tmp$_15;
      this.jsTabulator = createInstance(TabulatorModule_getInstance().getConstructor(), [tmp$_0, toJs_1(this.options, this, getCallableRef('translate', function ($receiver, p1) {
        return $receiver.translate_61zpoe$(p1);
      }.bind(null, this)), this.kClass)]);
      var tmp$_16;
      if ((tmp$_1 = this.options.columns) != null) {
        var destination = ArrayList_init_0();
        var tmp$_17;
        tmp$_17 = tmp$_1.iterator();
        while (tmp$_17.hasNext()) {
          var element = tmp$_17.next();
          var tmp$_0_0;
          if ((tmp$_0_0 = element.columns) != null) {
            destination.add_11rb$(tmp$_0_0);
          }}
        tmp$_16 = plus(tmp$_1, flatten(destination));
      } else
        tmp$_16 = null;
      var allColumns = tmp$_16;
      var tmp$_18;
      if (allColumns != null) {
        var firstOrNull$result;
        firstOrNull$break: do {
          var tmp$_19;
          tmp$_19 = allColumns.iterator();
          while (tmp$_19.hasNext()) {
            var element_0 = tmp$_19.next();
            if (element_0.editorComponentFunction != null) {
              firstOrNull$result = element_0;
              break firstOrNull$break;
            }}
          firstOrNull$result = null;
        }
         while (false);
        tmp$_18 = firstOrNull$result;
      } else
        tmp$_18 = null;
      if (tmp$_18 != null) {
        var tmp$_20;
        (tmp$_20 = this.jsTabulator) != null && (tmp$_20.on('cellEditCancelled', Tabulator$createJsTabulator$lambda$lambda$lambda), Unit);
      }(tmp$_2 = this.jsTabulator) != null ? (tmp$_2.on('rowClick', Tabulator$createJsTabulator$lambda$lambda(this)), Unit) : null;
      (tmp$_3 = this.jsTabulator) != null ? (tmp$_3.on('rowDblClick', Tabulator$createJsTabulator$lambda$lambda_0(this)), Unit) : null;
      (tmp$_4 = this.jsTabulator) != null ? (tmp$_4.on('rowSelectionChanged', Tabulator$createJsTabulator$lambda$lambda_1(this)), Unit) : null;
      (tmp$_5 = this.jsTabulator) != null ? (tmp$_5.on('rowSelected', Tabulator$createJsTabulator$lambda$lambda_2(this)), Unit) : null;
      (tmp$_6 = this.jsTabulator) != null ? (tmp$_6.on('rowDeselected', Tabulator$createJsTabulator$lambda$lambda_3(this)), Unit) : null;
      (tmp$_7 = this.jsTabulator) != null ? (tmp$_7.on('cellClick', Tabulator$createJsTabulator$lambda$lambda_4(this)), Unit) : null;
      (tmp$_8 = this.jsTabulator) != null ? (tmp$_8.on('cellDblClick', Tabulator$createJsTabulator$lambda$lambda_5(this)), Unit) : null;
      (tmp$_9 = this.jsTabulator) != null ? (tmp$_9.on('cellEditing', Tabulator$createJsTabulator$lambda$lambda_6(this)), Unit) : null;
      (tmp$_10 = this.jsTabulator) != null ? (tmp$_10.on('cellEdited', Tabulator$createJsTabulator$lambda$lambda_7(this)), Unit) : null;
      (tmp$_11 = this.jsTabulator) != null ? (tmp$_11.on('cellEditCancelled', Tabulator$createJsTabulator$lambda$lambda_8(this)), Unit) : null;
      (tmp$_12 = this.jsTabulator) != null ? (tmp$_12.on('dataLoading', Tabulator$createJsTabulator$lambda$lambda_9(this)), Unit) : null;
      (tmp$_13 = this.jsTabulator) != null ? (tmp$_13.on('dataLoaded', Tabulator$createJsTabulator$lambda$lambda_10(this)), Unit) : null;
      (tmp$_14 = this.jsTabulator) != null ? (tmp$_14.on('dataChanged', Tabulator$createJsTabulator$lambda$lambda_11(this)), Unit) : null;
      (tmp$_15 = this.jsTabulator) != null && (tmp$_15.on('tableBuilt', Tabulator$createJsTabulator$lambda$lambda_12(this)), Unit);
    }};
  Tabulator.prototype.render = function () {
    var tmp$;
    if (this.lastLanguage != null && !equals(this.lastLanguage, i18n.I18n.language)) {
      (tmp$ = this.jsTabulator) != null ? (tmp$.destroy(), Unit) : null;
      this.jsTabulatorInitialized_xtyfok$_0 = false;
      var tmp$_0;
      tmp$_0 = this.customRoots_1mxic5$_0.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        element.dispose();
      }
      this.customRoots_1mxic5$_0.clear();
      this.createJsTabulator();
    }return this.render_61zpoe$('div');
  };
  Tabulator.prototype.afterInsert_77isfd$ = function (node) {
    this.createJsTabulator();
  };
  Tabulator.prototype.afterDestroy = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    var page = (tmp$ = this.jsTabulator) != null ? tmp$.getPage() : null;
    if (page != null && page != false) {
      this.pageSize_rj1gv$_0 = (tmp$_0 = this.jsTabulator) != null ? tmp$_0.getPageSize() : null;
      this.currentPage_jtvjgt$_0 = Kotlin.isNumber(tmp$_1 = page) ? tmp$_1 : throwCCE();
    }(tmp$_2 = this.jsTabulator) != null ? (tmp$_2.destroy(), Unit) : null;
    this.jsTabulatorInitialized_xtyfok$_0 = false;
    var tmp$_3;
    tmp$_3 = this.customRoots_1mxic5$_0.iterator();
    while (tmp$_3.hasNext()) {
      var element = tmp$_3.next();
      element.dispose();
    }
    this.customRoots_1mxic5$_0.clear();
    this.jsTabulator = null;
  };
  Tabulator.prototype.replaceData_3i86gf$ = function (data) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9;
    var destination = ArrayList_init(data.length);
    var tmp$_10;
    for (tmp$_10 = 0; tmp$_10 !== data.length; ++tmp$_10) {
      var item = data[tmp$_10];
      destination.add_11rb$(this.toPlainObjTabulator_myks26$(item));
    }
    var jsData = copyToArray(destination);
    this.options.data = jsData;
    if (((tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? tmp$_0.querySelectorAll('.tabulator-editing') : null) != null ? tmp$_1.length : null) != null ? tmp$_2 : 0) > 0) {
      this.removeCustomEditors_8be2vx$();
    }if (this.jsTabulatorInitialized_xtyfok$_0) {
      var oldPagination = (tmp$_4 = (tmp$_3 = this.jsTabulator) != null ? tmp$_3.options : null) != null ? tmp$_4.pagination : null;
      (tmp$_6 = (tmp$_5 = this.jsTabulator) != null ? tmp$_5.options : null) != null ? (tmp$_6.pagination = false) : null;
      (tmp$_7 = this.jsTabulator) != null ? tmp$_7.replaceData(jsData, null, null) : null;
      (tmp$_9 = (tmp$_8 = this.jsTabulator) != null ? tmp$_8.options : null) != null ? (tmp$_9.pagination = oldPagination) : null;
    }};
  Tabulator.prototype.setData_3i86gf$ = function (data) {
    var tmp$;
    var destination = ArrayList_init(data.length);
    var tmp$_0;
    for (tmp$_0 = 0; tmp$_0 !== data.length; ++tmp$_0) {
      var item = data[tmp$_0];
      destination.add_11rb$(this.toPlainObjTabulator_myks26$(item));
    }
    var jsData = copyToArray(destination);
    this.options.data = jsData;
    (tmp$ = this.jsTabulator) != null ? tmp$.setData(jsData, null, null) : null;
  };
  Tabulator.prototype.getData_skonn1$$default = function (rowRangeLookup) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.jsTabulator != null) {
      tmp$_2 = this.fixData_giv383$(Kotlin.isType(tmp$_1 = (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getData(rowRangeLookup != null ? rowRangeLookup.set_8be2vx$ : null) : null) != null ? toList(tmp$_0) : null, List) ? tmp$_1 : null);
    } else {
      tmp$_2 = this.data;
    }
    return tmp$_2;
  };
  Tabulator.prototype.getData_skonn1$ = function (rowRangeLookup, callback$default) {
    if (rowRangeLookup === void 0)
      rowRangeLookup = null;
    return callback$default ? callback$default(rowRangeLookup) : this.getData_skonn1$$default(rowRangeLookup);
  };
  Tabulator.prototype.getSelectedData = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.jsTabulator != null) {
      tmp$_2 = ensureNotNull(this.fixData_giv383$(Kotlin.isType(tmp$_1 = (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getSelectedData() : null) != null ? toList(tmp$_0) : null, List) ? tmp$_1 : throwCCE()));
    } else {
      tmp$_2 = emptyList();
    }
    return tmp$_2;
  };
  Tabulator.prototype.clearData = function () {
    var tmp$;
    return (tmp$ = this.jsTabulator) != null ? (tmp$.clearData(), Unit) : null;
  };
  Tabulator.prototype.undo = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.undo() : null) != null ? tmp$_0 : false;
  };
  Tabulator.prototype.redo = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.redo() : null) != null ? tmp$_0 : false;
  };
  Tabulator.prototype.getHistoryUndoSize = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getHistoryUndoSize() : null) != null ? tmp$_0 : 0;
  };
  Tabulator.prototype.getHistoryRedoSize = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getHistoryRedoSize() : null) != null ? tmp$_0 : 0;
  };
  Tabulator.prototype.getDataCount_skonn1$$default = function (rowRangeLookup) {
    var tmp$, tmp$_0, tmp$_1;
    return (tmp$_1 = (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getDataCount(rowRangeLookup != null ? rowRangeLookup.set_8be2vx$ : null) : null) != null ? numberToInt(tmp$_0) : null) != null ? tmp$_1 : 0;
  };
  Tabulator.prototype.getDataCount_skonn1$ = function (rowRangeLookup, callback$default) {
    if (rowRangeLookup === void 0)
      rowRangeLookup = null;
    return callback$default ? callback$default(rowRangeLookup) : this.getDataCount_skonn1$$default(rowRangeLookup);
  };
  Tabulator.prototype.getHtml_e24xio$$default = function (rowRangeLookup, isStyled, htmlOutputConfig) {
    var tmp$;
    return (tmp$ = this.jsTabulator) != null ? tmp$.getHtml(rowRangeLookup.set_8be2vx$, isStyled, htmlOutputConfig) : null;
  };
  Tabulator.prototype.getHtml_e24xio$ = function (rowRangeLookup, isStyled, htmlOutputConfig, callback$default) {
    if (isStyled === void 0)
      isStyled = false;
    if (htmlOutputConfig === void 0)
      htmlOutputConfig = null;
    return callback$default ? callback$default(rowRangeLookup, isStyled, htmlOutputConfig) : this.getHtml_e24xio$$default(rowRangeLookup, isStyled, htmlOutputConfig);
  };
  Tabulator.prototype.print_e24xio$$default = function (rowRangeLookup, isStyled, printConfig) {
    var tmp$;
    return (tmp$ = this.jsTabulator) != null ? tmp$.print(rowRangeLookup.set_8be2vx$, isStyled, printConfig) : null;
  };
  Tabulator.prototype.print_e24xio$ = function (rowRangeLookup, isStyled, printConfig, callback$default) {
    if (isStyled === void 0)
      isStyled = false;
    if (printConfig === void 0)
      printConfig = null;
    return callback$default ? callback$default(rowRangeLookup, isStyled, printConfig) : this.print_e24xio$$default(rowRangeLookup, isStyled, printConfig);
  };
  Tabulator.prototype.downloadCSV_qmjwo$$default = function (fileName, dataSet, delimiter, includeBOM, newTab) {
    var tmp$, tmp$_0, tmp$_1;
    if (newTab) {
      var tmp$_2;
      if ((tmp$ = this.jsTabulator) != null) {
        var $receiver = new Object_init();
        $receiver.delimiter = String.fromCharCode(delimiter);
        $receiver.bom = includeBOM;
        tmp$_2 = (tmp$.downloadToTab('csv', fileName, $receiver, dataSet.set_8be2vx$), Unit);
      } else
        tmp$_2 = null;
      tmp$_1 = tmp$_2;
    } else {
      var tmp$_3;
      if ((tmp$_0 = this.jsTabulator) != null) {
        var $receiver_0 = new Object_init();
        $receiver_0.delimiter = String.fromCharCode(delimiter);
        $receiver_0.bom = includeBOM;
        tmp$_3 = (tmp$_0.download('csv', fileName, $receiver_0, dataSet.set_8be2vx$), Unit);
      } else
        tmp$_3 = null;
      tmp$_1 = tmp$_3;
    }
    return tmp$_1;
  };
  Tabulator.prototype.downloadCSV_qmjwo$ = function (fileName, dataSet, delimiter, includeBOM, newTab, callback$default) {
    if (fileName === void 0)
      fileName = null;
    if (dataSet === void 0)
      dataSet = RowRangeLookup$ACTIVE_getInstance();
    if (delimiter === void 0)
      delimiter = 44;
    if (includeBOM === void 0)
      includeBOM = false;
    if (newTab === void 0)
      newTab = false;
    return callback$default ? callback$default(fileName, dataSet, delimiter, includeBOM, newTab) : this.downloadCSV_qmjwo$$default(fileName, dataSet, delimiter, includeBOM, newTab);
  };
  Tabulator.prototype.downloadJSON_35842u$$default = function (fileName, dataSet, newTab) {
    var tmp$, tmp$_0, tmp$_1;
    if (newTab) {
      var tmp$_2;
      if ((tmp$ = this.jsTabulator) != null) {
        var $receiver = new Object_init();
        tmp$_2 = (tmp$.downloadToTab('json', fileName, $receiver, dataSet.set_8be2vx$), Unit);
      } else
        tmp$_2 = null;
      tmp$_1 = tmp$_2;
    } else {
      var tmp$_3;
      if ((tmp$_0 = this.jsTabulator) != null) {
        var $receiver_0 = new Object_init();
        tmp$_3 = (tmp$_0.download('json', fileName, $receiver_0, dataSet.set_8be2vx$), Unit);
      } else
        tmp$_3 = null;
      tmp$_1 = tmp$_3;
    }
    return tmp$_1;
  };
  Tabulator.prototype.downloadJSON_35842u$ = function (fileName, dataSet, newTab, callback$default) {
    if (fileName === void 0)
      fileName = null;
    if (dataSet === void 0)
      dataSet = RowRangeLookup$ACTIVE_getInstance();
    if (newTab === void 0)
      newTab = false;
    return callback$default ? callback$default(fileName, dataSet, newTab) : this.downloadJSON_35842u$$default(fileName, dataSet, newTab);
  };
  Tabulator.prototype.downloadHTML_v0e7fj$$default = function (fileName, dataSet, style, newTab) {
    var tmp$, tmp$_0, tmp$_1;
    if (newTab) {
      var tmp$_2;
      if ((tmp$ = this.jsTabulator) != null) {
        var $receiver = new Object_init();
        $receiver.style = style;
        tmp$_2 = (tmp$.downloadToTab('html', fileName, $receiver, dataSet.set_8be2vx$), Unit);
      } else
        tmp$_2 = null;
      tmp$_1 = tmp$_2;
    } else {
      var tmp$_3;
      if ((tmp$_0 = this.jsTabulator) != null) {
        var $receiver_0 = new Object_init();
        $receiver_0.style = style;
        tmp$_3 = (tmp$_0.download('html', fileName, $receiver_0, dataSet.set_8be2vx$), Unit);
      } else
        tmp$_3 = null;
      tmp$_1 = tmp$_3;
    }
    return tmp$_1;
  };
  Tabulator.prototype.downloadHTML_v0e7fj$ = function (fileName, dataSet, style, newTab, callback$default) {
    if (fileName === void 0)
      fileName = null;
    if (dataSet === void 0)
      dataSet = RowRangeLookup$ACTIVE_getInstance();
    if (style === void 0)
      style = false;
    if (newTab === void 0)
      newTab = false;
    return callback$default ? callback$default(fileName, dataSet, style, newTab) : this.downloadHTML_v0e7fj$$default(fileName, dataSet, style, newTab);
  };
  Tabulator.prototype.scrollToRow_ltuqef$$default = function (row, position, ifVisible) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.scrollToRow(row, position != null ? position.position_8be2vx$ : null, ifVisible) : null;
  };
  Tabulator.prototype.scrollToRow_ltuqef$ = function (row, position, ifVisible, callback$default) {
    if (position === void 0)
      position = null;
    if (ifVisible === void 0)
      ifVisible = null;
    callback$default ? callback$default(row, position, ifVisible) : this.scrollToRow_ltuqef$$default(row, position, ifVisible);
  };
  Tabulator.prototype.redraw_6taknv$$default = function (force) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.redraw(force), Unit) : null;
  };
  Tabulator.prototype.redraw_6taknv$ = function (force, callback$default) {
    if (force === void 0)
      force = false;
    callback$default ? callback$default(force) : this.redraw_6taknv$$default(force);
  };
  Tabulator.prototype.reload = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.setData(null, null, null) : null;
  };
  Tabulator.prototype.setHeight_za3lpa$ = function (height) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.setHeight(height), Unit) : null;
  };
  Tabulator.prototype.clearSort = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.clearSort(), Unit) : null;
  };
  Tabulator.prototype.setFilter_71v3by$ = function (filter) {
    this.filter = filter;
    this.applyFilter();
  };
  function Tabulator$applyFilter$lambda(this$Tabulator) {
    return function (data, f) {
      var tmp$;
      var tmp$_0;
      if ((tmp$ = this$Tabulator.filter) != null) {
        var tmp$_1;
        tmp$_0 = tmp$(this$Tabulator.fixData_za3rmp$(Kotlin.isType(tmp$_1 = data, Object_init) ? tmp$_1 : throwCCE()));
      } else
        tmp$_0 = null;
      return tmp$_0;
    };
  }
  Tabulator.prototype.applyFilter = function () {
    var tmp$;
    if (this.filter != null) {
      (tmp$ = this.jsTabulator) != null ? (tmp$.setFilter(Tabulator$applyFilter$lambda(this), null, null, null), Unit) : null;
    }};
  Tabulator.prototype.clearFilter_6taknv$$default = function (includeHeaderFilters) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.clearFilter(includeHeaderFilters), Unit) : null;
  };
  Tabulator.prototype.clearFilter_6taknv$ = function (includeHeaderFilters, callback$default) {
    if (includeHeaderFilters === void 0)
      includeHeaderFilters = true;
    callback$default ? callback$default(includeHeaderFilters) : this.clearFilter_6taknv$$default(includeHeaderFilters);
  };
  Tabulator.prototype.clearHeaderFilter = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.clearHeaderFilter(), Unit) : null;
  };
  Tabulator.prototype.selectRow_za3rmp$$default = function (row) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.selectRow(row), Unit) : null;
  };
  Tabulator.prototype.selectRow_za3rmp$ = function (row, callback$default) {
    if (row === void 0)
      row = undefined;
    callback$default ? callback$default(row) : this.selectRow_za3rmp$$default(row);
  };
  Tabulator.prototype.deselectRow_za3rmp$$default = function (row) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.deselectRow(row), Unit) : null;
  };
  Tabulator.prototype.deselectRow_za3rmp$ = function (row, callback$default) {
    if (row === void 0)
      row = undefined;
    callback$default ? callback$default(row) : this.deselectRow_za3rmp$$default(row);
  };
  Tabulator.prototype.toggleSelectRow_za3rmp$$default = function (row) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.toggleSelectRow(row), Unit) : null;
  };
  Tabulator.prototype.toggleSelectRow_za3rmp$ = function (row, callback$default) {
    if (row === void 0)
      row = undefined;
    callback$default ? callback$default(row) : this.toggleSelectRow_za3rmp$$default(row);
  };
  Tabulator.prototype.getSelectedRows = function () {
    var tmp$, tmp$_0, tmp$_1;
    return (tmp$_1 = (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getSelectedRows() : null) != null ? asList(tmp$_0) : null) != null ? tmp$_1 : emptyList();
  };
  Tabulator.prototype.setPage_za3lpa$ = function (page) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.setPage(page) : null;
  };
  Tabulator.prototype.setPageToRow_za3lpa$ = function (row) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.setPageToRow(row) : null;
  };
  Tabulator.prototype.setPageSize_za3lpa$ = function (size) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.setPageSize(size), Unit) : null;
  };
  Tabulator.prototype.getPageSize = function () {
    var tmp$, tmp$_0, tmp$_1;
    return (tmp$_1 = (tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getPageSize() : null) != null ? numberToInt(tmp$_0) : null) != null ? tmp$_1 : 0;
  };
  Tabulator.prototype.previousPage = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.previousPage() : null;
  };
  Tabulator.prototype.nextPage = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.nextPage() : null;
  };
  Tabulator.prototype.getPage = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    return (tmp$_2 = (tmp$_1 = Kotlin.isNumber(tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getPage() : null) ? tmp$_0 : null) != null ? numberToInt(tmp$_1) : null) != null ? tmp$_2 : -1;
  };
  Tabulator.prototype.getPageMax = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    return (tmp$_2 = (tmp$_1 = Kotlin.isNumber(tmp$_0 = (tmp$ = this.jsTabulator) != null ? tmp$.getPageMax() : null) ? tmp$_0 : null) != null ? numberToInt(tmp$_1) : null) != null ? tmp$_2 : -1;
  };
  Tabulator.prototype.navigatePrev = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.navigatePrev(), Unit) : null;
  };
  Tabulator.prototype.navigateNext = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.navigateNext(), Unit) : null;
  };
  Tabulator.prototype.navigateLeft = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.navigateLeft(), Unit) : null;
  };
  Tabulator.prototype.navigateRight = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.navigateRight(), Unit) : null;
  };
  Tabulator.prototype.navigateUp = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.navigateUp(), Unit) : null;
  };
  Tabulator.prototype.navigateDown = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.navigateDown(), Unit) : null;
  };
  Tabulator.prototype.getColumn_61zpoe$ = function (name) {
    var tmp$;
    return (tmp$ = this.jsTabulator) != null ? tmp$.getColumn(name) : null;
  };
  Tabulator.prototype.deleteColumn_61zpoe$ = function (name) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.deleteColumn(name) : null;
  };
  Tabulator.prototype.addColumn_nbzrqa$$default = function (columnDefinition, insertRightOfTarget, positionTarget) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.addColumn(toJs_0(columnDefinition, this, getCallableRef('translate', function ($receiver, p1) {
      return $receiver.translate_61zpoe$(p1);
    }.bind(null, this)), this.kClass), insertRightOfTarget, positionTarget) : null;
  };
  Tabulator.prototype.addColumn_nbzrqa$ = function (columnDefinition, insertRightOfTarget, positionTarget, callback$default) {
    if (insertRightOfTarget === void 0)
      insertRightOfTarget = null;
    if (positionTarget === void 0)
      positionTarget = null;
    callback$default ? callback$default(columnDefinition, insertRightOfTarget, positionTarget) : this.addColumn_nbzrqa$$default(columnDefinition, insertRightOfTarget, positionTarget);
  };
  Tabulator.prototype.addColumn_tjuwae$$default = function (columnDefinition, insertRightOfTarget, positionTarget) {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? tmp$.addColumn(columnDefinition, insertRightOfTarget, positionTarget) : null;
  };
  Tabulator.prototype.addColumn_tjuwae$ = function (columnDefinition, insertRightOfTarget, positionTarget, callback$default) {
    if (insertRightOfTarget === void 0)
      insertRightOfTarget = null;
    if (positionTarget === void 0)
      positionTarget = null;
    callback$default ? callback$default(columnDefinition, insertRightOfTarget, positionTarget) : this.addColumn_tjuwae$$default(columnDefinition, insertRightOfTarget, positionTarget);
  };
  Tabulator.prototype.alert_14qm6v$$default = function (message, style) {
    var tmp$, tmp$_0;
    if (style != null) {
      (tmp$ = this.jsTabulator) != null ? (tmp$.alert(message, style.style_8be2vx$), Unit) : null;
    } else {
      (tmp$_0 = this.jsTabulator) != null ? (tmp$_0.alert(message), Unit) : null;
    }
  };
  Tabulator.prototype.alert_14qm6v$ = function (message, style, callback$default) {
    if (style === void 0)
      style = null;
    callback$default ? callback$default(message, style) : this.alert_14qm6v$$default(message, style);
  };
  Tabulator.prototype.clearAlert = function () {
    var tmp$;
    (tmp$ = this.jsTabulator) != null ? (tmp$.clearAlert(), Unit) : null;
  };
  Tabulator.prototype.removeCustomEditors_8be2vx$ = function () {
    var tmp$, tmp$_0, tmp$_1;
    (tmp$ = EditorRoot_getInstance().cancel_8be2vx$) != null ? tmp$(null) : null;
    if ((tmp$_0 = EditorRoot_getInstance().disposeTimer_8be2vx$) != null) {
      window.clearTimeout(tmp$_0);
    }(tmp$_1 = EditorRoot_getInstance().root_8be2vx$) != null ? (tmp$_1.dispose(), Unit) : null;
    EditorRoot_getInstance().root_8be2vx$ = null;
  };
  Tabulator.prototype.fixData_giv383$ = function (data) {
    var tmp$;
    if (this.kClass != null) {
      var tmp$_0;
      if (data != null) {
        var destination = ArrayList_init(collectionSizeOrDefault(data, 10));
        var tmp$_1;
        tmp$_1 = data.iterator();
        while (tmp$_1.hasNext()) {
          var item = tmp$_1.next();
          destination.add_11rb$(this.toKotlinObjTabulator_azo0g3$(item, this.kClass));
        }
        tmp$_0 = destination;
      } else
        tmp$_0 = null;
      tmp$ = tmp$_0;
    } else {
      tmp$ = data;
    }
    return tmp$;
  };
  Tabulator.prototype.fixData_za3rmp$ = function (data) {
    var tmp$;
    if (this.kClass != null) {
      tmp$ = this.toKotlinObjTabulator_azo0g3$(data, this.kClass);
    } else {
      tmp$ = data;
    }
    return tmp$;
  };
  Tabulator.prototype.toKotlinObjTabulator_azo0g3$ = function (data, kClass) {
    var tmp$;
    if (data._children != null) {
      var $receiver = data._children;
      var destination = ArrayList_init($receiver.length);
      var tmp$_0;
      for (tmp$_0 = 0; tmp$_0 !== $receiver.length; ++tmp$_0) {
        var item = $receiver[tmp$_0];
        destination.add_11rb$(this.toKotlinObjTabulator_azo0g3$(item, kClass));
      }
      data._children = copyToArray(destination);
    }if (this.jsonHelper == null || this.serializer == null) {
      tmp$ = toKotlinObj(data, kClass);
    } else {
      tmp$ = ensureNotNull(this.jsonHelper).decodeFromString_awif5v$(this.serializer, JSON.stringify(data));
    }
    return tmp$;
  };
  Tabulator.prototype.toPlainObjTabulator_myks26$ = function (data) {
    var tmp$;
    if (this.jsonHelper == null || this.serializer == null) {
      tmp$ = toPlainObj(data);
    } else {
      tmp$ = JSON.parse(ensureNotNull(this.jsonHelper).encodeToString_tf03ej$(this.serializer, data));
    }
    var obj = tmp$;
    if (obj._children != null) {
      var $receiver = obj._children;
      var destination = ArrayList_init($receiver.length);
      var tmp$_0;
      for (tmp$_0 = 0; tmp$_0 !== $receiver.length; ++tmp$_0) {
        var item = $receiver[tmp$_0];
        destination.add_11rb$(this.toPlainObjTabulator_myks26$(item));
      }
      obj._children = copyToArray(destination);
    }return obj;
  };
  Tabulator.prototype.addCustomRoot_bbcr7y$ = function (root) {
    this.customRoots_1mxic5$_0.add_11rb$(root);
  };
  Tabulator.prototype.dispose = function () {
    var tmp$, tmp$_0;
    (tmp$ = this.unsubscribe_aoulac$_0) != null ? tmp$() : null;
    (tmp$_0 = this.jsTabulator) != null ? (tmp$_0.destroy(), Unit) : null;
    var tmp$_1;
    tmp$_1 = this.customRoots_1mxic5$_0.iterator();
    while (tmp$_1.hasNext()) {
      var element = tmp$_1.next();
      element.dispose();
    }
    this.customRoots_1mxic5$_0.clear();
    this.jsTabulator = null;
    Widget.prototype.dispose.call(this);
  };
  function Tabulator$Companion() {
    Tabulator$Companion_instance = this;
    TabulatorModule_getInstance().initialize();
  }
  Tabulator$Companion.prototype.create_lu3yb0$ = defineInlineFunction('kvision-kvision-tabulator-js-legacy.io.kvision.tabulator.Tabulator.Companion.create_lu3yb0$', wrapFunction(function () {
    var TabulatorOptions_init = _.io.kvision.tabulator.TabulatorOptions;
    var getKClass = Kotlin.getKClass;
    var Tabulator_init = _.io.kvision.tabulator.Tabulator;
    var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
    return function (T_0, isT, data, dataUpdateOnEdit, options, types, className, serializer, serializersModule, init) {
      if (data === void 0)
        data = null;
      if (dataUpdateOnEdit === void 0)
        dataUpdateOnEdit = true;
      if (options === void 0)
        options = new TabulatorOptions_init();
      if (types === void 0) {
        types = emptySet();
      }if (className === void 0)
        className = null;
      if (serializer === void 0)
        serializer = null;
      if (serializersModule === void 0)
        serializersModule = null;
      if (init === void 0)
        init = null;
      var tabulator = new Tabulator_init(data, dataUpdateOnEdit, options, types, className, getKClass(T_0), serializer, serializersModule);
      init != null ? init(tabulator) : null;
      return tabulator;
    };
  }));
  Tabulator$Companion.prototype.create_3jpqpy$ = defineInlineFunction('kvision-kvision-tabulator-js-legacy.io.kvision.tabulator.Tabulator.Companion.create_3jpqpy$', wrapFunction(function () {
    var TabulatorOptions_init = _.io.kvision.tabulator.TabulatorOptions;
    var getKClass = Kotlin.getKClass;
    var Tabulator_init = _.io.kvision.tabulator.Tabulator;
    var Unit = Kotlin.kotlin.Unit;
    var wrapFunction = Kotlin.wrapFunction;
    var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
    var Tabulator$Companion$create$lambda = wrapFunction(function () {
      var copyToArray = Kotlin.kotlin.collections.copyToArray;
      return function (closure$tabulator, closure$dataFactory) {
        return function (s) {
          closure$tabulator.replaceData_3i86gf$(copyToArray(closure$dataFactory(s)));
          return Unit;
        };
      };
    });
    return function (T_0, isT, store, dataFactory, options, types, className, serializer, serializersModule, init) {
      if (options === void 0)
        options = new TabulatorOptions_init();
      if (types === void 0) {
        types = emptySet();
      }if (className === void 0)
        className = null;
      if (serializer === void 0)
        serializer = null;
      if (serializersModule === void 0)
        serializersModule = null;
      if (init === void 0)
        init = null;
      var data = dataFactory(store.getState());
      var tabulator = new Tabulator_init(data, false, options, types, className, getKClass(T_0), serializer, serializersModule);
      init != null ? init(tabulator) : null;
      tabulator.addBeforeDisposeHook_o14v8n$(store.subscribe_qlkmfe$(Tabulator$Companion$create$lambda(tabulator, dataFactory)));
      return tabulator;
    };
  }));
  Tabulator$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Tabulator$Companion_instance = null;
  function Tabulator$Companion_getInstance() {
    if (Tabulator$Companion_instance === null) {
      new Tabulator$Companion();
    }return Tabulator$Companion_instance;
  }
  function Tabulator$jsonHelper$lambda($receiver) {
    $receiver.ignoreUnknownKeys = true;
    $receiver.isLenient = true;
    return Unit;
  }
  function Tabulator$jsonHelper$lambda_0(this$Tabulator) {
    return function ($receiver) {
      var builder = new SerializersModuleBuilder_init();
      var this$Tabulator_0 = this$Tabulator;
      var tmp$;
      builder.contextual_cfhkba$(getKClass(Date), types.DateSerializer);
      if ((tmp$ = this$Tabulator_0.module) != null) {
        builder.include_4jix7z$(tmp$);
      }$receiver.serializersModule = overwriteWith(builder.build(), $receiver.serializersModule);
      return Unit;
    };
  }
  function Tabulator_init$lambda(this$Tabulator) {
    return function (it) {
      this$Tabulator.replaceData_3i86gf$(copyToArray(this$Tabulator.data));
      return Unit;
    };
  }
  Tabulator.$metadata$ = {kind: Kind_CLASS, simpleName: 'Tabulator', interfaces: [Widget]};
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'TabulatorModule', {get: TabulatorModule_getInstance});
  var package$tabulator = package$kvision.tabulator || (package$kvision.tabulator = {});
  Object.defineProperty(Formatter, 'PLAINTEXT', {get: Formatter$PLAINTEXT_getInstance});
  Object.defineProperty(Formatter, 'TEXTAREA', {get: Formatter$TEXTAREA_getInstance});
  Object.defineProperty(Formatter, 'HTML', {get: Formatter$HTML_getInstance});
  Object.defineProperty(Formatter, 'MONEY', {get: Formatter$MONEY_getInstance});
  Object.defineProperty(Formatter, 'IMAGE', {get: Formatter$IMAGE_getInstance});
  Object.defineProperty(Formatter, 'LINK', {get: Formatter$LINK_getInstance});
  Object.defineProperty(Formatter, 'DATETIME', {get: Formatter$DATETIME_getInstance});
  Object.defineProperty(Formatter, 'DATETIMEDIFF', {get: Formatter$DATETIMEDIFF_getInstance});
  Object.defineProperty(Formatter, 'TICKCROSS', {get: Formatter$TICKCROSS_getInstance});
  Object.defineProperty(Formatter, 'COLOR', {get: Formatter$COLOR_getInstance});
  Object.defineProperty(Formatter, 'STAR', {get: Formatter$STAR_getInstance});
  Object.defineProperty(Formatter, 'TRAFFIC', {get: Formatter$TRAFFIC_getInstance});
  Object.defineProperty(Formatter, 'PROGRESS', {get: Formatter$PROGRESS_getInstance});
  Object.defineProperty(Formatter, 'LOOKUP', {get: Formatter$LOOKUP_getInstance});
  Object.defineProperty(Formatter, 'BUTTONTICK', {get: Formatter$BUTTONTICK_getInstance});
  Object.defineProperty(Formatter, 'BUTTONCROSS', {get: Formatter$BUTTONCROSS_getInstance});
  Object.defineProperty(Formatter, 'ROWNUM', {get: Formatter$ROWNUM_getInstance});
  Object.defineProperty(Formatter, 'HANDLE', {get: Formatter$HANDLE_getInstance});
  Object.defineProperty(Formatter, 'ROWSELECTION', {get: Formatter$ROWSELECTION_getInstance});
  Object.defineProperty(Formatter, 'RESPONSIVECOLLAPSE', {get: Formatter$RESPONSIVECOLLAPSE_getInstance});
  package$tabulator.Formatter = Formatter;
  Object.defineProperty(Layout, 'FITDATA', {get: Layout$FITDATA_getInstance});
  Object.defineProperty(Layout, 'FITDATAFILL', {get: Layout$FITDATAFILL_getInstance});
  Object.defineProperty(Layout, 'FITCOLUMNS', {get: Layout$FITCOLUMNS_getInstance});
  Object.defineProperty(Layout, 'FITDATASTRETCH', {get: Layout$FITDATASTRETCH_getInstance});
  Object.defineProperty(Layout, 'FITDATATABLE', {get: Layout$FITDATATABLE_getInstance});
  package$tabulator.Layout = Layout;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  package$tabulator.toJs_9os6om$ = toJs;
  package$tabulator.ColumnDefinition = ColumnDefinition;
  Object.defineProperty(package$tabulator, 'EditorRoot', {get: EditorRoot_getInstance});
  package$tabulator.toJs_2uklv$ = toJs_0;
  package$tabulator.TabulatorOptions = TabulatorOptions;
  package$tabulator.toJs_351r7k$ = toJs_1;
  Object.defineProperty(TableType, 'STRIPED', {get: TableType$STRIPED_getInstance});
  Object.defineProperty(TableType, 'BORDERED', {get: TableType$BORDERED_getInstance});
  Object.defineProperty(TableType, 'BORDERLESS', {get: TableType$BORDERLESS_getInstance});
  Object.defineProperty(TableType, 'HOVER', {get: TableType$HOVER_getInstance});
  Object.defineProperty(TableType, 'SMALL', {get: TableType$SMALL_getInstance});
  package$tabulator.TableType = TableType;
  Object.defineProperty(RowRangeLookup, 'ALL', {get: RowRangeLookup$ALL_getInstance});
  Object.defineProperty(RowRangeLookup, 'VISIBLE', {get: RowRangeLookup$VISIBLE_getInstance});
  Object.defineProperty(RowRangeLookup, 'SELECTED', {get: RowRangeLookup$SELECTED_getInstance});
  Object.defineProperty(RowRangeLookup, 'ACTIVE', {get: RowRangeLookup$ACTIVE_getInstance});
  package$tabulator.RowRangeLookup = RowRangeLookup;
  Object.defineProperty(Tabulator, 'Companion', {get: Tabulator$Companion_getInstance});
  $$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy;
  package$tabulator.Tabulator = Tabulator;
  return _;
}));

//# sourceMappingURL=kvision-kvision-tabulator-js-legacy.js.map
